{
  "products.title": "Groupes",
  "products.allGroups": "Tous les groupes",
  "products.new": "Nouveau groupe",
  "products.search": "Rechercher un groupe…",
  "products.missionCount_one": "{{count}} mission",
  "products.missionCount_other": "{{count}} missions",
  "products.unassigned": "Sans groupe",
  "products.noMatch": "Aucun groupe ne correspond.",
  "products.noMissions": "Aucune mission dans ce groupe pour l'instant.",
  "products.settings": "Paramètres",
  "products.col.backlog": "Backlog",
  "products.col.done": "Terminé",
  "products.col.dropped": "Abandonné",
  "products.boardHint": "Où en est chaque mission — lecture seule.",
  "products.board.expandAll": "Déplier toutes les colonnes",
  "products.board.collapseAll": "Replier toutes les colonnes",
  "products.board.perColumn": "{{count}} par colonne",
  "products.board.more": "+{{count}} de plus",
  "products.createTitle": "Nouveau groupe",
  "products.nameLabel": "Nom",
  "products.namePlaceholder": "ex. v1 — Rattraper le marché",
  "products.colorLabel": "Couleur",
  "products.create": "Créer",
  "filter.basic": "Basic",
  "filter.run": "Lancer",
  "filter.clear": "Tout effacer",
  "filter.saveAs": "Sauver",
  "filter.views": "Vues",
  "filter.noViews": "Aucune vue sauvegardée.",
  "filter.savePrompt": "Nommer cette vue",
  "filter.saved": "Vue sauvegardée",
  "nav.label": "Navigation de l'office",
  "nav.home": "Tableau de bord",
  "nav.dashboard": "Tableau de bord",
  "nav.goals": "Objectifs",
  "nav.routines": "Routines",
  "nav.wiki": "Wiki",
  "nav.org": "Organigramme",
  "nav.settings": "Paramètres",
  "nav.newMission": "Nouvelle mission",
  "nav.newProject": "Nouveau projet",
  "nav.sections.work": "Travail",
  "nav.sections.projects": "Projets",
  "nav.sections.agents": "Agents",
  "nav.sections.office": "Office",
  "nav.sections.agency": "Office",
  "nav.reporting": "Reporting",
  "nav.schedule": "Planning",
  "nav.audit": "Audit agents",
  "nav.guild": "Guilde",
  "nav.skills": "Rôles",
  "nav.billing": "Facturation",
  "nav.admin": "Admin",
  "nav.processes": "Processus",
  "roles.title": "Rôles",
  "roles.subtitle": "Chaque poste du catalogue des studios, groupé par studio — n'importe quel champion peut l'endosser.",
  "roles.allStudios": "Tous les studios",
  "roles.add": "Ajouter",
  "roles.added": "Ajouté",
  "roles.championAffinity": "champion affin : {{name}}",
  "roles.empty": "Aucun rôle pour ce studio.",
  "roles.slots": "/ {{count}} postes",
  "processes.title": "Processus",
  "processes.subtitle": "Les briques réutilisables que ton équipe applique aux missions.",
  "processes.catalogBlueprints.title": "Blueprints",
  "processes.catalogBlueprints.description": "Les processus métier de l'office : des standards connus (OKR, BDD, C4, TDD, funnel audit…) appliqués tels quels, chacun avec sa squad, ses étapes et ses garde-fous. Une mission peut personnaliser le sien dans son onglet Process.",
  "processes.skills.title": "Skills",
  "processes.skills.description": "Les savoir-faire propres à l'office, par type de tâche (nouvelle feature, bug, endpoint, revue…) : une squad, des étapes et des garde-fous. Contrairement aux blueprints, qui sont des standards connus, une skill est faite pour évoluer avec l'office.",
  "processes.skill.edit": "Modifier la skill",
  "processes.skill.edited": "Édité",
  "processes.skill.editedTitle": "Édition de l'office v{{version}}",
  "processes.skill.readOnlyProcess": "Standard connu — lecture seule",
  "processes.skill.readOnlyMember": "Seul le POC de l'office peut modifier cette skill",
  "processes.skill.save": "Enregistrer une nouvelle version",
  "processes.skill.cancel": "Annuler",
  "processes.skill.note": "Note de version (facultatif)",
  "processes.skill.saved": "Version {{version}} enregistrée",
  "processes.skill.unchanged": "Aucune modification — version inchangée",
  "processes.skill.saveError": "Impossible d'enregistrer la skill",
  "processes.skill.conflict": "Une autre version a été enregistrée entre-temps — rechargée",
  "processes.skill.reset": "Revenir à la version du plugin",
  "processes.skill.resetConfirm": "Revenir à la version du plugin ? Une nouvelle version est créée ; les missions en cours gardent la leur.",
  "processes.skill.futureMissions": "S'applique aux missions qui choisiront cette skill ensuite (Camille et la squad du Studio) ; les missions en cours gardent leur version. Les builds GitHub l'appliqueront avec la mission platform-composed-agents.",
  "processes.skill.diff": "Écart avec le canonique",
  "processes.skill.diffCanonical": "Catalogue",
  "processes.skill.diffOffice": "Votre édition",
  "processes.skill.drift": "Le canonique a changé depuis cette édition",
  "processes.skill.versions": "Historique des versions",
  "processes.skill.versionReset": "Retour à la version du plugin",
  "processes.skill.add": "Ajouter",
  "processes.skill.remove": "Retirer",
  "processes.skill.field.phases": "Étapes",
  "processes.skill.field.required_roles": "Rôles requis",
  "processes.skill.field.optional_roles": "Rôles optionnels",
  "processes.skill.field.role_guidance": "Règles de travail par rôle",
  "processes.skill.field.notes": "Notes",
  "processes.skill.field.abort_conditions": "Conditions d'arrêt",
  "processes.skill.phase.name": "Nom de l'étape",
  "processes.skill.phase.owner": "Rôle responsable",
  "processes.skill.phase.gate": "Gate",
  "processes.skill.phase.artifact": "Artefact",
  "processes.skill.activateWhen": "Quand l'activer",
  "processes.skill.triggers": "Règles",
  "processes.skill.skills": "Compétences",
  "processes.skill.moveUp": "Monter",
  "processes.skill.moveDown": "Descendre",
  "processes.filter.vertical": "Vertical",
  "processes.filter.problem": "Problème",
  "processes.filter.role": "Rôle",
  "processes.filter.champion": "Champion",
  "processes.filter.all": "Tous",
  "processes.filter.clear": "Effacer les filtres",
  "processes.filter.empty": "Aucun résultat pour ces filtres.",
  "processes.filter.otherProblem": "Autres",
  "processes.filter.byRole": "Voir les blueprints avec le rôle {{name}}",
  "processes.filter.byChampion": "Voir les blueprints où {{name}} peut intervenir",
  "processes.vertical.engineering": "Ingénierie",
  "processes.vertical.product": "Produit",
  "processes.vertical.marketing": "Marketing",
  "processes.vertical.sales": "Ventes",
  "processes.vertical.strategy": "Stratégie",
  "processes.vertical.project-management": "Gestion de projet",
  "processes.vertical.operations": "Opérations",
  "processes.vertical.ecommerce": "E-commerce",
  "processes.vertical.social-media": "Réseaux sociaux",
  "processes.vertical.finance": "Finance",
  "processes.vertical.real-estate": "Immobilier",
  "processes.vertical.testing": "Tests",
  "processes.vertical.design": "Design",
  "processes.vertical.support": "Support",
  "processes.vertical.knowledge": "Connaissance",
  "processes.vertical.compliance": "Conformité",
  "processes.vertical.other": "Autres",
  "processes.bp.open": "Voir le détail →",
  "processes.bp.what": "Quoi",
  "processes.bp.whatQ": "ce que la mission produit",
  "processes.bp.why": "Pourquoi",
  "processes.bp.whyQ": "la raison d'être de ce processus",
  "processes.bp.whyNone": "Le blueprint ne détaille pas sa justification au-delà de sa description.",
  "processes.bp.when": "Quand",
  "processes.bp.whenQ": "dans quelles situations l'utiliser",
  "processes.bp.who": "Qui",
  "processes.bp.whoQ": "les rôles de la squad et les Champions qui les tiennent",
  "processes.bp.whoIntro": "Chaque rôle est tenu par un agent composé : un Champion (personnalité, style de travail) × le rôle (responsabilités, livrable). Les Champions listés sont ceux qui conviennent le mieux à ce rôle sur ce blueprint, du plus adapté au repli.",
  "processes.bp.how": "Comment",
  "processes.bp.howQ": "le déroulé, les règles et l'effort",
  "processes.bp.deliverables": "Livrables",
  "processes.bp.disciplines": "Disciplines imposées",
  "processes.bp.situations": "Situations typiques",
  "processes.bp.keywords": "Mots qui le déclenchent",
  "processes.bp.stopWhen": "La mission s'arrête si",
  "processes.bp.required": "Requis",
  "processes.bp.optional": "Optionnel",
  "processes.bp.joinsWhen": "Rejoint la squad si :",
  "processes.bp.champions": "Champions :",
  "processes.bp.leads": "Pilote :",
  "processes.bp.phaseOwner": "Piloté par",
  "processes.bp.phaseArtifact": "Produit",
  "processes.bp.phaseGate": "Arrêt si :",
  "processes.bp.steps": "Étapes",
  "processes.bp.defaultFlowIntro": "Pas de phases spécifiques : la squad suit le flux standard d'une mission, chaque étape validée par une gate.",
  "processes.bp.flow.spec": "Spec (architecte, G4)",
  "processes.bp.flow.implement": "Implémentation (G5)",
  "processes.bp.flow.test": "Tests (G6)",
  "processes.bp.flow.review": "Review (G7)",
  "processes.bp.flow.retro": "Rétro",
  "processes.bp.methodology": "Méthodologie appliquée :",
  "processes.bp.roleRules": "Règles de travail par rôle",
  "processes.bp.notes": "Notes",
  "processes.bp.tools": "Outils (MCP) suggérés :",
  "processes.bp.budget": "Effort estimé : ~{{duration}}, {{iterations}} itérations, {{tokens}} tokens au maximum.",
  "processes.bp.cadence": "Cadence :",
  "processes.bp.horizon.today": "Aujourd'hui",
  "processes.bp.horizon.this_week": "Cette semaine",
  "processes.bp.horizon.this_sprint": "Ce sprint",
  "processes.bp.horizon.this_quarter": "Ce trimestre",
  "processes.bp.horizon.this_year": "Cette année",
  "processes.bp.cadenceValue.annual": "annuelle",
  "processes.bp.cadenceValue.monthly": "mensuelle",
  "processes.bp.cadenceValue.quarterly": "trimestrielle",
  "processes.bp.cadenceValue.per_sprint": "à chaque sprint",
  "processes.bp.cadenceValue.monthly_or_six_week": "mensuelle ou toutes les 6 semaines",
  "processes.bp.shape.micro": "Micro",
  "processes.bp.shape.lite": "Léger",
  "processes.bp.shape.standard": "Standard",
  "processes.bp.shape.heavy": "Renforcé",
  "processes.bp.shape.orchestration": "Orchestration",
  "processes.bp.shapeDesc.micro": "un seul agent, un mini-brief, pas de gates : pour une tâche de quelques minutes.",
  "processes.bp.shapeDesc.lite": "un binôme implémenteur + reviewer, un mini-brief, sans questions de cadrage.",
  "processes.bp.shapeDesc.standard": "le parcours complet : cadrage (intent, brief, stories), squad complète, gates G1 à G7.",
  "processes.bp.shapeDesc.heavy": "le parcours complet plus un pre-mortem obligatoire, un security-reviewer ajouté, un budget resserré et une seconde passe de review forcée.",
  "processes.bp.shapeDesc.orchestration": "découpe l'intention en un projet de plusieurs missions enfants, chacune avec son propre parcours.",
  "processes.blueprints.title": "Méthodologies",
  "processes.blueprints.description": "Les méthodologies que l'équipe applique ; chaque blueprint en suit une.",
  "processes.templates.title": "Portes d'entrée",
  "processes.templates.description": "Les portes d'entrée qui amorcent une nouvelle mission, par nature.",
  "nav.accountSettings": "Paramètres",
  "nav.loadError": "Erreur de chargement.",
  "office.switcher.label": "Changer d'office",
  "office.notFound": "Office introuvable ou accès refusé.",
  "userMenu.label": "Menu utilisateur",
  "userMenu.theme.label": "Thème",
  "userMenu.theme.light": "Clair",
  "userMenu.theme.dark": "Sombre",
  "userMenu.theme.auto": "Auto",
  "userMenu.editProfile": "Modifier le profil",
  "pocOnly": "Réservé au POC de l'office.",
  "form.create": "Créer",
  "form.save": "Enregistrer",
  "form.cancel": "Annuler",
  "form.submitting": "Envoi…",
  "form.required": "Champ requis.",
  "form.name": "Nom",
  "form.slug": "Slug",
  "form.slug.hint": "kebab-case : minuscules, chiffres, tirets.",
  "form.slug.invalid": "Slug invalide (kebab-case attendu).",
  "form.description": "Description (optionnel)",
  "onboarding.title": "Bienvenue",
  "onboarding.intro": "Créez votre agence puis son premier office pour démarrer.",
  "onboarding.agency.title": "1. Créer l'agence",
  "onboarding.agency.created": "Agence créée.",
  "onboarding.office.title": "2. Créer le premier office",
  "dashboard.title": "Tableau de bord",
  "dashboard.metrics.activeAgents": "Agents actifs",
  "dashboard.metrics.executingMissions": "Missions en cours",
  "dashboard.metrics.pendingSignoffs": "Signoffs en attente",
  "dashboard.agentsAtWork": "Agents au travail",
  "dashboard.noAgents": "Aucun agent embauché pour l'instant.",
  "dashboard.noActivity": "Aucune activité en cours",
  "agent.status.idle": "Inactif",
  "agent.status.working": "En activité",
  "agent.status.waiting": "En attente",
  "agent.status.offline": "Hors ligne",
  "agent.tabs.label": "Sections de l'agent",
  "agent.tabs.overview": "Aperçu",
  "agent.tabs.activity": "Activité",
  "agent.overview.status": "Statut",
  "agent.overview.currentStory": "Story en cours",
  "agent.overview.currentActivity": "Activité en cours",
  "agent.overview.supervisor": "Superviseur",
  "agent.overview.runtimeTier": "Runtime",
  "agent.overview.hiredAt": "Embauché le",
  "agent.overview.none": "—",
  "agent.activity.empty": "Aucune activité enregistrée.",
  "agent.notFound": "Agent introuvable.",
  "projects.new": "Nouveau projet",
  "projects.created": "Projet créé.",
  "projects.empty": "Aucun projet. Créez le premier.",
  "projects.statusUpdated": "Statut du projet mis à jour.",
  "projects.archive": "Archiver",
  "projects.unarchive": "Réactiver",
  "projects.filter.label": "Filtrer les projets",
  "projects.filter.active": "Actifs",
  "projects.filter.archived": "Archivés",
  "project.notFound": "Projet introuvable.",
  "project.tabs.label": "Sections du projet",
  "project.tabs.board": "Board",
  "project.tabs.missions": "Missions",
  "project.tabs.wiki": "Wiki",
  "board.label": "Board kanban",
  "board.newStory": "Nouvelle story",
  "board.storyCreated": "Story créée.",
  "board.moveFailed": "Le déplacement de la story a échoué.",
  "board.story.title": "Titre",
  "board.story.mission": "Mission",
  "board.story.missionPlaceholder": "Choisir une mission…",
  "board.story.acceptance": "Critères d'acceptation (BDD)",
  "board.column.backlog": "Backlog",
  "board.column.planned": "Façonné",
  "board.column.in_progress": "En cours",
  "board.column.blocked": "Bloqué",
  "board.column.in_review": "En revue",
  "board.column.done": "Terminé",
  "board.column.cancelled": "Annulé",
  "board.column.icebox": "Icebox",
  "board.column.brainstorming": "Exploration",
  "board.column.shaping": "Cadrage",
  "board.column.building": "Construction",
  "board.column.validating": "Validation",
  "board.column.operating": "Exploitation",
  "board.column.shipped": "Livré",
  "board.column.archived": "Archivé",
  "missions.new": "Nouvelle mission",
  "missions.created": "Mission créée.",
  "missions.empty": "Aucune mission dans ce projet.",
  "missions.cronInvalid": "Expression cron à 5 champs requise.",
  "missions.type.goal": "Goal",
  "missions.type.routine": "Routine",
  "missions.form.title": "Titre",
  "missions.form.type": "Type",
  "missions.form.cron": "Expression cron (5 champs)",
  "missions.form.project": "Projet",
  "missions.form.projectPlaceholder": "Choisir un projet…",
  "missions.form.process": "Processus d'exécution",
  "missions.process.sequential": "Séquentiel",
  "missions.process.hierarchical": "Hiérarchique",
  "goals.empty": "Aucune mission goal pour l'instant.",
  "routines.empty": "Aucune routine pour l'instant.",
  "mission.notFound": "Mission introuvable.",
  "mission.artifacts.title": "Artefacts",
  "mission.artifacts.empty": "Les artefacts apparaîtront ici dès que les agents produiront des livrables.",
  "mission.artifacts.version": "v{{n}}",
  "mission.artifacts.phase": "{{phase}}",
  "mission.artifacts.author": "Par {{name}}",
  "mission.artifacts.download": "Télécharger {{name}}",
  "mission.artifacts.preview": "Aperçu de {{name}}",
  "mission.artifacts.cadrage": "Cadrage",
  "mission.files.title": "Fichiers de mission",
  "mission.files.empty": "Aucun fichier pour l'instant.",
  "mission.files.selectFile": "Sélectionnez un fichier pour l'afficher.",
  "mission.files.source.github": "GitHub",
  "mission.files.source.studio": "Studio",
  "mission.files.status.stored": "Enregistré",
  "mission.files.status.deleted": "Supprimé",
  "mission.files.status.oversize": "Trop volumineux",
  "mission.files.status.binary": "Binaire",
  "mission.files.revision": "v{{n}}",
  "mission.files.readOnly": "Lecture seule — miroir de GitHub.",
  "mission.files.openOnGithub": "Ouvrir sur GitHub",
  "mission.files.editorLabel": "Modifier {{path}}",
  "mission.files.save": "Enregistrer",
  "mission.files.saving": "Enregistrement…",
  "mission.files.saveError": "Échec de l'enregistrement. Réessayez.",
  "mission.files.stale": "Ce fichier a changé depuis son ouverture.",
  "mission.files.reload": "Recharger",
  "mission.files.history": "Historique",
  "mission.files.diffFrom": "De",
  "mission.files.diffTo": "À",
  "mission.files.showDiff": "Afficher le diff",
  "mission.files.diffTooLarge": "Trop volumineux pour un diff.",
  "mission.artifactViewer.pending": "Pas encore produit.",
  "mission.artifactViewer.openPdf": "Ouvrir le PDF",
  "mission.artifactViewer.download": "Télécharger",
  "mission.process.view.flow": "Flux",
  "mission.process.officeEdition": "Édition de l'office v{{version}}",
  "mission.process.view.list": "Liste",
  "mission.process.mode.plan": "Plan",
  "mission.process.mode.progression": "Progression",
  "mission.process.legend.advance": "Avance / passe",
  "mission.process.legend.failBranch": "Branche d'échec (halt · re-décompose · escalade)",
  "mission.process.legend.gate": "Gate de décision",
  "mission.process.legend.done": "Terminé",
  "mission.process.legend.current": "En cours",
  "mission.process.legend.upcoming": "À venir",
  "mission.process.artifact.open": "Ouvrir {{name}}",
  "mission.process.throughline.title": "Process",
  "mission.process.status.done": "Terminé",
  "mission.process.status.current": "En cours",
  "mission.process.status.upcoming": "À venir",
  "mission.process.upcoming": "À venir",
  "mission.process.methodologyLabel": "Méthodologie",
  "mission.process.step.kind.step": "Étape",
  "mission.process.step.kind.checkpoint": "Jalon",
  "mission.process.step.kind.gate": "Gate",
  "mission.process.noMethodology": "Aucune méthodologie choisie",
  "mission.process.customizeBlueprint": "Personnaliser ce blueprint",
  "mission.process.expandPhase": "Déplier {{phase}}",
  "mission.process.collapsePhase": "Replier {{phase}}",
  "mission.process.stepsProgress": "{{done}} / {{total}} étapes réalisées",
  "mission.process.stepState.done": "Fait",
  "mission.process.stepState.todo": "À faire",
  "mission.process.stepState.skipped": "Sauté — non réalisé",
  "mission.process.evidence.file": "Preuve : {{ref}}",
  "mission.process.evidence.record": "Preuve : {{ref}}",
  "mission.process.evidence.signoff": "Gate approuvé par {{name}}",
  "mission.process.decision.approved": "Approuvé par {{name}} · {{date}}",
  "mission.process.decision.rejected": "Renvoyé par {{name}} · {{date}}",
  "mission.process.role.unassigned": "Non assigné",
  "mission.process.role.claude-main": "Claude (orchestrateur)",
  "mission.process.role.architect": "Architecte",
  "mission.process.role.implementer": "Implémenteur",
  "mission.process.role.implementers": "Implémenteurs",
  "mission.process.role.tester": "Testeur",
  "mission.process.role.reviewer": "Reviewer",
  "mission.process.role.analyst": "Analyste",
  "mission.process.role.backend-engineer": "Ingénieur backend",
  "mission.process.role.frontend-engineer": "Ingénieur frontend",
  "mission.process.role.debugger": "Débogueur",
  "mission.process.role.depends-on-hotspot": "Selon le point chaud",
  "mission.process.role.devops-engineer": "Ingénieur DevOps",
  "mission.process.role.doc-writer": "Rédacteur doc",
  "mission.process.role.docs-architect": "Architecte doc",
  "mission.process.role.migration-engineer": "Ingénieur migration",
  "mission.process.role.performance-engineer": "Ingénieur performance",
  "mission.process.role.researcher": "Chercheur",
  "mission.process.role.shaper": "Shaper",
  "mission.process.role.tech-writer": "Rédacteur technique",
  "mission.process.role.tutorial-engineer": "Ingénieur tutoriel",
  "mission.status.proposal": "Proposition",
  "mission.status.clarification": "Clarification",
  "mission.status.methodology": "Méthodologie",
  "mission.status.planning": "Planification",
  "mission.status.awaiting_signoff": "Signoff",
  "mission.status.executing": "Exécution",
  "mission.status.review": "Revue",
  "mission.status.done": "Terminée",
  "mission.status.paused": "En pause",
  "mission.status.archived": "Archivée",
  "mission.stepper.label": "Cycle de vie de la mission",
  "mission.stepper.manualHint": "Pilotage manuel (Phase 1) — cliquer une phase pour y faire passer la mission.",
  "mission.stepper.goTo": "Passer à « {{phase}} »",
  "mission.journey.label": "Parcours de la mission",
  "mission.journey.processLabel": "Voir le process",
  "mission.journey.openProcess": "Voir le process",
  "mission.journey.forked": "Process forké",
  "mission.journey.closePopover": "Fermer le détail de l'étape",
  "mission.journey.gatePending": "Signoff en attente — aller à la gate",
  "mission.journey.gateApproved": "Gate approuvée",
  "mission.journey.gateLocked": "Gate verrouillée",
  "mission.journey.gateLine": "{{label}} — {{state}}",
  "mission.journey.gateState.approved": "approuvée",
  "mission.journey.gateState.pending": "en attente de signoff",
  "mission.journey.gateState.locked": "verrouillée",
  "mission.journey.status.done": "Terminé",
  "mission.journey.status.current": "En cours",
  "mission.journey.status.future": "À venir",
  "mission.journey.history.empty": "Aucune décision pour le moment.",
  "mission.journey.mark.pass": "Gate validée",
  "mission.journey.mark.bypassed": "Gate validée avec bypass",
  "mission.journey.mark.fail": "Gate refusée",
  "mission.journey.mark.defer": "Gate en attente — preuves manquantes, aller à la gate",
  "mission.journey.tooltip.proven": "{{n}}/{{m}} critères prouvés",
  "mission.journey.tooltip.bypass": "Bypass : {{reason}}",
  "mission.lifecycle.note.done": "Étape franchie et validée.",
  "mission.lifecycle.note.current": "Étape en cours — le travail se concentre ici.",
  "mission.lifecycle.note.planned": "Planifiée — pas encore atteinte.",
  "mission.step.idea.explore": "Explorer",
  "mission.step.idea.validate": "Valider",
  "mission.step.idea.verdict": "Verdict",
  "mission.step.idea.act": "Agir",
  "mission.step.decision.frame": "Cadrer",
  "mission.step.decision.weigh": "Évaluer",
  "mission.step.decision.recommend": "Recommander",
  "mission.step.decision.act": "Agir",
  "mission.step.question.research": "Rechercher",
  "mission.step.question.synthesize": "Synthétiser",
  "mission.step.question.answer": "Réponse",
  "mission.step.question.act": "Agir",
  "mission.step.issue.diagnose": "Diagnostiquer",
  "mission.step.issue.plan": "Planifier",
  "mission.step.issue.implement": "Implémenter",
  "mission.step.issue.test": "Tester",
  "mission.step.issue.release": "Livrer",
  "mission.step.goal.framing": "Cadrage",
  "mission.step.goal.shaping": "Façonnage",
  "mission.step.goal.building": "Construction",
  "mission.step.goal.testing": "Tests",
  "mission.step.goal.releasing": "Livraison",
  "mission.step.concern.framing": "Cadrage",
  "mission.step.concern.shaping": "Façonnage",
  "mission.step.concern.building": "Construction",
  "mission.step.concern.testing": "Tests",
  "mission.step.concern.releasing": "Livraison",
  "mission.step.review.audit": "Auditer",
  "mission.step.review.prioritize": "Prioriser",
  "mission.step.review.verdict": "Verdict",
  "mission.step.monitor.cadrage": "Cadrage",
  "mission.step.monitor.launch": "Lancement",
  "mission.step.monitor.piloting": "Pilotage",
  "mission.step.improve.baseline": "Baseline",
  "mission.step.improve.launch": "Lancement",
  "mission.step.improve.optimizing": "Optimisation",
  "mission.step.maintain.cadrage": "Cadrage",
  "mission.step.maintain.launch": "Lancement",
  "mission.step.maintain.running": "En opération",
  "mission.step.advisory.setup": "Setup",
  "mission.step.advisory.observing": "Observation",
  "mission.clarifications.title": "Clarifications",
  "mission.clarifications.empty": "Aucune question pour l'instant.",
  "mission.clarifications.ask": "Poser une question",
  "mission.clarifications.answer": "Répondre",
  "mission.clarifications.questionPlaceholder": "Votre question…",
  "mission.clarifications.answerPlaceholder": "Votre réponse…",
  "mission.clarifications.round": "Tour {{round}}",
  "mission.methodology.title": "Méthodologie",
  "mission.methodology.current": "Méthodologie actuelle : {{methodology}}",
  "mission.methodology.none": "Aucune méthodologie choisie.",
  "mission.methodology.placeholder": "ex. bdd-stories",
  "mission.methodology.apply": "Définir",
  "mission.methodology.suggestions": "Suggestions",
  "mission.signoffs.title": "Signoffs",
  "mission.signoffs.empty": "Aucun signoff demandé.",
  "mission.signoffs.request.plan": "Demander un signoff plan",
  "mission.signoffs.request.verdict": "Demander un signoff verdict",
  "mission.signoffs.pending": "Signoff {{kind}} en attente de décision",
  "mission.signoffs.kind.plan": "plan",
  "mission.signoffs.kind.verdict": "verdict",
  "mission.signoffs.kind.data_write": "accès en écriture",
  "mission.signoffs.approve": "Approuver",
  "mission.signoffs.reject": "Rejeter",
  "mission.signoffs.approved": "Approuvé",
  "mission.signoffs.rejected": "Rejeté",
  "mission.signoffs.comment": "Commentaire",
  "mission.signoffs.commentPlaceholder": "Commentaire (optionnel)",
  "mission.signoffs.waitPoc": "En attente de la décision du POC.",
  "mission.gate.blueprint": "Blueprint : {{name}}",
  "mission.gate.methodology": "Méthodo : {{name}}",
  "mission.gate.pending": "Gate : {{label}}",
  "mission.gate.approve": "Approuver",
  "mission.gate.sendBack": "Renvoyer",
  "mission.gate.pocOnly": "Réservé au POC de l'office.",
  "mission.gate.title": "Gate — {{label}}",
  "mission.gate.required": "signoff requis",
  "mission.gate.approvedBy": "Approuvé par {{name}} · {{date}}",
  "mission.gate.rejectedBy": "Renvoyé par {{name}} · {{date}}",
  "mission.gate.dataWrite.summary": "Autoriser les agents de cette mission à ÉCRIRE dans {{source}} (création / modification / envoi). La lecture reste inchangée.",
  "mission.gate.ledger.title": "Critères de la phase",
  "mission.gate.ledger.proven": "{{n}}/{{m}} prouvés",
  "mission.gate.ledger.missingTag": "Manquant",
  "mission.gate.ledger.missingList": "Preuves manquantes : {{codes}}",
  "mission.gate.ledger.bypassLabel": "Raison du bypass",
  "mission.gate.ledger.bypassHint": "Obligatoire pour approuver malgré des preuves manquantes.",
  "mission.gate.ledger.bypassCounter": "{{count}}/{{max}}",
  "mission.gate.ledger.approveWithBypass": "Approuver avec bypass",
  "mission.gate.ledger.receiptProven": "{{verified}}/{{total}} prouvés au moment de la décision",
  "mission.gate.ledger.receiptBypass": "Bypass : {{reason}}",
  "mission.gate.ledger.bypassTag": "Bypass",
  "mission.gate.plan.squadTitle": "Équipe",
  "mission.gate.plan.viewOnGithub": "Voir sur GitHub",
  "mission.github.issue": "Issue de la mission sur GitHub",
  "mission.github.issueN": "Issue #{{n}} sur GitHub",
  "mission.github.stories": "Stories sur GitHub",
  "mission.github.storyIssue": "Issue",
  "mission.github.storyPr": "PR #{{n}}",
  "mission.gate.plan.role": "Rôle",
  "mission.gate.plan.champion": "Champion",
  "mission.gate.plan.model": "Modèle",
  "mission.gate.plan.effort": "Effort",
  "mission.gate.plan.budget": "Budget",
  "mission.gate.plan.receiptSquad": "Équipe approuvée : {{squad}}",
  "mission.kickoff.title": "Prochaine étape : {{phase}}",
  "mission.kickoff.storyTitle": "Assigner : {{title}}",
  "mission.kickoff.objective.reasoning": "Cadrer la mission : comprendre le besoin, poser les hypothèses, choisir le blueprint.",
  "mission.kickoff.objective.shaping": "Façonner la solution : spec, découpage en stories, squad à confirmer.",
  "mission.kickoff.objective.building": "Construire le livrable : implémenter, tester, documenter.",
  "mission.kickoff.objective.steering": "Piloter en production : surveiller, ajuster, rendre compte.",
  "mission.kickoff.artifactSuffix": "Livrable attendu : {{artifact}}",
  "mission.kickoff.gateSuffix": "Gate : {{gate}}",
  "mission.kickoff.methodologyLabel": "Méthodologie",
  "mission.kickoff.agentLabel": "Agent",
  "mission.kickoff.modelLabel": "Modèle",
  "mission.kickoff.modelAuto": "Auto (routé)",
  "mission.kickoff.effortLabel": "Effort",
  "mission.kickoff.effort.low": "Faible",
  "mission.kickoff.effort.medium": "Moyen",
  "mission.kickoff.effort.high": "Élevé",
  "mission.kickoff.pickAgent": "Choisir un agent",
  "mission.kickoff.recommended": "recommandé",
  "mission.kickoff.launch": "Lancer",
  "mission.kickoff.launching": "Lancement…",
  "mission.stories.title": "Stories",
  "mission.stories.empty": "Aucune story planifiée.",
  "mission.stories.viewBoard": "Voir le board du projet",
  "mission.squad.title": "Squad",
  "mission.squad.empty": "Aucun agent affecté à cette mission.",
  "mission.squad.pocYou": "Toi",
  "mission.squad.pocUnnamed": "POC",
  "mission.squad.rolesAria": "Rôles sur la mission",
  "mission.squad.badge.lead": "Lead",
  "mission.squad.badge.pm": "PM",
  "mission.squad.badge.productOwner": "Product owner",
  "mission.squad.badge.projectManager": "Project manager",
  "mission.squad.badge.leadPm": "Lead · PM",
  "mission.squad.badge.temporary": "ponctuel",
  "mission.squad.variant.lead": "Lead de la mission",
  "mission.squad.variant.temporary": "Temporaire (ponctuel)",
  "mission.squad.variant.permanent": "Permanent",
  "story.verdict.ship": "Ship",
  "story.verdict.needs_work": "Needs work",
  "story.verdict.block": "Block",
  "org.empty": "Aucun agent au staff de l'office.",
  "org.hire": "Embaucher un agent",
  "org.hireSubmit": "Embaucher",
  "org.hired": "Agent embauché.",
  "org.form.displayName": "Nom d'affichage",
  "org.form.champion": "Champion (slug)",
  "org.form.role": "Rôle (slug)",
  "org.form.supervisor": "Superviseur",
  "org.form.noSupervisor": "Aucun",
  "org.form.runtimeTier": "Runtime",
  "wiki.empty": "Aucune page. Créez la première.",
  "wiki.tree.label": "Arborescence des pages",
  "wiki.newPage": "Nouvelle page",
  "wiki.selectPage": "Sélectionnez une page dans l'arborescence.",
  "wiki.editorLabel": "Contenu de la page",
  "wiki.save": "Enregistrer",
  "wiki.saved": "Page enregistrée.",
  "wiki.version": "v{{version}}",
  "wiki.delete": "Supprimer la page",
  "wiki.deleteConfirm": "Confirmer la suppression ?",
  "wiki.pageCreated": "Page créée.",
  "wiki.pageDeleted": "Page supprimée.",
  "wiki.pageNotFound": "Page introuvable.",
  "wiki.form.title": "Titre",
  "wiki.form.parent": "Page parente (optionnel)",
  "wiki.form.noParent": "Aucune",
  "wiki.search.label": "Recherche dans le wiki",
  "wiki.search.placeholder": "Rechercher dans le wiki…",
  "wiki.search.button": "Rechercher",
  "wiki.search.empty": "Aucun résultat.",
  "settings.identity.title": "Identité de l'office",
  "settings.identity.save": "Enregistrer",
  "settings.identity.saved": "Office mis à jour",
  "settings.identity.slugTaken": "Ce slug est déjà pris",
  "settings.stakeholders.title": "Parties prenantes",
  "settings.stakeholders.add": "Ajouter",
  "settings.stakeholders.added": "Partie prenante ajoutée.",
  "settings.stakeholders.removed": "Partie prenante retirée.",
  "settings.stakeholders.email": "E-mail",
  "settings.stakeholders.emailInvalid": "Adresse e-mail invalide.",
  "settings.stakeholders.role": "Rôle",
  "settings.stakeholders.name": "Nom",
  "settings.stakeholders.remove": "Retirer",
  "settings.stakeholders.removeConfirm": "Confirmer ?",
  "settings.stakeholders.empty": "Aucune partie prenante.",
  "settings.stakeholders.actions": "Actions",
  "settings.stakeholders.invite": "Inviter",
  "settings.stakeholders.invited": "Invitation envoyée. La personne devient membre une fois l'invitation acceptée.",
  "settings.invitations.title": "Invitations en attente",
  "settings.invitations.pending": "En attente",
  "settings.invitations.revoke": "Révoquer",
  "settings.invitations.revoked": "Invitation révoquée.",
  "invitations.title": "Invitations",
  "invitations.intro": "Vous ne devenez membre d'un office qu'une fois l'invitation acceptée. D'ici là, rien de vous n'y est partagé.",
  "invitations.empty": "Aucune invitation en attente.",
  "invitations.from": "Invité·e par {{name}} en tant que {{role}}",
  "invitations.accept": "Accepter",
  "invitations.decline": "Refuser",
  "invitations.accepted": "Invitation acceptée.",
  "invitations.declined": "Invitation refusée.",
  "invitations.continue": "Continuer sans rejoindre",
  "settings.role.poc": "POC",
  "settings.role.stakeholder": "Stakeholder",
  "settings.role.viewer": "Viewer",
  "nav.rail.label": "Navigation d'agence",
  "nav.rail.inbox": "Boîte de réception",
  "nav.rail.offices": "Offices",
  "nav.agency.switcher.label": "Changer d'agence",
  "nav.agency.admin": "admin",
  "nav.agency.new": "Nouvelle agence",
  "nav.office.bubble.add": "Nouvel office",
  "nav.breadcrumb.label": "Fil d'Ariane",
  "nav.missions": "Missions",
  "office.new": "Nouvel office — {{agency}}",
  "office.created": "Office créé",
  "form.slug.taken": "Ce slug est déjà utilisé",
  "nav.automations": "Automations",
  "missions.form.goal": "Objectif (le résultat visé)",
  "missions.form.goalPlaceholder": "Le résultat, pas l’artefact…",
  "missions.form.trigger": "Déclencheur",
  "missions.trigger.manual": "Manuel (one-shot)",
  "missions.trigger.cron": "Routine (cron)",
  "missions.trigger.event": "Automatisation (événement)",
  "missions.trigger.eventSoon": "Bientôt — nécessite l’inbox",
  "missions.officeEmpty": "Aucune mission pour l’instant.",
  "missions.gateBand.label": "{{pass}} validées, {{bypassed}} avec bypass, {{fail}} refusées, {{pending}} en attente",
  "missions.gateBand.bypassCount_one": "{{count}} bypass",
  "missions.gateBand.bypassCount_other": "{{count}} bypass",
  "missions.index.title": "Dossiers de mission",
  "missions.index.empty": "Aucun dossier de mission pour l'instant.",
  "missions.index.columns.date": "Date",
  "missions.index.columns.mid": "MID",
  "missions.index.columns.title": "Titre",
  "missions.index.columns.state": "État",
  "missions.index.columns.phase": "Phase",
  "missions.index.columns.source": "Source",
  "missions.index.columns.links": "Liens",
  "missions.index.import": "Importer",
  "missions.index.importing": "Importation…",
  "missions.index.importError": "Échec de l'import.",
  "missions.index.importSuccess": "Import terminé.",
  "missions.index.export": "Exporter",
  "missions.index.openStudio": "Ouvrir",
  "missions.index.openGithub": "GitHub",
  "missions.index.openIssue": "Issue",
  "automations.empty": "Aucune automation pour l'instant.",
  "catalog.picker.role": "Rôle",
  "catalog.picker.rolePlaceholder": "Choisir un rôle…",
  "catalog.picker.champion": "Champion",
  "catalog.picker.championPlaceholder": "Choisir un champion…",
  "catalog.picker.compatible": "Compatibles",
  "catalog.picker.lowAffinity": "Affinité faible",
  "catalog.picker.affinity": "Affinité : {{affinity}}",
  "catalog.picker.affinityLow": "Affinité faible pour ce rôle",
  "org.actions.buildSquad": "Construire un squad",
  "squad.catalog.title": "Construire un squad",
  "squad.catalog.tab.ready": "Squads prêts",
  "squad.catalog.tab.custom": "Sur mesure",
  "squad.catalog.customSoon": "Le builder sur mesure arrive bientôt.",
  "squad.card.hire": "Embaucher",
  "squad.card.workflow": "Workflow",
  "squad.card.members_one": "{{count}} agent",
  "squad.card.members_other": "{{count}} agents",
  "squad.hired": "Squad embauché.",
  "org.node.human": "Humain",
  "org.node.reportsTo": "Reporte à",
  "org.node.topOfChart": "Haut de l’organigramme",
  "org.node.remove": "Retirer",
  "org.node.removeConfirm": "Retirer ce membre de l’organigramme ?",
  "org.node.saved": "Modifié.",
  "org.node.removed": "Retiré.",
  "org.node.cycle": "Boucle de reporting interdite.",
  "org.node.editHint": "Clique un nœud pour le déplacer ou le retirer.",
  "org.chart.dragHint": "Glisse depuis le bas d’un nœud pour le relier à un manager ; lâche une arête dans le vide pour la détacher ; clique un nœud pour l’éditer ou le retirer.",
  "nav.agency.settings": "Paramètres de l’agence",
  "agency.settings.title": "Agence — {{name}}",
  "agency.settings.delete": "Supprimer l’agence",
  "agency.settings.deleteConfirm": "Supprimer cette agence ? Action irréversible.",
  "agency.settings.notEmpty": "Retire d’abord ses offices.",
  "agency.settings.saved": "Agence mise à jour.",
  "agency.settings.deleted": "Agence supprimée.",
  "agency.manage.title": "Gérer les agences",
  "agency.manage.empty": "Aucune agence à gérer.",
  "agency.manage.back": "Retour",
  "agency.manage.edit": "Modifier l’agence",
  "hotkeys.title": "Raccourcis clavier",
  "hotkeys.group.general": "Général",
  "hotkeys.group.navigate": "Navigation",
  "hotkeys.group.create": "Créer",
  "hotkeys.help": "Afficher les raccourcis",
  "hotkeys.palette": "Palette de commandes",
  "hotkeys.goBrainstorming": "Brainstorming",
  "hotkeys.goExecution": "Exécution",
  "hotkeys.goGroups": "Groupes",
  "hotkeys.goMission": "Aller à une mission…",
  "hotkeys.goInbox": "Boîte de réception",
  "hotkeys.goHome": "Mon travail",
  "hotkeys.newGroup": "Nouveau groupe",
  "hotkeys.goDashboard": "Tableau de bord",
  "hotkeys.goMissions": "Missions",
  "hotkeys.goRoutines": "Routines",
  "hotkeys.goAutomations": "Automatisations",
  "hotkeys.goProjects": "Projets",
  "hotkeys.goOrg": "Organigramme",
  "hotkeys.goWiki": "Wiki",
  "hotkeys.newMission": "Nouvelle mission",
  "hotkeys.newProject": "Nouveau projet",
  "nav.flow": "Flow",
  "flow.title": "Flow de la mission",
  "flow.empty": "Aucune story à afficher pour cette mission.",
  "flow.error": "Le DAG des stories ne peut pas être construit (dépendance cyclique ou inconnue).",
  "flow.launch": "Lancer la mission",
  "flow.launched": "Mission lancée",
  "flow.phase": "Phase : {{phase}}",
  "flow.escalation": "Escalade en attente : une story est bloquée et requiert une décision.",
  "flow.node.unassigned": "Non assignée",
  "flow.node.artifact": "Artefact produit",
  "flow.node.escalated": "Escaladée",
  "flow.sub.queued": "En file",
  "flow.sub.implementing": "Implémentation",
  "flow.sub.reviewing": "Revue",
  "flow.sub.awaiting_merge": "Attente de merge",
  "flow.sub.blocked": "Bloquée",
  "flow.sub.cancelled": "Annulée",
  "flow.sub.done": "Terminée",
  "loop.empty": "Aucun verdict de reviewer pour cette story.",
  "loop.error": "Impossible de charger l'historique des verdicts de cette story.",
  "loop.attempt": "Essai {{n}}",
  "loop.evidence.kind.test_output": "Sortie de test",
  "loop.evidence.kind.artifact": "Artefact",
  "loop.evidence.kind.data": "Donnée",
  "loop.evidence.kind.unknown": "Preuve",
  "loop.evidence.error.malformed_json": "La preuve de cette tentative est illisible (donnée malformée).",
  "loop.evidence.error.not_array": "La preuve de cette tentative est illisible (forme inattendue).",
  "loop.header.shipped": "Livrée au {{nth}} essai sur {{max}} autorisés (rigueur {{rigor}})",
  "loop.header.shippedNoRigor": "Livrée au {{nth}} essai sur {{max}} autorisés",
  "loop.header.escalated": "Escaladée au POC après l'essai {{n}} sur {{max}} autorisés (rigueur {{rigor}})",
  "loop.header.escalatedNoRigor": "Escaladée au POC après l'essai {{n}} sur {{max}} autorisés",
  "loop.header.rework": "À reprendre : essai {{n}} sur {{max}} autorisés, un nouvel essai suit (rigueur {{rigor}})",
  "loop.header.reworkNoRigor": "À reprendre : essai {{n}} sur {{max}} autorisés, un nouvel essai suit",
  "loop.header.in_progress": "En cours : essai {{n}} sur {{max}} autorisés (rigueur {{rigor}})",
  "loop.header.in_progressNoRigor": "En cours : essai {{n}} sur {{max}} autorisés",
  "loop.ceiling.help": "Plafond d'essais : après {{max}} relectures sans validation, la story est escaladée au POC. Il vient de la rigueur de la mission ({{rigor}}) ; le cycle de relecture en autorise au plus {{graphMax}}.",
  "loop.ceiling.helpNoRigor": "Plafond d'essais : après {{max}} relectures sans validation, la story est escaladée au POC.",
  "loop.rigor.fast": "Fast",
  "loop.rigor.steady": "Steady",
  "loop.rigor.solid": "Solid",
  "loop.verdict.ship": "Validé",
  "loop.verdict.needsWork": "À reprendre",
  "loop.verdict.block": "Bloqué",
  "loop.who.unknown": "Agent inconnu",
  "loop.who.withRole": "{{name}} ({{role}})",
  "loop.step.implement": "Implémentation",
  "loop.step.tests": "Tests (G6)",
  "loop.step.review": "Relecture",
  "loop.step.security": "Revue sécurité",
  "loop.run.none": "Aucun run enregistré pour cet essai.",
  "loop.run.effort": "effort {{effort}}",
  "loop.run.outcome.ok": "réussi",
  "loop.run.outcome.needs_human": "attend un humain",
  "loop.run.outcome.blocked": "bloqué",
  "loop.run.outcome.failed": "échoué",
  "loop.tests.summary": "{{passed}} réussi(s), {{failed}} en échec",
  "loop.review.by.ship": "{{who}} a validé la story.",
  "loop.review.by.needsWork": "{{who}} a demandé une reprise.",
  "loop.review.by.block": "{{who}} a bloqué la story.",
  "loop.review.by.other": "{{who}} a rendu le verdict {{verdict}}.",
  "loop.security.none": "Exigée par la rigueur {{rigor}} : aucune revue sécurité enregistrée pour cet essai.",
  "loop.checks.title": "Critères d'acceptation",
  "loop.checks.none": "Aucune preuve jointe à ce verdict.",
  "loop.check.status.pass": "Réussi",
  "loop.check.status.fail": "En échec",
  "loop.check.status.waived": "Dispensé",
  "loop.check.status.pending": "En attente",
  "loop.check.status.unknown": "Statut inconnu",
  "loop.check.untitled": "Preuve",
  "loop.check.raw": "Détail brut",
  "loop.oracle.test": "vérifié par un test automatisé",
  "loop.oracle.eval": "vérifié par un cas d'évaluation",
  "loop.oracle.e2e": "vérifié par un test de bout en bout",
  "loop.oracle.live": "vérifié en conditions réelles",
  "loop.oracle.review": "vérifié en relecture de code",
  "loop.oracle.capture": "vérifié sur une capture d'écran",
  "loop.oracle.checklist": "vérifié point par point (checklist)",
  "loop.oracle.crossref": "vérifié en croisant le fichier",
  "loop.oracle.recompute": "vérifié en recalculant le résultat",
  "loop.oracle.prediction": "à confirmer plus tard (prédiction)",
  "loop.oracle.human_verify": "à vérifier par un humain",
  "loop.oracle.other": "méthode : {{oracle}}",
  "loop.link.pr": "Pull request #{{n}}",
  "loop.link.issue": "Ticket GitHub",
  "loop.link.commit": "Commit",
  "loop.link.branch": "Branche",
  "loop.link.runLog": "Journal du run",
  "loop.link.reviewLog": "Journal de la relecture",
  "loop.link.reviewComment": "Commentaire de relecture",
  "loop.link.open": "Ouvrir",
  "loop.prompt.button": "Prompt",
  "loop.prompt.buttonLabel": "Voir le prompt exact de cette exécution",
  "loop.prompt.title": "Prompt de l'exécution",
  "loop.prompt.titleWho": "Prompt de l'exécution — {{who}}",
  "loop.prompt.close": "Fermer",
  "loop.prompt.loading": "Chargement du prompt…",
  "loop.prompt.error": "Le prompt de cette exécution n'a pas pu être chargé.",
  "loop.prompt.empty": "Aucun prompt enregistré pour cette exécution : elle a été lancée avant l'enregistrement des prompts.",
  "loop.prompt.mode.compiled": "Compilé par la plateforme",
  "loop.prompt.mode.plugin": "Chemin plugin",
  "loop.prompt.mode.host": "Étape exécutée par la plateforme (sans prompt)",
  "loop.prompt.mode.unknown": "Origine du prompt inconnue",
  "loop.prompt.verify.checking": "Vérification en cours…",
  "loop.prompt.verify.verified": "vérifié",
  "loop.prompt.verify.verifiedServer": "vérifié par le serveur",
  "loop.prompt.verify.mismatch": "non vérifié",
  "loop.prompt.verify.noRecord": "aucune empreinte enregistrée",
  "loop.prompt.verify.help.verified": "Votre navigateur a recalculé l'empreinte SHA-256 du texte affiché : elle est identique à celle enregistrée au lancement de l'exécution.",
  "loop.prompt.verify.help.verifiedServer": "Des valeurs ont été masquées à l'affichage, votre navigateur ne peut donc pas recalculer l'empreinte. Le serveur a calculé celle du texte stocké : elle est identique à celle enregistrée au lancement.",
  "loop.prompt.verify.help.mismatch": "L'empreinte du texte stocké diffère de celle enregistrée au lancement : ce texte n'est peut-être pas exactement celui que l'agent a reçu.",
  "loop.prompt.verify.help.noRecord": "Cette exécution n'a pas d'empreinte enregistrée : le texte ne peut pas être vérifié.",
  "loop.prompt.sha": "Empreinte {{sha}}",
  "loop.prompt.bundle": "Configuration {{id}}",
  "loop.prompt.compiler": "Compilateur {{version}}",
  "loop.prompt.pluginVersion": "Plugin {{version}}",
  "loop.prompt.fallback": "La compilation a été refusée ({{code}}) : l'exécution a utilisé le chemin plugin.",
  "runs.agentConfig.platform": "Agents : plateforme · v{{version}}",
  "runs.agentConfig.fallback": "Agents : plugin (repli — {{reason}})",
  "build.agentConfig.reason.architect_spec_requires_llm": "la squad a un architecte — le plugin écrit la spec",
  "build.agentConfig.reason.bundle_unavailable": "aucun catalogue d'agents n'est encore disponible",
  "build.agentConfig.reason.preflight_failed": "la vérification n'a pas pu s'exécuter",
  "build.agentConfig.reason.other": "la plateforme ne peut pas composer cette mission",
  "runs.agentConfig.reason.agent_config_unbound": "le service de la plateforme n'est pas connecté",
  "runs.agentConfig.reason.agent_config_rpc_failed": "la plateforme n'a pas répondu à temps",
  "runs.agentConfig.reason.agent_config_unknown": "la version n'appartient pas à cette mission",
  "runs.agentConfig.reason.manifest_mismatch": "les fichiers publiés ne correspondaient pas à leur version",
  "runs.agentConfig.reason.mount_failed": "le dossier n'a pas pu être monté",
  "runs.agentConfig.reason.mount_unreadable": "le dossier monté n'a pas pu être lu",
  "runs.agentConfig.reason.mount_writable": "le dossier monté n'était pas en lecture seule",
  "runs.agentConfig.reason.refused": "la plateforme a refusé de composer",
  "runs.agentConfig.reason.refused_architect_spec_requires_llm": "la squad a un architecte",
  "runs.agentConfig.reason.refused_secret_detected": "un secret a été détecté dans la configuration",
  "runs.agentConfig.reason.refused_bundle_unavailable": "aucun catalogue d'agents n'est disponible",
  "runs.agentConfig.reason.refused_no_plan": "aucun plan approuvé n'a été trouvé",
  "runs.agentConfig.reason.other": "erreur inattendue",
  "loop.prompt.redacted": "Des valeurs ressemblant à des secrets ou à des données personnelles ont été masquées à l'affichage.",
  "loop.prompt.truncated": "Texte tronqué à l'affichage : seule la fin est montrée.",
  "loop.prompt.sections": "Sections ({{count}})",
  "loop.prompt.sectionsHelp": "Dans l'ordre d'envoi. Les sections de la plateforme et du plugin sont verrouillées ; seules les sections de l'office sont modifiables.",
  "loop.prompt.jumpTo": "Aller à la section {{title}}",
  "loop.prompt.origin.platform": "plateforme",
  "loop.prompt.origin.plugin": "plugin",
  "loop.prompt.origin.office": "office",
  "loop.prompt.locked": "verrouillée",
  "loop.prompt.editable": "modifiable par l'office",
  "loop.prompt.version": "version {{version}}",
  "loop.prompt.item": "élément {{sha}}",
  "loop.prompt.chars": "{{count}} caractères",
  "loop.prompt.text": "Texte complet",
  "loop.prompt.argv": "Ligne de lancement",
  "loop.prompt.guidance": "Instructions ajoutées (guidance)",
  "loop.prompt.copy": "Copier le texte",
  "loop.prompt.copied": "Copié",
  "loop.prompt.raw": "Texte brut",
  "loop.prompt.rawManifest": "Manifeste (JSON)",
  "loop.step.testRun": "Exécution des tests",
  "loop.verdict.none": "Sans verdict",
  "loop.step.testCycle": "Exécution des tests, cycle {{n}}",
  "loop.review.none": "Aucun verdict de revue pour cet essai.",
  "workspaceActivity.empty": "Aucune activité pour cette mission.",
  "workspaceActivity.latestVerdicts": "Derniers verdicts",
  "workspaceActivity.retryCount": "{{n}} reprise(s)",
  "workspaceActivity.feed": "Fil en direct",
  "workspaceActivity.ghTransition": "{{sid}} -> {{to}}",
  "nav.connectors": "Connecteurs",
  "connectors.title": "Connecteurs",
  "connectors.subtitle": "Serveurs MCP connectés à cet office.",
  "connectors.empty": "Aucun connecteur enregistré.",
  "connectors.register": "Enregistrer un connecteur",
  "connectors.registered": "Connecteur enregistré.",
  "connectors.removed": "Connecteur supprimé.",
  "connectors.remove": "Supprimer",
  "connectors.removeConfirm": "Supprimer ce connecteur ?",
  "connectors.column.name": "Nom",
  "connectors.column.url": "URL du serveur",
  "connectors.column.status": "Statut",
  "connectors.column.actions": "Actions",
  "connectors.status.registered": "Enregistré",
  "connectors.status.credential_pending": "Authentification en attente",
  "connectors.status.active": "Actif",
  "connectors.form.name": "Nom",
  "connectors.form.serverUrl": "URL du serveur",
  "connectors.form.serverUrlHint": "Le point d'accès du serveur MCP (URL https).",
  "connectors.form.urlInvalid": "Saisissez une URL valide.",
  "connectors.setToken": "Définir le jeton",
  "connectors.updateToken": "Mettre à jour le jeton",
  "connectors.token": "Jeton d'authentification",
  "connectors.tokenSaved": "Jeton enregistré.",
  "connectors.tokenHint": "Stocké chiffré ; utilisé uniquement par l'hôte lorsque vos automations appellent ce connecteur.",
  "automations.title": "Automations",
  "automations.subtitle": "Les automations de cet office.",
  "automations.create": "Nouvelle automation",
  "automations.created": "Automation créée.",
  "automations.column.name": "Nom",
  "automations.column.status": "Statut",
  "automations.status.draft": "Brouillon",
  "automations.status.active": "Active",
  "automations.status.paused": "En pause",
  "automations.form.name": "Nom",
  "automations.viewFlow": "Voir le flow",
  "automations.backToList": "Retour aux automations",
  "automations.flow.title": "Flow de l'automation",
  "home.title": "Mon travail",
  "home.greeting.morning": "Bonjour",
  "home.greeting.afternoon": "Bon après-midi",
  "home.greeting.evening": "Bonsoir",
  "home.greeting.named": "Bonjour, {{name}}",
  "home.greeting.anon": "Bonjour",
  "home.myTasks.title": "Mes tâches",
  "home.myTasks.empty": "Aucune tâche ne vous est assignée.",
  "home.myTasks.filterLabel": "Filtrer les tâches par échéance",
  "home.myTasks.filter.all": "Toutes",
  "home.myTasks.filter.today": "Aujourd'hui",
  "home.myTasks.filter.upcoming": "À venir",
  "home.myTasks.filter.overdue": "En retard",
  "home.myTasks.filter.no_due": "Sans échéance",
  "home.myTasks.viewToggle": "Vue des tâches",
  "home.myTasks.viewList": "Vue liste",
  "home.myTasks.viewCalendar": "Vue calendrier",
  "home.myTasks.col.title": "Tâche",
  "home.myTasks.col.project": "Projet",
  "home.myTasks.col.status": "Statut",
  "home.myTasks.col.due": "Échéance",
  "home.myTasks.noDue": "—",
  "home.myTasks.addTask": "Ajouter une tâche",
  "home.myTasks.addTaskProject": "Dans le projet",
  "home.myTasks.addTaskPick": "Choisir un projet…",
  "home.myTasks.addTaskGo": "Ouvrir le tableau",
  "home.calendar.prev": "Mois précédent",
  "home.calendar.next": "Mois suivant",
  "home.calendar.noDue": "Sans échéance",
  "home.todos.title": "Liste de tâches perso",
  "home.todos.add": "Ajouter",
  "home.todos.addLabel": "Nouvelle tâche perso",
  "home.todos.addPlaceholder": "Ajouter une tâche personnelle…",
  "home.todos.empty": "Votre liste est vide.",
  "home.todos.delete": "Supprimer « {{title}} »",
  "home.activity.title": "Activité",
  "home.activity.tabsLabel": "Flux d'activité",
  "home.activity.tab.tasks": "Tâches",
  "home.activity.tab.time": "Temps loggé",
  "home.activity.kind.human": "Humain",
  "home.activity.kind.agent": "Agent",
  "home.activity.empty.tasks": "Aucune activité de tâche récente.",
  "home.activity.empty.time": "Aucun temps loggé pour l'instant.",
  "home.activity.notif.assignment": "Une story vous a été assignée",
  "home.activity.notif.mention": "Vous avez été mentionné",
  "home.activity.notif.app_ci.failed": "Le build d’une branche a échoué ({{code}})",
  "home.activity.notif.app_ci.ready_to_go_live": "Une nouvelle version de main est construite et prête à mettre en ligne",
  "home.activity.notif.app_ci.budget_exhausted": "Les builds de branches sont en pause : le budget de l’office est atteint",
  "home.activity.notif.app_ci.preview_evicted": "Une ancienne preview de branche a été supprimée (limite de {{cap}} par app)",
  "home.activity.notif.delivery.failed": "La mise en ligne n’a pas abouti ({{code}})",
  "home.activity.timeEntry": "a loggé {{duration}} le {{date}}",
  "home.recent.title": "Projets",
  "home.recent.tabsLabel": "Projets récents et favoris",
  "home.recent.tab.recents": "Récents",
  "home.recent.tab.favorites": "Favoris",
  "home.recent.empty.recents": "Aucun projet consulté récemment.",
  "home.recent.empty.favorites": "Aucun projet favori pour l'instant.",
  "home.recent.star": "Ajouter « {{name}} » aux favoris",
  "home.recent.unstar": "Retirer « {{name}} » des favoris",
  "projects.filter.all": "Tous",
  "projects.filter.favourites": "Favoris",
  "projects.view.list": "Liste",
  "projects.view.group": "Groupé",
  "projects.groupBy.label": "Grouper par",
  "projects.groupBy.category": "Catégorie",
  "projects.groupBy.health": "Santé",
  "projects.groupBy.none": "Sans catégorie",
  "projects.column.name": "Projet",
  "projects.column.category": "Catégorie",
  "projects.column.progress": "Progression",
  "projects.column.pm": "PM",
  "projects.column.updated": "Mis à jour",
  "projects.health.not_set": "Non défini",
  "projects.health.on_track": "Sur la bonne voie",
  "projects.health.at_risk": "À risque",
  "projects.health.off_track": "Hors piste",
  "projects.favorite.add": "Ajouter aux favoris",
  "projects.favorite.remove": "Retirer des favoris",
  "projects.favorite.failed": "Impossible de mettre à jour le favori",
  "projects.pm.none": "Non assigné",
  "projects.progress.label": "{{pct}}% terminé",
  "projects.edit": "Éditer le projet",
  "projects.updated": "Projet mis à jour",
  "projects.drawer.createTitle": "Nouveau projet",
  "projects.drawer.editTitle": "Éditer le projet",
  "projects.form.color": "Couleur",
  "projects.form.status": "Statut",
  "projects.form.health": "Santé",
  "projects.form.category": "Catégorie",
  "projects.form.categoryNone": "Sans catégorie",
  "projects.form.startDate": "Date de début",
  "projects.form.endDate": "Date de fin",
  "projects.form.manager": "Chef de projet",
  "projects.form.managerNone": "Non assigné",
  "projects.status.active": "Actif",
  "projects.status.archived": "Archivé",
  "projectView.tabs.label": "Vues du projet",
  "projectView.tabs.taskList": "Stories",
  "projectView.tabs.board": "Tableau",
  "projectView.tabs.files": "Fichiers",
  "projectView.tabs.members": "Membres",
  "projectView.tabs.updates": "Activité",
  "projectView.tabs.insights": "Insights",
  "projectView.tabs.roadmap": "Feuille de route",
  "projectView.tabs.workload": "Charge",
  "projectView.tabs.finance": "Finance",
  "projectView.tabs.budget": "Budget",
  "projectView.tabs.missions": "Missions",
  "projectView.tabs.wiki": "Wiki",
  "projectView.tabs.brainstorming": "Réflexion",
  "projectView.header.pm": "PM",
  "projectView.header.noPm": "Aucun PM",
  "projectView.header.newStory": "Nouvelle story",
  "projectView.placeholder.comingSoon": "À venir dans une prochaine passe.",
  "taskList.empty": "Aucune story pour l'instant. Ajoutez-en une pour démarrer.",
  "taskList.search": "Rechercher des stories",
  "taskList.groupBy.label": "Grouper par",
  "taskList.groupBy.status": "Statut",
  "taskList.groupBy.priority": "Priorité",
  "taskList.groupBy.assignee": "Assigné",
  "taskList.groupBy.due_date": "Échéance",
  "taskList.filter.priority": "Priorité",
  "taskList.filter.labels": "Labels",
  "taskList.filter.members": "Membres",
  "taskList.column.key": "Clé",
  "taskList.column.name": "Nom",
  "taskList.column.progress": "Progression",
  "taskList.column.status": "Statut",
  "taskList.column.assignees": "Assignés",
  "taskList.column.labels": "Labels",
  "taskList.column.priority": "Priorité",
  "taskList.column.due": "Échéance",
  "taskList.column.time": "Temps",
  "taskList.group.none": "Non groupé",
  "taskList.group.unassigned": "Non assigné",
  "taskList.group.due.overdue": "En retard",
  "taskList.group.due.today": "Aujourd'hui",
  "taskList.group.due.this_week": "Cette semaine",
  "taskList.group.due.this_month": "Ce mois-ci",
  "taskList.group.due.later": "Plus tard",
  "taskList.group.due.__none__": "Sans échéance",
  "taskList.subtasks_one": "{{count}} sous-story",
  "taskList.subtasks_other": "{{count}} sous-stories",
  "taskList.blockedBy": "Bloqué par {{count}}",
  "taskList.addStory": "Ajouter une story",
  "taskList.addStory.mission": "Mission",
  "taskList.addStory.title": "Titre de la story",
  "taskList.addStory.save": "Ajouter",
  "taskList.addStory.cancel": "Annuler",
  "taskList.priority.low": "Basse",
  "taskList.priority.medium": "Moyenne",
  "taskList.priority.high": "Haute",
  "taskList.priority.urgent": "Urgente",
  "storyDrawer.assignee.kind.human": "Humain",
  "storyDrawer.assignee.kind.agent": "Agent",
  "storyDrawer.assignee.unassigned": "Non assigné",
  "storyDrawer.assignee.pinned": "Cette assignation a une confiance / rigueur ajustée pour la story : clique sur son réglage et « Revenir au membre » avant de la retirer.",
  "storyDrawer.assignee.notInSquad": "Cet agent n'est pas dans l'escouade de la mission : recrute-le d'abord sur la mission.",
  "storyDrawer.tabs.label": "Détails de la story",
  "storyDrawer.tabs.info": "Infos",
  "storyDrawer.tabs.activity": "Activité",
  "storyDrawer.tabs.loop": "Boucle",
  "storyDrawer.close": "Fermer",
  "storyDrawer.peek.side": "Panneau latéral",
  "storyDrawer.peek.modal": "Fenêtre",
  "storyDrawer.peek.full": "Plein écran",
  "storyDrawer.notFound": "Story introuvable",
  "storyDrawer.title": "Titre",
  "storyDrawer.titlePlaceholder": "Titre de la story",
  "storyDrawer.parentLink": "Parent : {{title}}",
  "storyDrawer.field.assignees": "Assignés",
  "storyDrawer.field.labels": "Labels",
  "storyDrawer.field.priority": "Priorité",
  "storyDrawer.field.due": "Échéance",
  "storyDrawer.field.description": "Description",
  "storyDrawer.field.descriptionPlaceholder": "Ajouter une description…",
  "storyDrawer.field.save": "Enregistrer",
  "storyDrawer.field.add": "Ajouter",
  "storyDrawer.priority.none": "Sans priorité",
  "storyDrawer.priority.low": "Basse",
  "storyDrawer.priority.medium": "Moyenne",
  "storyDrawer.priority.high": "Haute",
  "storyDrawer.priority.urgent": "Urgente",
  "storyDrawer.saveFailed": "Impossible d'enregistrer la modification",
  "subtasks.title": "Sous-stories",
  "subtasks.empty": "Aucune sous-story.",
  "subtasks.add": "Ajouter une sous-story",
  "subtasks.placeholder": "Titre de la sous-story",
  "subtasks.save": "Ajouter",
  "subtasks.open": "Ouvrir la sous-story",
  "dependencies.title": "Dépendances",
  "dependencies.blockedBy": "Bloqué par",
  "dependencies.blocks": "Bloque",
  "dependencies.empty": "Aucune dépendance.",
  "dependencies.add": "Ajouter une dépendance",
  "dependencies.placeholder": "Choisir une story dont celle-ci dépend",
  "dependencies.remove": "Retirer la dépendance",
  "dependencies.addFailed": "Impossible d'ajouter la dépendance",
  "storyDrawer.time.add": "Enregistrer du temps",
  "storyDrawer.time.duration": "Durée (minutes)",
  "storyDrawer.time.date": "Date",
  "storyDrawer.time.note": "Note",
  "storyDrawer.time.billable": "Facturable",
  "storyDrawer.time.save": "Enregistrer",
  "storyDrawer.activity.empty": "Aucune activité pour l'instant.",
  "storyDrawer.blocked.title": "Pourquoi cette story est bloquée",
  "storyDrawer.blocked.failed": "L'exécution {{step}} a échoué à l'essai {{attempt}}",
  "storyDrawer.blocked.failedNoAttempt": "L'exécution {{step}} a échoué",
  "storyDrawer.blocked.codeLabel": "Code d'erreur",
  "storyDrawer.blocked.unknownCode": "Ce code d'erreur n'a pas encore d'explication — les journaux de l'exécution, dans l'onglet Boucle, donnent le détail.",
  "storyDrawer.blocked.noCode": "L'exécution a échoué sans code d'erreur lisible.",
  "storyDrawer.blocked.noFailure": "Aucune exécution en échec n'est enregistrée pour cette story : elle a été arrêtée par un verdict de revue, le plafond d'essais ou une règle de mission (voir l'onglet Boucle).",
  "storyDrawer.blocked.cost": "coût {{cost}}",
  "storyDrawer.blocked.hint": "Pour continuer, répondez {{retry}} sur l'issue GitHub de la story pour la relancer, ou {{abort}} pour l'abandonner.",
  "storyDrawer.blocked.issueLink": "Ouvrir l'issue GitHub",
  "storyDrawer.blocked.step.plan": "de plan",
  "storyDrawer.blocked.step.compose": "de composition",
  "storyDrawer.blocked.step.implement": "d'implémentation",
  "storyDrawer.blocked.step.review": "de revue",
  "storyDrawer.blocked.step.retro": "de rétro",
  "storyDrawer.blocked.step.other": "de l'agent",
  "storyDrawer.blocked.code.verdict_missing": "Le relecteur a terminé sans écrire de verdict (SHIP, NEEDS_WORK ou BLOCK).",
  "storyDrawer.blocked.code.block_missing": "L'agent a terminé sans écrire son bloc de résultat.",
  "storyDrawer.blocked.code.block_truncated": "Le bloc de résultat de l'agent a été coupé avant sa fin.",
  "storyDrawer.blocked.code.block_invalid": "Le bloc de résultat de l'agent ne respecte pas le format attendu.",
  "storyDrawer.blocked.code.result_unparseable": "La sortie de l'agent n'a pas pu être lue comme un résultat.",
  "storyDrawer.blocked.code.no_stdout_captured": "L'agent n'a produit aucune sortie.",
  "storyDrawer.blocked.code.exit_nonzero": "Le processus de l'agent s'est terminé en erreur.",
  "storyDrawer.blocked.code.timeout": "L'exécution a dépassé sa limite de temps.",
  "storyDrawer.blocked.code.step_timeout": "L'exécution a dépassé sa limite de temps.",
  "storyDrawer.blocked.code.poll_deadline": "L'exécution n'a pas répondu avant l'échéance.",
  "storyDrawer.blocked.code.step_lost": "Le runner a perdu l'exécution avant sa fin.",
  "storyDrawer.blocked.code.run_interrupted": "L'exécution dans la sandbox a été interrompue avant sa fin.",
  "storyDrawer.blocked.code.launch_failed": "L'agent n'a pas pu être démarré dans la sandbox.",
  "storyDrawer.blocked.code.seed_failed": "La sandbox n'a pas pu être préparée (clone, fetch ou installation en échec).",
  "storyDrawer.blocked.code.capacity_exceeded": "Aucune capacité de runner n'était libre pour lancer l'exécution.",
  "storyDrawer.blocked.code.runner_unbound": "Aucun runner n'est configuré pour cet office.",
  "storyDrawer.blocked.code.sandbox_unavailable": "La sandbox n'était pas disponible.",
  "storyDrawer.blocked.code.invalid_step_request": "Le runner a refusé la demande d'étape comme invalide.",
  "storyDrawer.blocked.code.plugin_missing": "Le plugin NovaTechnica est introuvable dans la sandbox.",
  "storyDrawer.blocked.code.harness_unsupported_feature": "Le harness de code configuré ne prend pas en charge cette étape.",
  "storyDrawer.blocked.code.model_unmappable": "Le modèle configuré n'est pas disponible pour ce harness.",
  "storyDrawer.blocked.code.review_env_dirty": "L'espace de revue contenait des modifications inattendues : la revue n'a pas été retenue.",
  "storyDrawer.blocked.code.review_level_unrecorded": "Le niveau de revue n'a pas pu être enregistré avant le début de la revue.",
  "storyDrawer.blocked.code.review_level_unreadable": "Le niveau de revue n'a pas pu être relu après la revue.",
  "storyDrawer.blocked.code.retro_inputs_incomplete": "Les entrées de la rétro étaient incomplètes.",
  "storyDrawer.blocked.code.push_refused": "Le push des commits de l'agent a été refusé.",
  "storyDrawer.blocked.code.push_failed": "Le push des commits de l'agent a échoué.",
  "storyDrawer.blocked.code.base_conflict": "La branche de la story est toujours en conflit avec la branche de mission : le run ne l'a pas fusionnée, rien n'a été poussé.",
  "storyDrawer.blocked.code.no_commit": "L'implémenteur a terminé sans committer de changement.",
  "storyDrawer.blocked.code.no_diff": "L'implémenteur a terminé sans modifier de fichier.",
  "storyDrawer.blocked.code.finalize_failed": "Le résultat de l'exécution n'a pas pu être enregistré.",
  "storyDrawer.blocked.code.cancelled": "L'exécution a été annulée.",
  "storyDrawer.activity.sentence.verdict.ship": "{{who}} a validé la story — essai {{n}}",
  "storyDrawer.activity.sentence.verdict.needsWork": "{{who}} a demandé une reprise — essai {{n}}",
  "storyDrawer.activity.sentence.verdict.block": "{{who}} a bloqué la story — essai {{n}}",
  "storyDrawer.activity.sentence.verdict.other": "{{who}} a rendu le verdict {{verdict}} — essai {{n}}",
  "storyDrawer.activity.sentence.comment": "{{who}} a commenté",
  "storyDrawer.activity.sentence.timeLog": "{{who}} a enregistré {{minutes}} min de travail",
  "storyDrawer.activity.actor.workflow": "Workflow GitHub",
  "storyDrawer.activity.actor.unknownAgent": "Agent inconnu",
  "storyDrawer.activity.actor.unknownMember": "Membre inconnu",
  "storyDrawer.activity.actor.system": "Système",
  "storyDrawer.activity.link.attempt": "Voir l'essai {{n}}",
  "storyDrawer.activity.link.review": "Commentaire de relecture",
  "storyDrawer.activity.link.pr": "Pull request",
  "storyDrawer.activity.sentence.status": "{{who}} a déplacé la story de « {{from}} » à « {{to}} »",
  "storyDrawer.activity.sentence.statusTo": "{{who}} a déplacé la story à « {{to}} »",
  "storyDrawer.activity.sentence.run.implement.running": "{{who}} implémente — essai {{n}}",
  "storyDrawer.activity.sentence.run.implement.finished": "{{who}} a terminé l'implémentation ({{outcome}}) — essai {{n}}",
  "storyDrawer.activity.sentence.run.implement.finishedBare": "{{who}} a terminé l'implémentation — essai {{n}}",
  "storyDrawer.activity.sentence.run.review.running": "{{who}} relit — essai {{n}}",
  "storyDrawer.activity.sentence.run.review.finished": "{{who}} a terminé la relecture ({{outcome}}) — essai {{n}}",
  "storyDrawer.activity.sentence.run.review.finishedBare": "{{who}} a terminé la relecture — essai {{n}}",
  "storyDrawer.activity.run.model": "Modèle : {{model}}",
  "storyDrawer.activity.currentStatus": "Statut actuel : {{status}}",
  "storyDrawer.activity.actor.github": "GitHub",
  "storyDrawer.activity.actor.champion": "Le champion",
  "storyDrawer.activity.link.prNumber": "Pull request #{{n}}",
  "storyDrawer.activity.link.issue": "Issue GitHub",
  "storyDrawer.tabs.review": "Revue",
  "storyDrawer.review.branch": "Branche",
  "storyDrawer.review.diffTitle": "Modifications",
  "storyDrawer.review.files_one": "{{count}} fichier",
  "storyDrawer.review.files_other": "{{count}} fichiers",
  "storyDrawer.review.noDiff": "Aucune modification enregistrée pour cette story.",
  "storyDrawer.review.diffUnavailable": "Les modifications ne peuvent pas être chargées pour le moment.",
  "storyDrawer.review.truncated": "Diff tronqué : seuls les 256 premiers Kio sont affichés.",
  "storyDrawer.review.binary": "Fichier binaire, non affiché.",
  "storyDrawer.review.status.added": "Ajouté",
  "storyDrawer.review.status.deleted": "Supprimé",
  "storyDrawer.review.status.renamed": "Renommé",
  "storyDrawer.review.status.modified": "Modifié",
  "storyDrawer.review.previewTitle": "Aperçu",
  "storyDrawer.review.previewOpen": "Ouvrir l'aperçu",
  "storyDrawer.review.previewPending": "Aperçu en attente : le lien apparaît ici dès que la build est déployée.",
  "storyDrawer.review.previewPrivateNote": "Lien privé, valable 12 heures, pour les membres de cet office.",
  "storyDrawer.review.previewUnavailable": "Aperçu déployé mais privé : l'accès sécurisé n'est pas encore configuré, il ne peut pas être ouvert d'ici.",
  "storyDrawer.review.share": "Partager l'aperçu",
  "storyDrawer.review.shareLabel": "Lien de partage (valable 7 jours). Toute personne qui l'a peut ouvrir l'aperçu.",
  "storyDrawer.review.shareExpiry": "Vous seul voyez ce lien. Il expire dans 7 jours.",
  "storyDrawer.review.shareFailed": "Impossible de créer un lien de partage.",
  "storyDrawer.review.decisionTitle": "Votre décision",
  "storyDrawer.review.approve": "Approuver",
  "storyDrawer.review.sendBack": "Renvoyer",
  "storyDrawer.review.commentLabel": "Que faut-il changer ?",
  "storyDrawer.review.commentPlaceholder": "Décrivez ce qu'il faut corriger. Ce texte est transmis à la tentative suivante.",
  "storyDrawer.review.sendBackConfirm": "Renvoyer avec ce commentaire",
  "storyDrawer.review.cancel": "Annuler",
  "storyDrawer.review.commentRequired": "Un commentaire est obligatoire pour renvoyer une story.",
  "storyDrawer.review.noGate": "Aucune porte de revue n'est ouverte pour cette story : rien à décider pour l'instant.",
  "storyDrawer.review.decideFailed": "Impossible d'enregistrer la décision.",
  "storyDrawer.review.stale": "Déjà décidé. Actualisation.",
  "storyDrawer.review.loadFailed": "Impossible de charger la revue.",
  "ledger.criteria.listLabel": "Critères d'acceptation",
  "ledger.criteria.empty": "Aucun critère pour l'instant.",
  "ledger.criteria.noEvidence": "Sans preuve",
  "ledger.criteria.evidenceCount_one": "{{count}} preuve",
  "ledger.criteria.evidenceCount_other": "{{count}} preuves",
  "ledger.criteria.more": "+{{count}}",
  "ledger.criteria.addEvidence": "Ajouter une preuve",
  "ledger.criteria.toggle.rows": "Lignes",
  "ledger.criteria.toggle.markdown": "Markdown",
  "ledger.criteria.markdownHint": "Les lignes font foi — ce markdown est régénéré à l'enregistrement.",
  "ledger.criteria.save": "Enregistrer",
  "ledger.criteria.importError.generic": "Impossible d'importer les critères depuis ce markdown.",
  "ledger.criteria.importError.story_seq_out_of_range": "Le numéro de story est hors plage.",
  "ledger.criteria.importError.too_many_criteria": "Trop de critères dans ce bloc.",
  "ledger.criteria.importError.story_block_not_found": "Aucun bloc de story trouvé dans ce markdown.",
  "ledger.criteria.importError.ambiguous_story_block": "Plusieurs blocs de story correspondent — précisez.",
  "ledger.criteria.importError.oracle_invalid": "Un critère a un oracle invalide.",
  "ledger.status.unverified": "Non vérifié",
  "ledger.status.verified": "Vérifié",
  "ledger.status.failed": "Échoué",
  "ledger.status.waived": "Dérogé",
  "ledger.oracle.test": "test",
  "ledger.oracle.checklist": "checklist",
  "ledger.oracle.crossref": "crossref",
  "ledger.oracle.recompute": "recompute",
  "ledger.oracle.prediction": "prédiction",
  "ledger.oracle.human_verify": "vérif. humaine",
  "ledger.evidence.kind.artifact": "Artefact",
  "ledger.evidence.kind.url": "URL",
  "ledger.evidence.kind.commit": "Commit",
  "ledger.evidence.kind.quote": "Citation",
  "ledger.evidence.kind.number": "Nombre",
  "ledger.evidence.kind.routine": "Routine",
  "ledger.evidence.kind.test_run": "Exécution de tests",
  "ledger.evidence.kind.prediction": "Prédiction",
  "ledger.evidence.field.url": "URL",
  "ledger.evidence.field.artifact": "Artefact",
  "ledger.evidence.field.version": "Version",
  "ledger.evidence.field.sha": "SHA du commit",
  "ledger.evidence.field.source": "Source",
  "ledger.evidence.field.excerpt": "Extrait",
  "ledger.evidence.field.value": "Valeur",
  "ledger.evidence.field.unit": "Unité",
  "ledger.evidence.field.note": "Note",
  "ledger.evidence.submit": "Ajouter la preuve",
  "ledger.evidence.cancel": "Annuler",
  "ledger.evidence.copySha": "Copier",
  "ledger.evidence.copied": "Copié",
  "ledger.evidence.chipLabel": "{{kind}} : {{label}}",
  "ledger.activity.title": "Lu / fait",
  "ledger.activity.empty": "Aucune lecture ni action enregistrée.",
  "ledger.activity.proven": "Prouvé",
  "ledger.activity.read": "Lu",
  "ledger.activity.done": "Fait",
  "ledger.activity.atLeast": "{{count}}+",
  "ledger.actions.title": "Actions ({{count}})",
  "ledger.actions.status.staged": "Préparée",
  "ledger.actions.status.pending": "En attente",
  "ledger.actions.status.approved": "Approuvée",
  "ledger.actions.status.rejected": "Rejetée",
  "ledger.actions.status.claimed": "En cours",
  "ledger.actions.status.applied": "Appliquée",
  "ledger.actions.status.failed": "Échouée",
  "ledger.actions.kind.datasource.write": "Écriture de données",
  "ledger.actions.kind.git.push": "Push Git",
  "ledger.actions.kind.github.pr.open": "Ouverture de PR",
  "ledger.actions.decidedBy": "{{name}} · {{date}}",
  "ledger.actions.via.manual": "Décision manuelle",
  "ledger.actions.via.rule": "Via la gate {{gate}}",
  "ledger.actions.decider.poc": "POC",
  "ledger.actions.awaiting": "En attente de décision",
  "ledger.actions.showAll": "Tout voir ({{count}})",
  "ledger.loadMore": "Charger plus",
  "ledger.actions.reject.button": "Rejeter",
  "ledger.actions.reject.confirm": "Confirmer le rejet",
  "ledger.actions.reject.cancel": "Annuler",
  "ledger.actions.reject.confirmLabel": "Rejeter « {{title}} » ?",
  "ledger.actions.reject.comment": "Commentaire (facultatif)",
  "ledger.actions.reject.done": "Action rejetée.",
  "ledger.actions.reject.error.action_not_pending": "Cette action n’est plus en attente, vue actualisée.",
  "ledger.actions.reject.error.not_found": "Action introuvable.",
  "ledger.observations.title": "Lectures ({{count}})",
  "ledger.observations.kind.datasource": "Source de données",
  "ledger.observations.kind.office_tool": "Outil du bureau",
  "ledger.observations.restricted": "Restreinte",
  "ledger.observations.restrictedCount": "dont {{count}} restreintes",
  "ledger.rail.proven": "{{phase}} : {{count}} preuves",
  "ledger.rail.read": "{{phase}} : {{count}} lectures",
  "ledger.rail.done": "{{phase}} : {{count}} actions",
  "ledger.rail.provenAtLeast": "{{phase}} : au moins {{count}} preuves",
  "ledger.rail.readAtLeast": "{{phase}} : au moins {{count}} lectures",
  "ledger.rail.doneAtLeast": "{{phase}} : au moins {{count}} actions",
  "workspace.tab.traceability": "Traçabilité",
  "traceability.label": "Traçabilité de la mission",
  "traceability.kpi.readiness": "Préparation",
  "traceability.error": "Impossible de charger le registre.",
  "traceability.empty": "Aucun critère ni lien pour l'instant.",
  "traceability.view.matrix": "Matrice",
  "traceability.view.flow": "Flow",
  "traceability.kpi.coverage": "Couverture",
  "traceability.kpi.unverified": "Non vérifiés",
  "traceability.kpi.failed": "Échoués",
  "traceability.kpi.waived": "Dérogés",
  "traceability.kpi.bypassed": "Gates contournées",
  "traceability.kpi.clarifications": "Clarifications ouvertes",
  "traceability.kpi.read": "Lu",
  "traceability.kpi.done": "Fait",
  "traceability.kpi.contradictions": "Contradictions",
  "traceability.kpi.showContradictions": "Voir les contradictions dans le flow",
  "traceability.kpi.proven": "{{n}}/{{m}} prouvés",
  "traceability.kpi.missing": "Sans preuve :",
  "traceability.kpi.blocked": "Gate bloquée",
  "traceability.kpi.readinessUnavailable": "Préparation indisponible",
  "traceability.matrix.col.code": "Code",
  "traceability.matrix.col.text": "Critère",
  "traceability.matrix.col.oracle": "Oracle",
  "traceability.matrix.col.status": "Statut",
  "traceability.matrix.col.evidence": "Preuves",
  "traceability.matrix.col.gate": "Gate",
  "traceability.matrix.openStory": "Ouvrir {{code}} ({{story}})",
  "traceability.matrix.gateAll": "Toutes",
  "traceability.matrix.count": "{{shown}} / {{total}} critères",
  "traceability.matrix.noMatch": "Aucun critère ne correspond aux filtres.",
  "traceability.filter.status": "Statut",
  "traceability.filter.oracle": "Oracle",
  "traceability.filter.phase": "Phase",
  "traceability.filter.noEvidence": "Sans preuve",
  "traceability.filter.all": "Tous",
  "traceability.filter.untagged": "Non taggé",
  "traceability.filter.reset": "Réinitialiser",
  "traceability.rel.covers": "couvre",
  "traceability.rel.contradicts": "contredit",
  "traceability.rel.derives_from": "dérive de",
  "traceability.rel.supersedes": "remplace",
  "traceability.rel.cites": "cite",
  "traceability.rel.blocks": "bloque",
  "traceability.flow.edgeAria": "{{from}} {{rel}} {{to}}",
  "traceability.flow.edgeAriaCross": "(autre mission : {{mission}})",
  "traceability.flow.foreign": "{{type}} · {{mission}}",
  "traceability.flow.otherMission": "Autre mission",
  "traceability.flow.unknownArtifact": "artefact introuvable",
  "traceability.flow.linksList": "Liste des liens ({{count}})",
  "traceability.flow.empty": "Aucun lien enregistré pour cette mission.",
  "traceability.type.criterion": "Critère",
  "traceability.type.story": "Story",
  "traceability.type.artifact": "Artefact",
  "traceability.type.mission": "Mission",
  "board.card.subtasks_one": "{{count}} sous-tâche",
  "board.card.subtasks_other": "{{count}} sous-tâches",
  "files.title": "Fichiers",
  "files.layout": "Disposition",
  "files.layoutGrid": "Vue grille",
  "files.layoutList": "Vue liste",
  "files.upload": "Téléverser un fichier",
  "files.uploading": "Téléversement…",
  "files.uploadHint": "Glissez un fichier ici ou cliquez pour parcourir",
  "files.download": "Télécharger {{name}}",
  "files.delete": "Supprimer {{name}}",
  "files.empty": "Aucun fichier pour l'instant.",
  "members.title": "Membres",
  "members.empty": "Aucun membre pour l'instant.",
  "updates.empty": "Aucune mise à jour pour l'instant.",
  "updates.unknownStory": "une story",
  "updates.onStory": "Sur {{title}}",
  "updates.composer.story": "Story",
  "updates.composer.storyPlaceholder": "Choisir une story…",
  "updates.composer.comment": "Commentaire",
  "updates.composer.placeholder": "Partagez une mise à jour…",
  "updates.composer.post": "Publier",
  "automations.flow.placeholder": "Décrivez ce que cette automation doit faire — le copilot dessine la crew ici.",
  "automations.process": "Processus",
  "automations.process.sequential": "Séquentiel",
  "automations.editAgent": "Modifier l'agent",
  "automations.editTask": "Modifier la tâche",
  "automations.save": "Enregistrer",
  "automations.saving": "Enregistrement…",
  "automations.saved": "Automation mise à jour.",
  "automations.fields.champion": "Champion",
  "automations.fields.role": "Rôle",
  "automations.fields.personaRole": "Rôle du persona",
  "automations.fields.goal": "Objectif",
  "automations.fields.backstory": "Histoire",
  "automations.fields.key": "Clé de la tâche",
  "automations.fields.description": "Description",
  "automations.fields.expectedOutput": "Résultat attendu",
  "automations.fields.connector": "Connecteur",
  "automations.fields.connectorId": "ID du connecteur",
  "automations.fields.method": "Méthode",
  "automations.fields.path": "Chemin",
  "automations.fields.model": "Modèle",
  "automations.fields.modelDefault": "Par défaut (hérité)",
  "automations.process.hierarchical": "Hiérarchique",
  "automations.palette.title": "Composants",
  "automations.palette.hint": "Glissez sur le canevas pour ajouter.",
  "automations.palette.crew": "Crew",
  "automations.palette.tools": "Outils",
  "automations.palette.agent": "Agent",
  "automations.palette.agentHint": "Un membre de la crew",
  "automations.palette.task": "Tâche",
  "automations.palette.taskHint": "Une unité de travail",
  "automations.palette.noTools": "Aucun connecteur actif. Ajoutez un jeton sur la page Connecteurs.",
  "automations.palette.newAgentRole": "Nouvel agent",
  "automations.palette.newTaskDescription": "Décrivez cette tâche…",
  "automations.palette.newToolDescription": "Appeler {{name}}",
  "automations.tabs.canvas": "Canevas",
  "automations.tabs.runs": "Exécutions",
  "automations.triggers.title": "Déclencheurs",
  "automations.triggers.manual": "Manuel",
  "automations.triggers.cron": "Cron",
  "automations.triggers.cronExpr": "Expression cron",
  "automations.triggers.cronHint": "Cron standard à 5 champs (min heure jour mois jour-semaine).",
  "automations.triggers.saved": "Déclencheur enregistré.",
  "automations.triggers.comingSoon": "La planification n'est pas encore disponible — bientôt.",
  "automations.runs.empty": "Aucune exécution pour l'instant.",
  "automations.runs.noOutput": "Aucune sortie enregistrée pour cette exécution.",
  "automations.generating": "Génération…",
  "automations.copilot.label": "Copilot",
  "automations.copilot.empty": "Décris ce que cette automation doit faire — le copilot dessine la crew.",
  "automations.copilot.placeholder": "Décrivez ce que cette automation doit faire…",
  "automations.copilot.send": "Générer",
  "automations.copilot.done": "Crew générée.",
  "automations.copilot.thinking.understanding": "Compréhension de la demande…",
  "automations.copilot.thinking.designing": "Conception de la crew…",
  "automations.copilot.thinking.compiling": "Compilation du workflow…",
  "automations.copilot.summary.created": "{{parts}}",
  "automations.copilot.summary.agents": "{{n}} agents créés ({{keys}})",
  "automations.copilot.summary.tasks": "et {{n}} tâches ({{keys}}).",
  "automations.run.label": "Exécuter",
  "automations.run.input": "Entrée",
  "automations.run.running": "En cours…",
  "automations.run.output": "Sortie",
  "automations.run.needsSpec": "Générez une crew avant d'exécuter.",
  "automations.run.status.queued": "En file",
  "automations.run.status.running": "En cours",
  "automations.run.status.complete": "Terminé",
  "automations.run.status.errored": "En erreur",
  "sidebar.new": "Nouveau",
  "sidebar.pinned": "Épinglés",
  "sidebar.groupBy.phase": "Phase",
  "sidebar.groupBy.product": "Produit",
  "sidebar.groupBy.last_activity": "Activité",
  "sidebar.lens.think": "Réflexion",
  "sidebar.lens.do": "Exécution",
  "sidebar.lens.products": "Vue d'ensemble",
  "sidebar.portfolio.add": "Nouveau groupe",
  "sidebar.portfolio.search": "Filtrer les groupes",
  "sidebar.mission.search": "Rechercher une mission…",
  "sidebar.portfolio.filterPlaceholder": "Filtrer les groupes…",
  "sidebar.lens.empty": "Aucune mission dans cette vue pour l'instant.",
  "sidebar.lens.on": "Vue : {{name}}",
  "sidebar.phase.other": "Autres",
  "sidebar.phase.reasoning": "Exploration",
  "sidebar.phase.shaping": "Cadrage",
  "sidebar.phase.building": "Construction",
  "sidebar.phase.steering": "Pilotage",
  "sidebar.product.settings": "Paramètres du produit",
  "sidebar.tree.toggle": "Tâches qui t'attendent : {{title}}",
  "sidebar.tree.group": "Tâches qui t'attendent — {{title}}",
  "sidebar.tree.waitingYou": "t'attend",
  "sidebar.tree.waitingCount": "{{count}} t'attend",
  "sidebar.tree.countLabel_one": "{{count}} tâche t'attend",
  "sidebar.tree.countLabel_other": "{{count}} tâches t'attendent",
  "sidebar.tree.allTickets": "Tous les tickets dans le pane",
  "sidebar.product.addMission": "Nouvelle mission dans ce groupe",
  "sidebar.product.none": "Sans produit",
  "sidebar.filter.label": "Filtrer les missions",
  "sidebar.filter.heading": "Afficher",
  "sidebar.filter.all": "Toutes les missions",
  "sidebar.filter.active": "Actives uniquement",
  "sidebar.filter.activeShort": "Actives",
  "sidebar.filter.clear": "Effacer tous les filtres",
  "breadcrumb.assignProduct": "Ajouter un produit",
  "breadcrumb.changeProduct": "Changer de produit",
  "breadcrumb.productSearch": "Rechercher un groupe…",
  "breadcrumb.productEmpty": "Aucun produit",
  "breadcrumb.productCreate": "Créer « {{name}} »",
  "productSettings.title": "Paramètres",
  "productSettings.back": "Retour aux groupes",
  "productSettings.notFound": "Produit introuvable",
  "productSettings.section.config.title": "Configuration",
  "productSettings.section.config.description": "Nom, couleur et réglages généraux de ce groupe.",
  "productSettings.section.connectors.title": "Connecteurs",
  "productSettings.section.connectors.description": "Sources de données et intégrations propres à ce groupe.",
  "productSettings.section.squad.title": "Squad",
  "productSettings.section.squad.description": "Agents et personnes affectés à ce groupe.",
  "productSettings.section.budget.title": "Budget",
  "productSettings.section.budget.description": "Plafonds de dépense et suivi des coûts des missions de ce groupe.",
  "intake.title": "Par où commencer ?",
  "intake.placeholderTitle": "Nouvelle mission",
  "conductor.advanced": "Avancé",
  "conductor.model": "Modèle de Camille",
  "conductor.effort": "Effort de Camille",
  "conductor.loading": "Chargement des modèles…",
  "conductor.hint": "Choisi à la création. Ensuite, ajuste Camille depuis les réglages par agent de la mission.",
  "intake.launcher.placeholder": "Décris ce sur quoi tu veux travailler, ou pose ta question pour démarrer…",
  "intake.launcher.orPick": "ou choisis un point de départ",
  "intake.launcher.orType": "ou décris ton idée pour démarrer",
  "intake.launcher.start": "Démarrer",
  "intake.group.think": "Réflexion",
  "intake.group.act": "Action",
  "intake.group.operate": "Pilotage",
  "intake.door.idea": "Idée",
  "intake.door.decision": "Décision",
  "intake.door.question": "Question",
  "intake.door.concern": "Concern",
  "intake.door.goal": "Objectif",
  "intake.door.review": "Revue",
  "intake.door.prototype": "Prototype",
  "intake.flavorLabel": "Quel type de prototype ?",
  "intake.flavor.app": "App",
  "intake.flavor.workflow": "Workflow",
  "intake.flavorHint.app": "Vibe-code une petite app pour tester une idée.",
  "intake.flavorHint.workflow": "Vibe-code un workflow — livré comme automation.",
  "intake.door.monitor": "Suivi",
  "intake.door.improve": "Amélioration",
  "intake.door.maintain": "Maintenir",
  "intake.door.advisory": "Conseil",
  "intake.tagline.idea": "J'ai une idée à explorer.",
  "intake.tagline.decision": "Je dois trancher entre des options.",
  "intake.tagline.question": "J'aimerais comprendre un truc.",
  "intake.tagline.concern": "Un truc me tracasse — résolvons-le.",
  "intake.tagline.goal": "Aide-moi à atteindre un objectif.",
  "intake.tagline.review": "J'aimerais un avis d'expert.",
  "intake.tagline.prototype": "Je veux construire un prototype rapide.",
  "intake.tagline.monitor": "Aide-moi à garder mes métriques.",
  "intake.tagline.improve": "J'aimerais améliorer quelque chose.",
  "intake.tagline.maintain": "Aide-moi à maintenir quelque chose.",
  "intake.tagline.advisory": "Conseille-moi en continu.",
  "intake.placeholder.idea": "Quelle est l'idée ?",
  "intake.placeholder.decision": "Que faut-il décider ?",
  "intake.placeholder.question": "Quelle est la question ?",
  "intake.placeholder.concern": "Quel problème veux-tu résoudre ?",
  "intake.placeholder.goal": "Quel est l'objectif ?",
  "intake.placeholder.review": "Qu'est-ce qui doit être revu ?",
  "intake.placeholder.prototype": "Que veux-tu prototyper ?",
  "intake.placeholder.monitor": "Que surveiller ?",
  "intake.placeholder.improve": "Qu'améliorer ?",
  "intake.placeholder.maintain": "Qu'est-ce qu'on fait tourner ? ex. uptime plateforme, support SLA…",
  "intake.placeholder.advisory": "Quel conseil est nécessaire ?",
  "intake.titleLabel": "Titre",
  "intake.back": "Retour",
  "intake.product": "Produit (optionnel)",
  "intake.productNone": "Aucun produit",
  "intake.created": "Élément créé.",
  "intake.error": "Création échouée. Réessayez.",
  "think.attention.title": "À traiter",
  "think.attention.columnTitle": "À traiter",
  "think.attention.pending_one": "{{count}} en attente",
  "think.attention.pending_other": "{{count}} en attente",
  "think.attention.gateSummary": "Gate {{kind}} — signoff requis",
  "think.attention.silenceSummary_one": "Mission silencieuse — aucune activité depuis {{count}} j",
  "think.attention.silenceSummary_other": "Mission silencieuse — aucune activité depuis {{count}} j",
  "think.attention.openThread": "Ouvrir le fil",
  "think.attention.silenceMore_one": "+{{count}} mission silencieuse",
  "think.attention.silenceMore_other": "+{{count}} missions silencieuses",
  "think.attention.silenceLess": "Réduire",
  "think.attention.empty": "Rien ne vous attend — les squads avancent.",
  "think.attention.badge.gate": "gate en attente",
  "think.attention.badge.silence_one": "silencieuse · {{count}} j",
  "think.attention.badge.silence_other": "silencieuse · {{count}} j",
  "think.attention.age.minutes_one": "il y a {{count}} min",
  "think.attention.age.minutes_other": "il y a {{count}} min",
  "think.attention.age.hours_one": "il y a {{count}} h",
  "think.attention.age.hours_other": "il y a {{count}} h",
  "think.attention.age.days_one": "il y a {{count}} j",
  "think.attention.age.days_other": "il y a {{count}} j",
  "think.attention.doorsToggle": "Type",
  "workspace.tabs.label": "Sections du workspace",
  "workspace.tabs.more": "Plus de sections",
  "workspace.tickets.back": "Retour aux tickets",
  "workspace.tickets.working": "{{name}} travaille…",
  "workspace.tickets.workingUnknown": "Un agent travaille…",
  "workspace.tickets.agents": "Agents",
  "workspace.dock.close": "Replier le panneau",
  "workspace.dock.resize": "Redimensionner le panneau",
  "workspace.tickets.checklist.title": "Sous-tâches",
  "workspace.tickets.checklist.progress": "{{done}}/{{total}} terminées",
  "workspace.tickets.checklist.untitled": "Sous-tâche sans titre",
  "workspace.tickets.checklist.state.pending": "À faire",
  "workspace.tickets.checklist.state.in_progress": "En cours",
  "workspace.tickets.checklist.state.done": "Terminée",
  "workspace.tickets.checklist.state.blocked": "Bloquée",
  "workspace.dock.sections": "Sections de la mission",
  "workspace.dock.mcp": "Connexions MCP",
  "workspace.dock.dataSources": "Sources de données",
  "workspace.tickets.chip": "Ouvrir le ticket {{sid}} · {{title}}",
  "champion.title": "Champion",
  "champion.subtitle": "Demandez-moi d'importer un PRD sur le board, ou de montrer le board.",
  "champion.thinking": "{{name}} réfléchit…",
  "champion.sendFailed": "Ton message n'est pas parti — il est conservé ci-dessus.",
  "champion.queued": "Message enregistré. Camille termine une étape en cours et te répond juste après.",
  "champion.refused.budget_exceeded": "Le budget de ce bureau est dépensé. Les nouveaux messages sont refusés jusqu'au {{date}} (UTC), ou jusqu'à l'augmentation du budget dans Consommation.",
  "champion.refused.rate_limited": "Trop de messages en peu de temps. Attends une minute, puis réessaie.",
  "champion.refused.gateway_budget_block": "La limite de dépense de la plateforme est atteinte. Réessayer ne servira à rien ; l'équipe de la plateforme est prévenue.",
  "champion.retry": "Réessayer",
  "champion.autoContinue": "{{name}} continue ({{n}}/{{max}})…",
  "champion.details": "Détails",
  "champion.step.list_blueprints": "lit les blueprints",
  "champion.step.select_blueprint": "choisit un blueprint",
  "champion.step.recommend_squad": "compose l'équipe",
  "champion.step.hire_agent_for_mission": "recrute un agent",
  "champion.step.set_mission_brief": "rédige le brief",
  "champion.step.recategorize_mission": "recatégorise la mission",
  "champion.step.record_decision": "enregistre une décision",
  "champion.step.ask_questions": "prépare des questions",
  "champion.step.request_phase_signoff": "prépare le signoff",
  "champion.step.create_story": "crée une story",
  "champion.step.list_board": "lit le board",
  "champion.step.save_mission_file": "écrit un fichier de mission",
  "champion.step.generic": "travaille",
  "champion.step.advance_phase": "fait avancer la phase",
  "champion.step.list_prds": "lit les PRDs",
  "champion.step.import_prd": "importe un PRD",
  "champion.step.set_conductor_status": "met à jour son statut",
  "champion.step.record_methodology_step": "enregistre une étape de méthode",
  "champion.step.propose_mission_mcp": "propose des sources de données",
  "champion.step.propose_mission_mode": "propose un mode",
  "champion.step.start_build": "lance le build",
  "champion.step.codemode": "consulte les données",
  "champion.step.add_org_node": "ajoute un nœud à l'organigramme",
  "champion.step.analyze_story_retro": "analyse la rétro d'une story",
  "champion.step.answer_agent": "répond à un agent",
  "champion.step.assign_mission_role": "attribue un rôle de mission",
  "champion.step.assign_story": "assigne une story",
  "champion.step.attach_evidence": "joint une preuve",
  "champion.step.configure_agent_inference": "configure le modèle d'un agent",
  "champion.step.confirm_cadrage": "confirme le cadrage",
  "champion.step.connect_mcp": "connecte une source de données",
  "champion.step.create_follow_up_mission": "crée une mission de suite",
  "champion.step.create_squad": "crée l'équipe",
  "champion.step.datasource_list_tools": "liste les outils d'une source de données",
  "champion.step.decline_ui_mock": "décline une maquette",
  "champion.step.get_agent_inference": "lit le modèle d'un agent",
  "champion.step.get_methodology_progress": "vérifie l'avancement de la méthode",
  "champion.step.get_plan": "lit le plan",
  "champion.step.list_criteria": "lit les critères",
  "champion.step.list_data_sources": "liste les sources de données",
  "champion.step.list_mcp_connectors": "liste les connecteurs",
  "champion.step.list_merged_stories": "liste les stories fusionnées",
  "champion.step.list_squad": "lit l'équipe",
  "champion.step.mcp_call": "appelle un outil connecté",
  "champion.step.mcp_list_tools": "liste les outils d'un connecteur",
  "champion.step.post_dojo_judgment": "publie un jugement du dojo",
  "champion.step.propose_office_hire": "propose un recrutement",
  "champion.step.propose_office_release": "propose un départ",
  "champion.step.record_decomposition": "enregistre le découpage",
  "champion.step.reparent_org_node": "déplace un nœud de l'organigramme",
  "champion.step.request_action": "demande une action",
  "champion.step.request_confirmation": "demande une confirmation",
  "champion.step.request_ui_mock": "demande une maquette",
  "champion.step.save_artifact": "enregistre un livrable",
  "champion.step.set_agent_status": "met à jour le statut d'un agent",
  "champion.step.set_delivery_route": "définit la voie de sortie",
  "champion.step.set_stack": "définit la stack",
  "champion.step.set_story_status": "met à jour le statut d'une story",
  "champion.step.set_supervisor": "définit un superviseur",
  "champion.step.submit_plan": "soumet le plan",
  "champion.step.supersede_story": "remplace une story",
  "champion.step.update_dojo_lesson": "met à jour une leçon du dojo",
  "champion.step.update_story_status": "met à jour le statut d'une story",
  "champion.notFound": "Aucun champion sur cette mission.",
  "champion.empty": "Essayez : « importe le PRD-016 » ou « montre le board ».",
  "champion.inputLabel": "Message au champion",
  "champion.placeholder": "Importer un PRD, montrer le board…",
  "champion.intake.subtitle": "Décrivez votre besoin — je le cadre avec vous, puis je pilote la mission.",
  "champion.intake.placeholder": "Décrivez votre besoin…",
  "champion.intake.empty": "Dites-moi ce que vous voulez obtenir : le résultat, les contraintes, l'échéance.",
  "champion.send": "Envoyer",
  "champion.mentionsLabel": "Mentionner un membre de l'équipe",
  "champion.mentionsEmpty": "Aucun résultat.",
  "champion.mentionIntent": "{{name}} répondra à ce message",
  "champion.attach": "Joindre un fichier",
  "champion.uploading": "Envoi…",
  "champion.uploadError": "Échec de l'envoi",
  "champion.removeAttachment": "Retirer {{name}}",
  "champion.recipientLabel": "Destinataire",
  "champion.loadingOlder": "Chargement des messages plus anciens…",
  "champion.request.label": "Demande",
  "champion.request.by": "par @{{author}}",
  "champion.request.issueLink": "Issue GitHub #{{number}}",
  "champion.pins.region": "Messages épinglés",
  "champion.pins.goTo": "Aller au message épinglé",
  "champion.pins.previous": "Aller au message épinglé précédent",
  "champion.pins.next": "Aller au message épinglé suivant",
  "champion.pins.pin": "Épingler le message",
  "champion.pins.unpin": "Désépingler le message",
  "champion.pins.member": "Membre",
  "champion.live.working": "{{name}} travaille — {{what}}",
  "champion.live.workingBare": "{{name}} travaille…",
  "champion.live.waitingYou": "En attente de toi : {{on}}",
  "champion.live.waitingYouBare": "En attente de toi",
  "champion.live.waiting": "{{name}} attend {{owner}} : {{on}}",
  "champion.live.waitingBare": "{{name}} attend {{owner}}",
  "champion.live.blocked": "Bloqué — {{owner}} : {{on}}",
  "champion.live.blockedBare": "Bloqué — {{owner}}",
  "champion.live.you": "toi",
  "champion.live.unknownOwner": "quelqu’un",
  "champion.action.supersedeStory": "Story remplacée (retirée du board)",
  "workspace.phase.reasoning": "Raisonnement",
  "workspace.phase.shaping": "Façonnage",
  "workspace.phase.building": "Construction",
  "workspace.phase.steering": "Pilotage",
  "workspace.phase.advance": "Passer en {{phase}}",
  "workspace.chat.hide": "Masquer le chat",
  "workspace.chat.show": "Chat",
  "workspace.tab.chats": "Chats",
  "workspace.tab.champion": "Champion",
  "workspace.tab.overview": "Vue d'ensemble",
  "workspace.tab.discussions": "Discussions",
  "workspace.tab.brainstorming": "Brainstorming",
  "workspace.tab.inbox": "Inbox",
  "workspace.discussions.title": "Discussions",
  "workspace.discussions.new": "Nouvelle discussion",
  "workspace.discussions.placeholder": "Écrire un message…",
  "workspace.tab.canvas": "Canvas",
  "workspace.tab.sources": "Sources",
  "workspace.tab.verdict": "Verdict",
  "workspace.tab.board": "Board",
  "workspace.tab.backlog": "Stories",
  "workspace.tab.roadmap": "Roadmap",
  "workspace.tab.deliverables": "Livrables",
  "workspace.tab.kpis": "KPIs",
  "workspace.tab.feed": "Conseils",
  "workspace.tab.actions": "Workflows",
  "workspace.tab.activity": "Activite",
  "workspace.tab.connectors": "Connecteurs",
  "workspace.tab.team": "Equipe",
  "workspace.tab.artifacts": "Artefacts",
  "workspace.overview.pipeline": "Pipeline",
  "workspace.overview.phase": "Phase",
  "workspace.overview.currentPhase": "<- en cours",
  "workspace.overview.natureUnlocked": "La nature peut encore etre requalifiee avant le passage en shaping.",
  "workspace.overview.parent": "Lie a",
  "workspace.kpis.building": "Systeme en cours de construction",
  "workspace.kpis.buildingHint": "Les KPIs apparaitront des que le chantier sera release. Voir l'onglet Chantiers actifs.",
  "workspace.kpis.empty": "Pas encore de donnees KPI.",
  "workspace.chantiers.intro": "Chantiers actifs lies a ce suivi.",
  "workspace.chantiers.empty": "Aucun chantier actif pour l'instant.",
  "workspace.nature.label": "Nature",
  "workspace.nature.think": "Think",
  "workspace.nature.act": "Act",
  "workspace.nature.operate": "Operate",
  "workspace.nature.locked": "La nature est verrouillee.",
  "mission.step._shared.framing": "Cadrage",
  "mission.step._shared.go": "Go",
  "mission.step._shared.appetite": "Appétit",
  "mission.step._shared.budget": "Budget",
  "mission.step._shared.scope": "Périmètre",
  "mission.step._shared.bet": "Pari",
  "mission.step._shared.build": "Construire",
  "mission.step._shared.test": "Tester",
  "mission.step._shared.release": "Livrer",
  "mission.step._shared.act": "Agir",
  "mission.step._shared.verdict": "Verdict",
  "mission.step._shared.audit": "Auditer",
  "mission.step._shared.triage": "Triage",
  "mission.step.decision.options": "Options",
  "mission.step.concern.diagnose": "Diagnostiquer",
  "mission.step.prototype.spike": "Spike",
  "mission.step.prototype.demo": "Démo",
  "mission.step.prototype.learn": "Apprendre",
  "mission.step.monitor.metrics": "Indicateurs",
  "mission.step.monitor.instrument": "Instrumenter",
  "mission.step.monitor.alerts": "Alertes",
  "mission.step.improve.experiment": "Expérimenter",
  "mission.step.improve.measure": "Mesurer",
  "mission.step.maintain.inventory": "Inventaire",
  "mission.step.maintain.intake": "Réception",
  "mission.step.advisory.context": "Contexte",
  "mission.step.advisory.observe": "Observer",
  "mission.step.advisory.advising": "Conseil",
  "workspace.tab.memory": "Mémoire",
  "workspace.tab.squad": "Squad",
  "workspace.tab.files": "Fichiers",
  "workspace.squad.stakeholders": "Parties prenantes",
  "workspace.squad.reportsTo": "rend compte à",
  "workspace.squad.lead": "Lead de mission",
  "workspace.squad.permanent": "Permanents",
  "workspace.squad.temporary": "Temporaires",
  "workspace.squad.punctual": "ponctuel",
  "workspace.squad.noTemporary": "Aucun membre temporaire",
  "settings.models.title": "Modèles",
  "settings.models.cardTitle": "Configuration des modèles",
  "settings.models.cardDescription": "Définir le modèle, l'effort, les tokens max et le secours pour chaque rôle.",
  "settings.github.title": "App GitHub",
  "settings.github.connect": "Connecter / ajouter des dépôts",
  "settings.github.connectFailed": "Impossible de démarrer la connexion GitHub.",
  "settings.github.targetAccountLabel": "Organisation ou utilisateur GitHub",
  "settings.github.targetAccountPlaceholder": "ex. mon-org",
  "settings.github.targetAccountInvalid": "Saisissez un identifiant GitHub valide (organisation ou utilisateur).",
  "settings.github.notConfigured": "Non configurée",
  "settings.github.healthy": "Opérationnelle",
  "settings.github.degraded": "Dégradée",
  "settings.github.empty": "Aucune installation GitHub pour l'instant.",
  "settings.github.noMission": "Aucune mission liée",
  "settings.github.linkSaved": "Dépôt lié à la mission.",
  "settings.github.linkFailed": "Impossible de lier ce dépôt.",
  "settings.github.linkArchived": "Lien archivé.",
  "settings.github.addMission": "Ajouter une mission…",
  "settings.github.addMissionTo": "Ajouter une mission à {{repo}}",
  "settings.github.archiveLink": "Archiver le lien",
  "settings.github.archiveMission": "Archiver le lien : {{title}}",
  "settings.github.limitReached": "Limite atteinte ({{count}}/{{limit}}) : archivez le lien d'une mission pour en ajouter une autre.",
  "settings.github.repoBusy": "Ce dépôt exécute déjà {{limit}} missions actives (la limite de votre bureau).",
  "settings.github.missionLimitLabel": "Missions actives par dépôt",
  "settings.github.missionLimitHelp": "Par dépôt : vide = illimité, ou de 1 à {{max}}. Bureau : de 1 à {{officeMax}} (10 par défaut). Au-delà, les nouvelles issues attendent leur tour dans la file du bureau. Baisser une limite n'arrête jamais une mission en cours.",
  "settings.github.missionLimitSave": "Enregistrer la limite",
  "settings.github.missionLimitSaved": "Limite enregistrée.",
  "settings.github.missionLimitFailed": "Impossible d'enregistrer la limite.",
  "settings.github.autoMission": "Démarrer une mission quand un collaborateur ouvre une issue",
  "settings.github.autoMissionSaved": "Réglage enregistré.",
  "settings.github.autoMissionFailed": "Impossible de modifier ce réglage.",
  "settings.github.inboundTitle": "Livraisons récentes",
  "settings.github.pending": "en attente",
  "settings.github.replay": "Rejouer",
  "settings.github.replayed": "Livraison rejouée.",
  "settings.github.replayFailed": "Échec du rejeu.",
  "settings.github.never": "jamais",
  "settings.github.justNow": "à l'instant",
  "settings.github.minutesAgo": "il y a {{count}} min",
  "settings.github.hoursAgo": "il y a {{count}} h",
  "settings.github.daysAgo": "il y a {{count}} j",
  "settings.githubTriage.title": "Triage des issues",
  "settings.githubTriage.description": "Propositions uniquement : rien n'est planifié, fermé ni modifié. Acceptez une proposition, ou marquez-la corrigée quand vous changez ses labels.",
  "settings.githubTriage.empty": "Aucune issue triée pour l'instant. Posez le label nova:triage sur une issue, ou commentez /nova triage sur n'importe quelle issue.",
  "settings.githubTriage.colIssue": "Issue",
  "settings.githubTriage.colLabels": "Labels proposés",
  "settings.githubTriage.colNext": "Prochaine action",
  "settings.githubTriage.colCost": "Coût",
  "settings.githubTriage.colStatus": "Statut",
  "settings.githubTriage.colDecision": "Jugement",
  "settings.githubTriage.statusFilter": "Statut",
  "settings.githubTriage.statusAll": "Tous",
  "settings.githubTriage.status.running": "En cours",
  "settings.githubTriage.status.proposed": "Proposé",
  "settings.githubTriage.status.accepted": "Accepté",
  "settings.githubTriage.status.corrected": "Corrigé",
  "settings.githubTriage.status.superseded": "Remplacé",
  "settings.githubTriage.status.failed": "Échec",
  "settings.githubTriage.next.plan": "Prêt à planifier",
  "settings.githubTriage.next.needs_info": "Infos manquantes",
  "settings.githubTriage.next.duplicate": "Doublon",
  "settings.githubTriage.next.human": "À voir par un humain",
  "settings.githubTriage.next.defer": "Reporté",
  "settings.githubTriage.accept": "Accepter",
  "settings.githubTriage.correct": "Marquer corrigé",
  "settings.githubTriage.decisionSaved": "Décision enregistrée.",
  "settings.githubTriage.decisionFailed": "Impossible d'enregistrer la décision.",
  "settings.githubTriage.loadMore": "Voir plus",
  "settings.githubTriage.loadFailed": "Impossible de charger la liste de triage.",
  "settings.githubTriage.spentToday": "Dépensé aujourd'hui : {{amount}}",
  "settings.githubTriage.spentTodayCap": "Dépensé aujourd'hui : {{amount}} sur {{cap}}",
  "settings.githubTriage.acceptanceRate": "Acceptés sans changement : {{rate}}",
  "settings.githubTriage.pending": "{{count}} à revoir",
  "settings.githubTriage.failedWith": "Échec ({{code}})",
  "settings.github.outcome.connected": "App GitHub connectée.",
  "settings.github.outcome.updated": "Installation GitHub mise à jour.",
  "settings.github.outcome.requested": "Demande d'installation envoyée — un propriétaire de l'organisation doit l'approuver.",
  "settings.github.outcome.connected_partial": "Connectée, mais la liste des dépôts n'a pas encore pu être actualisée.",
  "settings.githubIdentity.title": "Identité GitHub",
  "settings.githubIdentity.subtitle": "Liez votre propre compte GitHub pour que les commandes /nova que vous postez sur GitHub soient reconnues comme les vôtres.",
  "settings.githubIdentity.linked": "Lié en tant que @{{login}}",
  "settings.githubIdentity.notLinked": "Non lié",
  "settings.githubIdentity.verifiedVia.oauth": "OAuth",
  "settings.githubIdentity.verifiedVia.claim": "Revendiqué",
  "settings.githubIdentity.verifiedVia.manual": "Manuel (affichage seulement — n'autorise jamais de commande)",
  "settings.githubIdentity.link": "Lier GitHub",
  "settings.githubIdentity.linkFailed": "Impossible de démarrer la liaison GitHub.",
  "settings.githubIdentity.unlink": "Délier",
  "settings.githubIdentity.unlinked": "Identité GitHub déliée.",
  "settings.githubIdentity.unlinkFailed": "Impossible de délier.",
  "settings.githubIdentity.claimInstead": "Impossible de lier maintenant ? Revendiquez depuis un commentaire à la place.",
  "settings.githubIdentity.claimLoginLabel": "Votre identifiant GitHub",
  "settings.githubIdentity.claimSubmit": "Obtenir une commande de revendication",
  "settings.githubIdentity.claimFailed": "Impossible de créer une revendication.",
  "settings.githubIdentity.claimTooMany": "Trop de revendications en attente — attendez l'expiration de l'une d'elles, ou utilisez-en une déjà émise.",
  "settings.githubIdentity.claimCommand": "Collez ceci en commentaire sur GitHub, depuis @{{login}} :",
  "settings.githubIdentity.copy": "Copier",
  "settings.githubIdentity.copied": "Copié.",
  "settings.githubOnboarding.title": "Connecter un dépôt",
  "settings.githubOnboarding.subtitle": "Installez l'App, liez un dépôt, mergez la PR de bootstrap, puis lancez une mission avec /nova plan.",
  "settings.githubOnboarding.guideLink": "Guide (10 minutes)",
  "settings.githubOnboarding.checklist.app_installed": "App installée",
  "settings.githubOnboarding.checklist.repo_linked": "Dépôt lié",
  "settings.githubOnboarding.checklist.bootstrap_merged": "PR de bootstrap mergée",
  "settings.githubOnboarding.checklist.first_plan": "Premier plan",
  "settings.githubOnboarding.action.install_app": "Installer l'App",
  "settings.githubOnboarding.action.configure_url": "Ouvrir les réglages GitHub",
  "settings.githubOnboarding.action.restart_install": "Terminer l'autorisation",
  "settings.githubOnboarding.action.retry": "Réessayer",
  "settings.githubOnboarding.action.view_pr": "Voir la PR",
  "settings.githubOnboarding.action.guide_labels": "Pourquoi ?",
  "settings.githubOnboarding.action.link_identity": "Lier votre identité GitHub",
  "settings.githubOnboarding.action.continue_import": "Continuer l'import",
  "settings.githubOnboarding.action.connect_repo": "Connecter",
  "settings.githubOnboarding.action.open_bootstrap_pr": "Ouvrir la PR de bootstrap",
  "settings.githubOnboarding.action.review_pr": "Relire et merger la PR #{{number}}",
  "settings.githubOnboarding.action.comment_plan": "Commenter /nova plan sur une issue",
  "settings.githubOnboarding.action.open_mission": "Ouvrir la mission",
  "settings.githubOnboarding.code.app_not_installed.message": "L'App GitHub de NovaTechnica n'est pas installée pour cet Office.",
  "settings.githubOnboarding.code.app_suspended.message": "L'App est suspendue.",
  "settings.githubOnboarding.code.app_deleted.message": "L'App a été désinstallée.",
  "settings.githubOnboarding.code.app_pending.message": "L'installation attend votre autorisation GitHub.",
  "settings.githubOnboarding.code.repo_inaccessible.message": "L'App ne peut pas accéder à {{repo}}.",
  "settings.githubOnboarding.code.bootstrap_in_progress.message": "Un bootstrap est déjà en cours.",
  "settings.githubOnboarding.code.bootstrap_timeout.message": "Le dernier bootstrap ne s'est pas terminé.",
  "settings.githubOnboarding.code.already_merged.message": "Déjà bootstrappé — la PR #{{number}} a été mergée.",
  "settings.githubOnboarding.code.default_branch_up_to_date.message": "Rien à ajouter : la branche par défaut a déjà les fichiers NovaTechnica.",
  "settings.githubOnboarding.code.labels_fallback.message": "Types/champs d'issue indisponibles ici : statut, phase et priorité utilisent des labels.",
  "settings.githubOnboarding.code.closed_unmerged.message": "La PR #{{number}} a été fermée sans être mergée.",
  "settings.githubOnboarding.code.bootstrap_branch_foreign.message": "Une branche nova/bootstrap existe et n'a pas été créée par NovaTechnica.",
  "settings.githubOnboarding.code.repo_empty.message": "Le dépôt n'a encore aucun commit.",
  "settings.githubOnboarding.code.github_forbidden.message": "GitHub a refusé l'écriture (dépôt archivé, règle de branche sur nova/* ?).",
  "settings.githubOnboarding.code.mint_refused.message": "Le service de jetons a refusé la demande.",
  "settings.githubOnboarding.code.rate_limited.message": "Limite de taux GitHub atteinte.",
  "settings.githubOnboarding.code.identity_unlinked.message": "/nova plan sera refusé : votre compte GitHub n'est pas lié.",
  "settings.githubOnboarding.code.onboarding_unavailable.message": "Le service d'onboarding n'est pas disponible dans cet environnement.",
  "settings.githubOnboarding.code.import_partial.message": "{{mirrored}}/{{found}} missions existantes importées.",
  "settings.githubOnboarding.picker.title": "Dépôts",
  "settings.githubOnboarding.picker.empty": "Aucun dépôt disponible pour le moment.",
  "settings.githubOnboarding.picker.linked": "Lié",
  "settings.githubOnboarding.picker.private": "Privé",
  "settings.githubOnboarding.picker.public": "Public",
  "settings.githubOnboarding.import.inProgress": "Import des missions existantes… {{mirrored}}/{{found}}",
  "settings.githubOnboarding.import.done": "{{mirrored}} missions importées.",
  "settings.githubOnboarding.import.skippedTitle": "Non importées",
  "settings.githubOnboarding.import.skipReason.mid_unavailable": "une autre mission utilise déjà cet identifiant",
  "settings.githubOnboarding.import.skipReason.sync_dir_missing": "le dossier est introuvable à la tête actuelle du dépôt",
  "settings.githubOnboarding.import.skipReason.sync_dir_ambiguous": "plusieurs dossiers de .missions/ correspondent à cet identifiant",
  "settings.githubOnboarding.import.skipReason.sync_ref_missing": "la branche n'a pas pu être lue",
  "settings.githubOnboarding.import.skipReason.sync_tree_truncated": "l'arborescence du dépôt est trop grande pour être lue en une requête",
  "settings.githubOnboarding.import.skipReason.sync_failed": "erreur temporaire — Continuer l'import réessaiera",
  "settings.githubOnboarding.import.skipReason.unknown": "n'a pas pu être importé",
  "settings.githubOnboarding.state.no_app": "Installez l'App pour commencer.",
  "settings.githubOnboarding.state.app_installed": "Choisissez un dépôt à connecter.",
  "settings.githubOnboarding.state.repo_inaccessible": "Accordez à l'App l'accès à ce dépôt.",
  "settings.githubOnboarding.state.linked": "Ouvrez la PR de bootstrap.",
  "settings.githubOnboarding.state.bootstrapping": "Ouverture de la PR de bootstrap…",
  "settings.githubOnboarding.state.pr_open": "Relisez et mergez la PR #{{number}}.",
  "settings.githubOnboarding.state.bootstrapped": "Commentez /nova plan sur une issue.",
  "settings.githubOnboarding.state.planned": "Terminé — ouvrir la mission {{title}}.",
  "models.title": "Modèles",
  "models.subtitle": "Défauts de modèle par rôle, pour tout le bureau.",
  "models.precedence": "Ce sont les défauts du bureau pour chaque rôle. Ils sont surchargeables par le profil d'un agent, puis par une mission.",
  "models.precedence.agentsLink": "Voir les profils d'agents",
  "models.precedence.missionsLink": "Voir les missions",
  "models.tabs.label": "Rôles par étape",
  "models.tab.transverse": "Transverse",
  "models.empty": "Aucun rôle pour cette étape.",
  "models.card.default": "Défaut",
  "models.card.custom": "Personnalisé",
  "models.card.configure": "Configurer",
  "models.card.chip.effort": "Effort : {{effort}}",
  "models.card.chip.maxTokens": "Tokens max : {{value}}",
  "models.card.chip.fallback": "Secours : {{model}}",
  "models.provider.anthropic": "Anthropic",
  "models.provider.workersAi": "Workers AI",
  "models.role.account-manager.purpose": "Conversation et pilotage de la mission.",
  "models.role.chief-of-staff.purpose": "Rythme opérationnel et déblocages transverses.",
  "models.role.architect.purpose": "Cadrage, spec et décisions structurantes.",
  "models.role.product-manager.purpose": "Priorisation produit et arbitrages de scope.",
  "models.role.backend-engineer.purpose": "Écriture du code et des tests.",
  "models.role.frontend-engineer.purpose": "Écriture du code et des tests (frontend).",
  "models.role.reviewer.purpose": "Relecture critique et verdict.",
  "models.role.security-reviewer.purpose": "Relecture critique et verdict (sécurité).",
  "models.role.tester.purpose": "Exécution et analyse des tests.",
  "models.role.shaper.purpose": "Transformer une intention floue en action structurée.",
  "models.role.analyst.purpose": "Analyse, synthèse du signal et recherche.",
  "models.dialog.title": "Configurer {{role}}",
  "models.dialog.description": "Réglage pour tout le bureau — s'applique à tous les agents avec ce rôle, sauf override plus spécifique.",
  "models.dialog.model": "Modèle",
  "models.dialog.effort": "Effort de raisonnement",
  "models.dialog.maxTokens": "Tokens max",
  "models.dialog.maxTokensHint": "Entre {{min}} et {{max}}.",
  "models.params.thinking.always": "Raisonnement toujours actif",
  "models.params.thinking.optional": "Raisonnement activable",
  "models.params.thinking.adaptive": "Raisonnement adaptatif",
  "models.params.maxOutput": "Sortie max : {{value}} tokens ({{min}} – {{max}})",
  "models.params.maxOutputDefault": "Sortie max (défaut) : {{value}} tokens ({{min}} – {{max}})",
  "models.params.temperature": "Température : défaut du modèle ({{default}}, plage {{min}}–{{max}})",
  "models.params.noEffort": "Pas de réglage d'effort pour ce modèle",
  "models.dialog.fallback": "Modèle de secours",
  "models.unavailable": "indisponible",
  "models.dialog.fallbackNone": "Aucun",
  "models.dialog.systemDefault": "Défaut système : {{value}}",
  "models.dialog.reset": "Réinitialiser",
  "models.dialog.save": "Enregistrer",
  "models.dialog.saving": "Enregistrement…",
  "models.dialog.saved": "Configuration enregistrée",
  "models.dialog.resetDone": "Réinitialisé au défaut",
  "models.providerPanels.platform.title": "Modèles plateforme",
  "models.providerPanels.platform.description": "Exécutés via Anthropic (AI Gateway) — sélectionnables pour tous les rôles.",
  "models.providerPanels.platform.empty": "Aucun modèle exécutable pour l'instant.",
  "models.providerPanels.byok.title": "BYOK (votre propre clé)",
  "models.providerPanels.byok.description": "Configuré aujourd'hui via la variable plateforme AI_GATEWAY_TOKEN.",
  "models.providerPanels.byok.body": "Le BYOK par bureau n'est pas encore disponible — prévu pour une itération ultérieure.",
  "workspace.champion.action.modelFallback": "Modèle de secours : {{from}} → {{to}}",
  "workspace.champion.action.toolRefused": "Refusé : {{tool}} ({{code}})",
  "workspace.champion.action.attachmentsOmitted_one": "{{count}} pièce jointe non lue : {{model}} ne lit pas les images ni les PDF",
  "workspace.champion.action.attachmentsOmitted_other": "{{count}} pièces jointes non lues : {{model}} ne lit pas les images ni les PDF",
  "mcp.title": "Connexions MCP",
  "mcp.subtitle": "Serveurs branchés au niveau de l'office et partagés par toutes ses missions. Connecte-en un ici — ou demande à Camille.",
  "mcp.status.active": "Actif",
  "mcp.status.inactive": "Non connecté",
  "mcp.action.connect": "Connecter",
  "mcp.action.reconnect": "Reconnecter",
  "mcp.action.disconnect": "Déconnecter",
  "mcp.action.cancel": "Annuler",
  "mcp.auth.pat": "Token personnel (PAT)",
  "mcp.auth.oauth": "OAuth · écran de consentement",
  "mcp.token.placeholder": "Coller un token (PAT)",
  "mcp.token.inputLabel": "Token d'accès personnel {{server}}",
  "mcp.toast.connectStartError": "Impossible de démarrer la connexion MCP.",
  "mcp.toast.connected": "{{name}} connecté",
  "mcp.toast.connectTokenError": "Impossible de connecter — vérifie le token.",
  "mcp.toast.disconnected": "{{name}} déconnecté",
  "mcp.toast.disconnectError": "Impossible de déconnecter.",
  "mcp.toast.customError": "Impossible d'enregistrer ce serveur.",
  "mcp.toast.selectionError": "Impossible d'enregistrer la sélection MCP.",
  "mcp.toast.oauthError": "Connexion MCP échouée : {{reason}}",
  "mcp.chip.proposed": "MCP proposé : {{list}}",
  "mcp.chip.proposedEmpty": "MCP proposé",
  "mcp.custom.add": "Serveur personnalisé",
  "mcp.custom.title": "Ajouter un serveur personnalisé",
  "mcp.custom.pocNotice": "Fonctionnalité POC — cible d'egress sortant, usage interne uniquement.",
  "mcp.custom.slugLabel": "Identifiant",
  "mcp.custom.slugPlaceholder": "mon-serveur",
  "mcp.custom.labelLabel": "Nom",
  "mcp.custom.labelPlaceholder": "Mon serveur",
  "mcp.custom.urlLabel": "URL (https)",
  "mcp.custom.urlPlaceholder": "https://mon-serveur.example.com/mcp",
  "mcp.custom.authLabel": "Authentification",
  "mcp.custom.authPat": "Token (PAT)",
  "mcp.custom.authNone": "Aucune",
  "mcp.custom.submit": "Enregistrer",
  "mcp.mission.heading": "Sélection pour cette mission",
  "mcp.mission.curated": "Sélection personnalisée active — seuls les serveurs cochés sont utilisables.",
  "mcp.mission.notCurated": "Aucune sélection : tous les connecteurs actifs de l'office sont utilisables.",
  "mcp.mission.checkboxLabel": "Activer {{name}} pour cette mission",
  "mcp.mission.save": "Enregistrer",
  "mcp.mission.reset": "Revenir au réglage de l'office",
  "mcp.mission.resetting": "Réinitialisation…",
  "mcp.toast.resetSuccess": "Sélection réinitialisée — cette mission suit maintenant le réglage de l'office.",
  "mcp.toast.resetError": "Impossible de réinitialiser la sélection MCP.",
  "mcp.card.title": "Serveurs MCP proposés",
  "mcp.card.empty": "Aucun serveur au catalogue.",
  "mcp.card.confirm": "Confirmer la sélection",
  "mcp.card.confirming": "Enregistrement…",
  "mcp.card.receiptSelected": "Sélection MCP enregistrée : {{list}}",
  "mcp.card.receiptEmpty": "Sélection MCP enregistrée : aucun serveur",
  "missionDataSources.heading": "Sources de données de la mission",
  "missionDataSources.intro": "Choisis les sources que cette mission peut consulter. La connexion elle-même se fait dans Réglages → Sources de données ; ici tu autorises leur usage pour cette mission.",
  "missionDataSources.readonlyNotice": "Seuls le point de contact et l'admin d'agence peuvent modifier cette sélection.",
  "missionDataSources.save": "Enregistrer",
  "missionDataSources.saving": "Enregistrement…",
  "missionDataSources.toast.selectionSaved": "Sélection mise à jour.",
  "missionDataSources.toast.selectionError": "Impossible d'enregistrer la sélection des sources de données.",
  "missionDataSources.selection.readLabel": "{{name}} — autorisée pour cette mission",
  "missionDataSources.selection.writeLabel": "{{name}} — autoriser l'écriture",
  "missionDataSources.selection.writeHint": "Lire consulte vos données ; écrire peut les modifier (envoyer une campagne, changer un prix…). La première écriture de cette mission devra être approuvée dans le fil.",
  "missionDataSources.selection.notUsable": "Autorisée — à connecter",
  "missionDataSources.legacy.heading": "Connecteurs directs (hérités)",
  "missionDataSources.card.title": "Sources de données proposées",
  "missionDataSources.card.empty": "Aucune source publiée pour cet office.",
  "missionDataSources.card.confirm": "Confirmer la sélection",
  "missionDataSources.card.confirming": "Enregistrement…",
  "missionDataSources.card.receiptSelected": "Sources sélectionnées : {{list}}",
  "missionDataSources.card.receiptEmpty": "Sources sélectionnées : aucune",
  "missionDataSources.card.receiptFlag": "à connecter",
  "missionDataSources.card.connectByPoc": "À connecter par le point de contact",
  "missionDataSources.card.obsolete": "Proposition de connecteurs directs — remplacée par les sources de données",
  "missionDataSources.chip.listed": "Sources : {{list}}",
  "missionDataSources.chip.listedEmpty": "Sources : aucune",
  "missionDataSources.chip.proposed": "Sources proposées : {{list}}",
  "missionDataSources.chip.proposedEmpty": "Sources proposées",
  "dataSources.title": "Sources de données",
  "dataSources.intro": "Connecte les outils que tu utilises déjà — Google Analytics, Shopify, Klaviyo — pour que ton équipe NovaTechnica travaille sur tes vrais chiffres, pas des suppositions. Tu gardes la main : chaque connexion peut être révoquée à tout moment.",
  "nav.connections": "Connexions",
  "connections.title": "Connexions",
  "connections.intro": "Branche ici tes sources de données et tes outils. Tes clés ne transitent jamais par NovaTechnica.",
  "connections.dataSources.title": "Sources de données",
  "connections.dataSources.intro": "Les données de ton activité que tes agents peuvent lire, mission par mission.",
  "connections.dataSources.searchLabel": "Rechercher une source",
  "connections.dataSources.searchPlaceholder": "Shopify, Odoo, Google Analytics…",
  "connections.dataSources.connected": "Connectées",
  "connections.dataSources.catalogue": "Catalogue",
  "connections.dataSources.showMore": "Afficher plus",
  "connections.dataSources.emptySearch": "Aucune source ne correspond à « {{query}} ».",
  "connections.tooling.title": "Outils",
  "connections.tooling.intro": "Les outils de build et d'exploitation : code, déploiement, erreurs, design.",
  "connections.tooling.notUsedYet": "Connecté au niveau de l'office — pas encore utilisé par les agents.",
  "connections.settingsLink.title": "Connexions",
  "connections.settingsLink.description": "Sources de données, GitHub et outils.",
  "dataSources.toast.pending": "La source est en cours de préparation, réessaie dans un instant.",
  "dataSources.toast.cap": "Trop de nouvelles sources aujourd'hui pour cet office. Réessaie demain.",
  "dataSources.status.connected": "Connecté",
  "dataSources.status.pending": "En attente",
  "dataSources.status.reconnect": "Reconnexion nécessaire",
  "dataSources.status.notConnected": "Non connecté",
  "dataSources.shop.label": "Nom de la boutique",
  "dataSources.shop.placeholder": "ma-boutique",
  "dataSources.shop.helper": "ma-boutique.myshopify.com — la partie avant .myshopify.com",
  "dataSources.shop.invalid": "Saisis le nom de ta boutique, comme ma-boutique (pas une adresse e-mail).",
  "dataSources.badge.managed": "Connexion directe",
  "dataSources.badge.apiKey": "Clé API requise",
  "dataSources.badge.apiKeyHint": "Tu colleras ta propre clé sur une page sécurisée — elle ne transite jamais par NovaTechnica.",
  "dataSources.action.connect": "Connecter",
  "dataSources.action.reconnect": "Reconnecter",
  "dataSources.action.disconnect": "Déconnecter",
  "dataSources.action.disconnectConfirm": "Confirmer la déconnexion",
  "dataSources.action.connectNamed": "Connecter {{name}}",
  "dataSources.action.reconnectNamed": "Reconnecter {{name}}",
  "dataSources.action.retry": "Réessayer",
  "dataSources.action.retryNamed": "Relancer la connexion à {{name}}",
  "dataSources.action.disconnectNamed": "Déconnecter {{name}}",
  "dataSources.action.disconnectConfirmNamed": "Confirmer la déconnexion de {{name}}",
  "dataSources.toast.notConfigured": "Les sources de données ne sont pas encore activées pour ton office.",
  "dataSources.toast.gone": "Cette source de données n'est plus disponible.",
  "dataSources.toast.alreadyConnected": "Cette source de données est déjà connectée.",
  "dataSources.action.cancel": "Annuler",
  "dataSources.toast.connectStartError": "Impossible de démarrer la connexion.",
  "dataSources.toast.connected": "Source de données connectée",
  "dataSources.toast.connectReturnError": "La connexion n'a pas pu être finalisée.",
  "dataSources.toast.disconnected": "Source de données déconnectée",
  "dataSources.toast.disconnectError": "Impossible de déconnecter.",
  "dataSources.state.notConfigured.title": "Pas encore configuré",
  "dataSources.state.notConfigured.description": "Ton équipe NovaTechnica n'a pas encore activé cette fonctionnalité pour ton office. Demande à ton contact d'activer les sources de données.",
  "dataSources.state.empty": "Aucune source de données disponible pour l'instant — c'est NovaTechnica qui déclare celles proposées à ton office.",
  "dataSources.state.error.title": "Les sources de données sont temporairement indisponibles",
  "dataSources.state.error.nonPoc": "Demande au point de contact de ton office de se pencher sur le sujet.",
  "charts.aria.workloadUtilization": "Graphique en barres : taux d'utilisation de la capacité par membre",
  "charts.aria.workloadComparison": "Graphique en barres : heures allouées et capacité par membre",
  "charts.workload.capacityRuleNote": "Ligne pointillée = 100 % de la capacité",
  "charts.aria.statusDoughnut": "Graphique en anneau : tâches par statut",
  "charts.aria.doughnut": "Graphique en anneau : répartition {{label}}",
  "charts.aria.costByMission": "Graphique en barres : coût estimé et coût réel par mission",
  "charts.aria.priorityBars": "Graphique en barres : tâches par priorité",
  "charts.aria.countBars": "Graphique en barres : nombre de {{unit}} par groupe",
  "charts.aria.hoursBars": "Graphique en barres : heures enregistrées",
  "charts.aria.estimatedVsActualBars": "Graphique en barres : heures estimées et réelles",
  "questionSlides.title": "Question",
  "questionSlides.multiHint": "Plusieurs réponses possibles.",
  "questionSlides.otherLabel": "Autre réponse",
  "questionSlides.otherPlaceholder": "Autre / précision…",
  "questionSlides.prev": "Précédent",
  "questionSlides.next": "Suivant",
  "questionSlides.submit": "Envoyer les réponses",
  "questionSlides.answered": "Répondu",
  "questionSlides.superseded": "Remplacée par une question plus récente",
  "questionSlides.counter": "{{n}} / {{total}}",
  "questionSlides.missing": "Il manque une réponse à la question {{n}}",
  "questionSlides.goTo": "Aller à la question {{n}}",
  "delivery.liveTitle": "Votre app est en ligne",
  "delivery.deployingTitle": "Mise en ligne de votre app",
  "delivery.deployingBody": "Cela prend en général quelques minutes. L'adresse apparaît ici dès qu'elle est prête.",
  "delivery.failedTitle": "La mise en ligne n'a pas abouti",
  "delivery.failedBody": "La version déjà en ligne n'a pas été modifiée. Vous pouvez réessayer.",
  "delivery.retry": "Réessayer",
  "delivery.retryFailed": "Impossible de relancer. Réessayez dans un instant.",
  "delivery.copy": "Copier l'adresse",
  "delivery.copied": "Copié",
  "delivery.copiedAnnounce": "Adresse copiée",
  "delivery.lastDeploy": "Dernière mise à jour",
  "delivery.version": "Version",
  "delivery.unknown": "Inconnue",
  "delivery.lastFailed": "La dernière mise à jour n'est pas passée en ligne. La version précédente continue de tourner.",
  "delivery.exportGithub": "Exporter vers GitHub",
  "delivery.exported": "Exporté vers {{repo}}.",
  "delivery.exportNeedsInstall": "Connectez d'abord GitHub, depuis les réglages de l'office.",
  "delivery.exportNeedsAccess": "GitHub attend votre accord pour continuer. Ouvrez les réglages GitHub de cet office.",
  "delivery.exportFailed": "Export impossible. Réessayez dans un instant.",
  "delivery.claim": "Récupérer mon compte",
  "branches.title": "Builds par branche",
  "branches.subtitle": "Chaque push construit sa branche. Chaque branche autre que main a sa propre preview privée.",
  "branches.status.building": "En construction",
  "branches.status.deployed": "Preview prête",
  "branches.status.built": "Construite — prête à mettre en ligne",
  "branches.status.failed": "Échec",
  "branches.status.failedAt": "Échec à l’étape {{step}}",
  "branches.status.superseded": "Remplacée par un push plus récent",
  "branches.status.skipped_budget": "Ignorée — budget atteint",
  "branches.status.blocked": "En attente du contrôle de la maquette",
  "branches.status.torn_down": "Preview supprimée",
  "branches.kind.main": "main",
  "branches.kind.story": "story",
  "branches.kind.other": "branche",
  "branches.open": "Ouvrir la preview",
  "branches.cost": "Coût du build",
  "branches.version": "Version",
  "branches.deleted": "supprimée",
  "claim.title": "Récupérer mon compte",
  "claim.intro": "Transférez votre app vers un compte qui vous appartient. Tant que vous n'avez pas confirmé, elle reste en ligne ici.",
  "claim.close": "Fermer",
  "claim.optionsLabel": "Comment voulez-vous recevoir votre app ?",
  "claim.oauthTitle": "Utiliser mon compte Cloudflare",
  "claim.oauthBody": "Vous vous connectez à Cloudflare et autorisez l'accès une fois. Votre app et toutes ses données sont copiées sur votre compte.",
  "claim.oauthStart": "Connecter mon compte Cloudflare",
  "claim.tempTitle": "Me créer un nouveau compte Cloudflare",
  "claim.tempBody": "Un nouveau compte est préparé avec votre app. Vous avez ensuite 60 minutes pour le réclamer. Votre app démarre avec une base de données vide.",
  "claim.tempUnavailable": "Indisponible pour cette app : elle utilise des fonctions qu'un nouveau compte ne propose pas.",
  "claim.tosLabel": "J'accepte les <tos>Conditions d'utilisation</tos> et la <privacy>Politique de confidentialité</privacy> de Cloudflare.",
  "claim.tosNew": "(s'ouvre dans un nouvel onglet)",
  "claim.tempStart": "Créer mon compte",
  "claim.noneAvailable": "La récupération n'est pas disponible pour cette app.",
  "claim.consentTitle": "En attente de votre autorisation sur Cloudflare",
  "claim.consentBody": "Terminez la connexion sur la page Cloudflare. Si vous l'avez fermée, annulez et recommencez.",
  "claim.chooseTitle": "Choisissez le compte qui recevra votre app",
  "claim.chooseContinue": "Transférer mon app vers ce compte",
  "claim.migratingTitle": "Transfert de votre app et de ses données",
  "claim.migratingBody": "Cela peut prendre quelques minutes. Votre app reste en ligne ici pendant ce temps.",
  "claim.deployedTitle": "Votre app est prête sur votre compte",
  "claim.deployedBody": "Vérifiez qu'elle fonctionne à sa nouvelle adresse. Quand vous confirmez, nous arrêtons de l'héberger ici et l'ancienne adresse renvoie vers la nouvelle.",
  "claim.newAddress": "Nouvelle adresse",
  "claim.confirm": "Confirmer et arrêter l'hébergement ici",
  "claim.preparingTitle": "Préparation de votre nouveau compte",
  "claim.preparingBody": "Cela prend un instant. Gardez cette page ouverte.",
  "claim.linkTitle": "Votre compte est prêt à être réclamé",
  "claim.linkBody": "Ouvrez le lien, inscrivez-vous ou connectez-vous à Cloudflare, puis réclamez le compte.",
  "claim.linkOpen": "Réclamer le compte",
  "claim.linkWarning": "Ce lien n'est affiché qu'une fois et seulement à vous. Ne le partagez pas : quiconque l'ouvre obtient le compte.",
  "claim.linkExpires": "Réclamez avant {{time}}.",
  "claim.claimedConfirm": "Je l'ai réclamé",
  "claim.linkGoneTitle": "En attente de votre réclamation",
  "claim.linkGoneBody": "Le lien de réclamation n'a été affiché qu'une fois. Si vous ne l'avez pas utilisé, recommencez pour en obtenir un nouveau.",
  "claim.startOver": "Recommencer",
  "claim.expiredTitle": "Le lien de réclamation a expiré",
  "claim.expiredBody": "Le compte n'a pas été réclamé à temps. Vous pouvez en créer un nouveau.",
  "claim.failedTitle": "Le transfert n'a pas abouti",
  "claim.failedBody": "Rien n'a changé : votre app est toujours en ligne ici. Vous pouvez réessayer.",
  "claim.declined": "L'accès n'a pas été autorisé sur Cloudflare. Rien n'a changé.",
  "claim.doneTitle": "Votre app vit désormais sur votre compte",
  "claim.doneBody": "Nous ne l'hébergeons plus et n'avons plus accès à votre compte. Toute mise à jour ultérieure demandera à nouveau votre autorisation.",
  "claim.cancel": "Annuler",
  "claim.error": "Une erreur est survenue. Réessayez dans un instant.",
  "claim.working": "En cours…",
  "build.title": "Build",
  "build.agentConfig.platform": "Agents : plateforme (composés par la plateforme, montés en lecture seule dans le sandbox)",
  "build.agentConfig.plugin": "Agents : plugin ({{reason}})",
  "build.notStarted": "Build pas encore lancé — aucun code ne tourne pour cette mission.",
  "build.repoLabel": "Dépôt",
  "build.start": "Lancer le build",
  "build.noRepo": "Aucun dépôt connecté à cet office.",
  "build.connectRepo": "Connecter un dépôt (Paramètres → GitHub)",
  "build.planPending": "Plan : en attente de votre validation",
  "build.mockHolds.title": "En attente d'une maquette non validée",
  "build.mockHolds.line": "{{sids}} attend(ent) la maquette {{mock}} : le build ne les lance pas tant qu'elle n'est pas validée.",
  "build.mockHolds.hint": "Elle se valide d'elle-même quand vous cochez « J'ai vérifié » sur la PR de la maquette puis la mergez depuis le Studio.",
  "build.mockHolds.lift": "Lever l'attente — maquette {{mock}}",
  "build.mockHolds.reason": "Pourquoi lever l'attente ? (10 à 200 caractères, journalisé)",
  "build.mockHolds.reasonPlaceholder": "Ex. maquette vérifiée sur la preview et mergée",
  "build.mockHolds.confirm": "Confirmer",
  "build.mockHolds.cancel": "Annuler",
  "build.mockHolds.done": "Attente levée : les stories reprennent au prochain passage du moteur.",
  "build.mockHolds.error": "La levée de l'attente a échoué ({{code}}).",
  "build.mockHolds.unreadable": "Une maquette de ce build est illisible : le moteur bloque les stories qui en dépendent.",
  "build.openGate": "Voir le gate",
  "build.status.executing": "Build en cours",
  "build.status.review": "En revue",
  "build.status.done": "Livré",
  "build.status.paused": "En pause",
  "build.status.archived": "Abandonnée",
  "build.attention.title": "Étape « {{step}} » arrêtée",
  "build.attention.attempt": "tentative {{attempt}}",
  "build.attention.storyLine": "{{sid}} · {{step}} · tentative {{attempt}} — {{reason}}",
  "build.attention.retryStory": "Relancer {{sid}}",
  "build.attention.outcome.failed": "en échec",
  "build.attention.outcome.needs_human": "attend une décision humaine",
  "build.attention.outcome.blocked": "bloquée",
  "build.attention.reason": "Cause : {{reason}}",
  "build.attention.retry": "Relancer",
  "build.attention.abort": "Abandonner",
  "build.attention.confirmAbort": "Abandonner la mission ? Les runs en cours sont arrêtés, l'issue GitHub est fermée et le dépôt est libéré. Les branches sont conservées.",
  "build.attention.confirmAbortPrompt": "Confirmer l'abandon ?",
  "build.attention.confirmAbortYes": "Confirmer",
  "build.attention.confirmAbortNo": "Annuler",
  "build.attention.result.retry.accepted": "Relance demandée — l'orchestrateur reprend l'étape.",
  "build.attention.result.retry.noop": "Rien à relancer : aucune étape en échec côté orchestrateur.",
  "build.attention.result.retry.rejected": "Relance refusée par l'orchestrateur ({{reason}}).",
  "build.attention.result.retry.queued": "Relance en file — tous les créneaux de build sont occupés ; elle démarrera dès qu'un créneau se libère, avant les stories pas encore lancées. Inutile de relancer à nouveau.",
  "build.attention.result.abort.accepted": "Mission abandonnée — le dépôt est libéré.",
  "build.attention.result.abort.noop": "Mission déjà close — le dépôt est libéré.",
  "build.attention.result.abort.rejected": "Abandon refusé par l'orchestrateur ({{reason}}).",
  "build.attention.ceiling.reached": "Plafond de relances atteint — aucune relance automatique.",
  "build.attention.ceiling.override": "Forcer…",
  "build.attention.ceiling.reason": "Raison d'une relance de plus (tracée)",
  "build.attention.ceiling.submit": "Relancer une fois de plus",
  "build.errors.build_not_started": "Le build n'est pas lancé pour cette mission.",
  "build.delivery.live": "En ligne",
  "build.delivery.noUrl": "Livré — aucune URL de prod configurée pour ce dépôt.",
  "build.errors.phase_not_building": "La mission n'est pas en phase building : faites d'abord valider le gate shaping.",
  "build.errors.mission_closed": "La mission est terminée ou archivée.",
  "build.errors.build_started_other_repo": "Le build est déjà lancé sur un autre dépôt.",
  "build.errors.story_set_drift": "Les stories ont changé depuis que le POC a approuvé le plan : le build n'utilise que l'ensemble approuvé.",
  "build.errors.plan_not_approved": "Le plan n'est pas encore approuvé : approuve-le dans l'onglet Plan, puis lance le build.",
  "build.errors.stories_outside_plan": "Des stories n'ont pas été créées par le plan approuvé : remplace-les (supersede), puis lance le build.",
  "build.errors.repo_not_onboarded": "Ce dépôt n'est pas onboardé dans l'office.",
  "build.errors.repo_busy": "Ce dépôt porte déjà une autre mission en cours.",
  "build.errors.mission_files_missing": "Il manque intent.md, brief.md et stories.md : rien à transmettre au build.",
  "build.errors.mint_refused": "L'App GitHub a refusé le jeton d'accès.",
  "build.errors.github_error": "GitHub a refusé la création de l'issue de mission.",
  "build.errors.mission_agent_unavailable": "L'orchestrateur est indisponible — réessayez, rien n'est perdu.",
  "build.errors.unknown": "Le build n'a pas pu être lancé.",
  "build.viewRuns": "Voir les runs",
  "build.stories.toggle": "Stories ({{count}})",
  "build.stories.unreachable": "État de l'orchestrateur indisponible.",
  "build.stories.attempt": "tentative {{attempt}}",
  "build.stories.pr": "PR #{{number}}",
  "build.stories.noopStory": "{{sid}} est déjà en cours ({{sub}})",
  "build.stories.sub.queued": "en attente",
  "build.stories.sub.implementing": "implémentation",
  "build.stories.sub.reviewing": "revue",
  "build.stories.sub.awaiting_merge": "à merger",
  "build.stories.sub.blocked": "bloquée",
  "build.stories.sub.done": "terminée",
  "build.stories.sub.cancelled": "annulée",
  "build.stories.merge": "Merger",
  "build.stories.mergeAria": "Merger la PR de {{sid}}",
  "build.stories.confirmMerge": "Merger la PR #{{number}} de {{sid}} dans la branche de mission, au commit revu (SHIP) ?",
  "build.stories.confirmYes": "Oui, merger",
  "build.stories.confirmNo": "Annuler",
  "build.stories.merged": "{{sid}} : PR mergée.",
  "build.stories.verify": "J'ai vérifié {{code}}",
  "build.stories.verifyAria": "Marquer {{code}} comme vérifié par moi",
  "build.stories.verifyHint": "À vérifier par vous avant le merge (ouvrez la preview) :",
  "build.stories.verified": "{{code}} vérifié.",
  "build.stories.verifySha": "commit revu :",
  "build.stories.verifyNoSha": "Une vérification humaine est demandée, mais le commit revu est illisible : demandez une nouvelle revue (/nova review sur la PR #{{number}}).",
  "build.errors.head_moved": "La PR a changé depuis la revue SHIP : demandez une nouvelle revue (/nova review sur la PR), puis mergez.",
  "build.errors.human_verify_pending": "Des vérifications humaines restent à faire : cliquez « J'ai vérifié » sur chacune d'abord.",
  "build.errors.head_mismatch": "La story a été revue sur un nouveau commit depuis l'affichage : rechargez, vérifiez ce commit, puis cliquez à nouveau.",
  "build.errors.human_verify_unknown": "Le verdict demande une vérification humaine que le Studio ne connaît pas (revue antérieure au 21/10) : demandez une nouvelle revue (/nova review sur la PR), puis vérifiez et mergez.",
  "build.errors.invalid_sha": "Le commit vérifié est invalide : rechargez la page.",
  "build.errors.not_shipped": "Cette story n'a pas (ou plus) de verdict SHIP.",
  "build.errors.checks_pending": "La CI n'a pas encore tout validé sur ce commit : réessayez dans un instant.",
  "build.errors.checks_not_green": "La CI est rouge sur ce commit : rien n'a été mergé.",
  "build.errors.sha_not_reviewed": "Ce commit n'est pas celui que la revue a validé.",
  "build.errors.pr_not_open": "La PR n'est plus ouverte.",
  "build.errors.not_pending": "Cette vérification n'est plus en attente.",
  "build.errors.verdict_publish_failed": "GitHub n'a pas accepté le nouveau verdict : réessayez, la vérification reste en attente.",
  "build.errors.invalid_decided_by": "Seul un POC de l'office avec un compte GitHub lié peut faire cela.",
  "build.errors.poc_required": "Réservé au POC de l'office.",
  "build.budget.exceeded": "Budget dépassé : {{used}} M / {{max}} M tokens",
  "build.budget.exceededIterations": "Budget dépassé : {{used}} / {{max}} itérations",
  "build.budget.exceededOther": "Budget dépassé ({{metric}})",
  "build.budget.capLabel": "Nouveau plafond (millions de tokens)",
  "build.budget.capUnit": "M tokens",
  "build.budget.capLabelIterations": "Nouveau plafond (itérations)",
  "build.budget.capUnitIterations": "itérations",
  "build.budget.confirmAcceptIterations": "Porter le plafond à {{cap}} itérations et relancer les stories en attente ?",
  "build.budget.errorUnknown": "La décision de budget n'a pas pu être enregistrée.",
  "build.budget.accept": "Augmenter et continuer",
  "build.budget.defer": "Mettre en pause",
  "build.budget.confirmAccept": "Porter le plafond à {{cap}} M tokens et relancer les stories en attente ?",
  "build.budget.confirmDefer": "Laisser la mission en pause sans augmenter le budget ?",
  "build.budget.confirmYes": "Confirmer",
  "build.budget.confirmNo": "Annuler",
  "build.budget.result.accepted": "Budget augmenté — l'orchestrateur reprend au prochain tick.",
  "build.budget.result.recorded": "Décision enregistrée — la mission reste en pause.",
  "build.errors.github_identity_required": "Liez votre compte GitHub (Paramètres → GitHub) pour décider du budget.",
  "build.errors.cap_not_above_usage": "Le nouveau plafond doit dépasser la consommation actuelle.",
  "build.errors.no_open_budget_escalation": "Aucun dépassement de budget en attente de décision.",
  "build.errors.budget_decision_rejected": "L'orchestrateur a refusé la décision de budget.",
  "runs.title": "Runs",
  "runs.back": "Retour au chat",
  "runs.listLabel": "Runs de la mission",
  "runs.empty": "Aucun run pour cette mission : ils apparaissent quand le build démarre.",
  "runs.unavailable": "Les logs ne sont pas disponibles sur cet environnement (bucket d'artefacts non relié).",
  "runs.error": "Impossible de charger les runs.",
  "runs.pick": "Choisissez un run pour voir ses logs.",
  "runs.attempt": "essai {{attempt}}",
  "runs.heartbeat": "battement il y a {{age}}",
  "runs.status.running": "En cours",
  "runs.status.succeeded": "Réussi",
  "runs.status.failed": "Échec",
  "runs.status.fallback": "Repli",
  "runs.copy": "Copier",
  "runs.copied": "Copié",
  "runs.logs.tabsLabel": "Fichiers de log",
  "runs.logs.tab.output": "Output",
  "runs.logs.tab.stderr": "Stderr",
  "runs.logs.tab.diagnostics": "Diagnostics",
  "runs.logs.tab.result": "Result",
  "runs.logs.tab.compose-mode": "Compose mode",
  "runs.logs.pending": "Les logs complets arrivent à la fin du run.",
  "runs.logs.missing": "Pas de fichier pour cet onglet dans ce run.",
  "runs.logs.loading": "Chargement…",
  "runs.logs.empty": "(fichier vide)",
  "runs.logs.error": "Impossible de charger ce log.",
  "mission.journey.runsLabel": "Voir les runs",
  "roomThread.title": "Fil de la mission",
  "roomThread.listLabel": "Fils par story",
  "roomThread.thread.mission": "Mission",
  "roomThread.close": "Fermer le fil",
  "roomThread.empty": "Aucun échange sur le bus pour l'instant.",
  "roomThread.emptyThread": "Aucun message dans ce fil.",
  "roomThread.unavailable": "Le fil en direct n'est pas disponible sur cet environnement.",
  "roomThread.error": "Impossible de charger le fil.",
  "roomThread.summary.checkins_one": "{{count}} check-in",
  "roomThread.summary.checkins_other": "{{count}} check-ins",
  "roomThread.summary.eta": "ETA {{min}} min",
  "roomThread.summary.etaOverdue": "ETA dépassée",
  "roomThread.summary.noBlocker": "aucun blocage",
  "roomThread.summary.blockers_one": "{{count}} blocage",
  "roomThread.summary.blockers_other": "{{count}} blocages",
  "roomThread.summary.pending_one": "{{count}} en attente",
  "roomThread.summary.pending_other": "{{count}} en attente",
  "roomThread.line.eta": "ETA {{min}} min",
  "roomThread.line.pending": "en attente de vous",
  "roomThread.actor.poc": "POC",
  "roomThread.actor.engine": "moteur",
  "roomThread.actor.run": "run",
  "roomThread.actor.agent": "agent",
  "roomThread.kind.progress_up": "avance",
  "roomThread.kind.progress_down": "recule",
  "roomThread.kind.eta": "ETA",
  "roomThread.kind.question": "question",
  "roomThread.kind.request": "demande",
  "roomThread.kind.blocker": "blocage",
  "roomThread.kind.finding": "constat",
  "roomThread.kind.steer": "consigne",
  "roomThread.kind.notice": "info",
  "roomThread.kind.alert": "alerte",
  "roomThread.turn.progressing": "avance",
  "roomThread.turn.waiting_on": "en attente",
  "roomThread.turn.blocked": "bloquée",
  "roomThread.turn.done": "terminé",
  "roomThread.pinned.title_one": "{{count}} élément en attente",
  "roomThread.pinned.title_other": "{{count}} éléments en attente",
  "roomThread.pinned.question": "Question de Camille",
  "roomThread.pinned.answerInChat": "Répondre dans le chat",
  "roomThread.pinned.gate": "Gate {{kind}} à valider",
  "roomThread.pinned.openGate": "Voir la gate",
  "roomThread.pinned.ask": "{{actor}} demande · {{thread}}",
  "roomThread.confirmation.title": "Confirmation demandée",
  "roomThread.confirmation.target": "Cible : {{target}}",
  "roomThread.confirmation.confirm": "Confirmer",
  "roomThread.confirmation.refuse": "Refuser",
  "roomThread.confirmation.waitPoc": "En attente du POC",
  "settings.localWorker.title": "Worker local",
  "settings.localWorker.description": "Exécutez les étapes d'implémentation de cet office avec Claude Code sur votre poste. Le code expire après 10 minutes et ne sert qu'une fois.",
  "settings.localWorker.button": "Obtenir un code d'appairage",
  "settings.localWorker.copy": "Copier le prompt",
  "settings.localWorker.error": "Le code n'a pas pu être créé. Réessayez.",
  "settings.mockOptional.title": "Maquette facultative",
  "settings.mockOptional.description": "Activé, chaque ligne UI des prochains plans part sans maquette HTML (raison : réglage de l'office). Sur un plan, tu peux toujours redemander une maquette pour une ligne. Les plans déjà approuvés ne changent pas.",
  "settings.mockOptional.switchLabel": "Maquette facultative pour les prochains plans",
  "settings.mockOptional.on": "Activée",
  "settings.mockOptional.off": "Désactivée",
  "settings.mockOptional.readOnly": "Seul le POC de l'office peut changer ce réglage.",
  "settings.mockOptional.historyTitle": "Derniers changements",
  "settings.mockOptional.historyEmpty": "Aucun changement pour l'instant.",
  "settings.mockOptional.historyOn": "Activée par {{name}} le {{date}}",
  "settings.mockOptional.historyOff": "Désactivée par {{name}} le {{date}}",
  "settings.mockOptional.unknownUser": "un ancien membre",
  "settings.mockOptional.error.generic": "Le réglage n'a pas pu être enregistré. Réessaie.",
  "settings.mockOptional.error.poc_required": "Seul le POC de l'office peut changer ce réglage.",
  "settings.mockOptional.error.forbidden": "Seul le POC de l'office peut changer ce réglage.",
  "settings.mockOptional.error.invalid_input": "Valeur refusée. Recharge la page et réessaie.",
  "settings.autonomy.title": "Autonomie de Camille",
  "settings.autonomy.version": "version {{version}}",
  "settings.autonomy.intro": "Ce que Camille peut faire seule sur les missions de cet office. Hors de cette enveloppe, elle vous demande une confirmation.",
  "settings.autonomy.reversible": "Actions réversibles",
  "settings.autonomy.merge": "Fusion des PR de story",
  "settings.autonomy.release": "Release de la mission",
  "settings.autonomy.mode.act": "Seule",
  "settings.autonomy.mode.confirm": "Avec confirmation",
  "settings.autonomy.mode.auto": "Automatique",
  "settings.autonomy.maxTokens": "Plafond de budget (tokens)",
  "settings.autonomy.maxTokensHint": "Camille peut relever le budget d'une mission jusqu'à ce plafond.",
  "settings.autonomy.criticalPct": "Seuil « critique seulement » (%)",
  "settings.autonomy.criticalPctHint": "Au-delà de ce pourcentage du plafond, seules les actions critiques restent autonomes.",
  "settings.autonomy.wakeTokens": "Tokens de réveil par jour",
  "settings.autonomy.wakesPerHour": "Réveils max par heure",
  "settings.autonomy.typical": "Durées types (ETA par défaut)",
  "settings.autonomy.typicalStep": "Durée type · {{step}} (min)",
  "settings.autonomy.deployHosts": "Hôtes de déploiement autorisés",
  "settings.autonomy.deployHostsHint": "Un suffixe d'hôte par ligne (ex. monequipe.workers.dev), 10 au plus. Camille enregistre seule une URL de livraison sur ces hôtes ; ailleurs, elle vous demande confirmation. Un suffixe public seul (workers.dev, pages.dev, com) est refusé.",
  "settings.autonomy.save": "Enregistrer l'enveloppe",
  "settings.autonomy.saved": "Enveloppe enregistrée.",
  "settings.autonomy.invalid": "Valeurs refusées : {{fields}}",
  "settings.autonomy.stale": "L'enveloppe a été modifiée entre-temps : rechargée, vérifiez puis réessayez.",
  "settings.autonomy.error": "Impossible d'enregistrer l'enveloppe.",
  "settings.autonomy.pocOnly": "Seul le POC peut modifier l'enveloppe.",
  "roomThread.chatNotice": "À confirmer dans la carte épinglée : onglet Runs › Fil de la mission.",
  "office.audit.title": "Audit agents",
  "office.audit.subtitle": "Où vont l'argent et le temps des agents : bureau, projet, mission, puis agents et stories, classés. Le gaspillage = le travail qui n'a pas été livré (appels en erreur, runs perdus, essais rejetés en revue), compté une seule fois.",
  "office.audit.breadcrumb.label": "Fil d'Ariane de l'audit",
  "office.audit.breadcrumb.office": "Bureau",
  "office.audit.level.label": "Niveau",
  "office.audit.level.project": "Projets",
  "office.audit.level.mission": "Missions",
  "office.audit.level.agent": "Agents",
  "office.audit.level.story": "Stories",
  "office.audit.level.model": "Modèles",
  "office.audit.lens.label": "Lecture",
  "office.audit.lens.cost": "Coût",
  "office.audit.lens.time": "Temps",
  "office.audit.lens.waste": "Gaspillage",
  "office.audit.col.cost": "Coût",
  "office.audit.col.tokens": "Tokens",
  "office.audit.col.calls": "Appels",
  "office.audit.col.errorCalls": "Erreurs",
  "office.audit.col.agentTime": "Temps agent",
  "office.audit.col.activations": "Activations",
  "office.audit.col.waste": "Gaspillé",
  "office.audit.col.wastePct": "% gaspillé",
  "office.audit.col.reruns": "Relances",
  "office.audit.col.qaRetries": "Retours QA",
  "office.audit.col.firstPass": "1er passage",
  "office.audit.unattributed.project": "Non attribué (sans projet)",
  "office.audit.unattributed.mission": "Sans mission",
  "office.audit.unattributed.agent": "Sans agent",
  "office.audit.unattributed.story": "Niveau mission (sans story)",
  "office.audit.unattributed.model": "Modèle inconnu",
  "office.audit.other": "Autres (regroupés)",
  "office.audit.total": "Total",
  "office.audit.running": "en cours",
  "office.audit.top": "Top {{rank}}",
  "office.audit.filter.model": "Modèle",
  "office.audit.filter.env": "Environnement",
  "office.audit.filter.all": "Tous",
  "office.audit.filter.envTimeNote": "Le filtre environnement ne s'applique qu'au coût : les activations d'agents n'ont pas d'environnement, le temps n'est pas filtré.",
  "office.audit.period.label": "Période",
  "office.audit.period.mode": "Type de période",
  "office.audit.period.month": "Mois",
  "office.audit.period.custom": "Personnalisée",
  "office.audit.period.from": "Du",
  "office.audit.period.to": "Au (exclu)",
  "office.audit.period.live": "En direct",
  "office.audit.period.report": "Rapport",
  "office.audit.period.invalid": "Période invalide : choisissez une fin après le début, 93 jours au plus.",
  "office.audit.header.spend": "Dépense de la période",
  "office.audit.header.cap": "Dépense / plafond",
  "office.audit.header.pct": "{{pct}} % du plafond",
  "office.audit.header.noBudget": "Pas de budget",
  "office.audit.header.burn": "Rythme par jour",
  "office.audit.header.projection": "Projection fin de période",
  "office.audit.header.wholeOffice": "Tout le bureau, période du budget",
  "office.audit.header.waste": "Gaspillé",
  "office.audit.header.wastePct": "{{pct}} % de la dépense",
  "office.audit.header.agentTime": "Temps agent",
  "office.audit.export": "Exporter en CSV",
  "office.audit.empty": "Aucune dépense ni activation d'agent sur cette période.",
  "office.audit.error": "Impossible de charger l'audit.",
  "office.audit.truncated": "Plus de 500 lignes : la fin est regroupée dans « Autres ».",
  "office.audit.settingsLink.title": "Audit agents",
  "office.audit.settingsLink.cardTitle": "Audit agents, budget et export",
  "office.audit.settingsLink.cardDescription": "Coût, temps et gaspillage des agents par projet, mission, agent, story et modèle, le budget du bureau et l'export CSV.",
  "office.audit.waste.by.error": "Appels en erreur",
  "office.audit.waste.by.lost_run": "Runs perdus",
  "office.audit.waste.by.rejected": "Essais rejetés",
  "consumption.budget.title": "Budget",
  "consumption.budget.none": "Aucun budget défini. La plateforme ne plafonne pas la dépense de ce bureau.",
  "consumption.budget.set": "Définir un budget",
  "consumption.budget.edit": "Modifier",
  "consumption.budget.summary": "{{spent}} dépensés sur {{cap}} ({{pct}} %) ce {{period}}.",
  "consumption.budget.until": "Jusqu'au {{date}} (UTC)",
  "consumption.budget.period.day": "jour",
  "consumption.budget.period.week": "semaine",
  "consumption.budget.period.month": "mois",
  "consumption.budget.action.refuse": "À l'atteinte : refuser les nouveaux tours",
  "consumption.budget.action.downgrade": "À l'atteinte : passer à un modèle moins cher",
  "consumption.budget.warn": "{{pct}} % du budget est utilisé. Les tours continuent ; le budget les arrêtera à l'atteinte.",
  "consumption.budget.exhausted.refuse": "Budget atteint. Les nouveaux tours sont refusés jusqu'au {{date}}. Augmentez le budget pour continuer.",
  "consumption.budget.exhausted.downgrade": "Budget atteint. Les tours passent à un modèle moins cher du même fournisseur quand il en existe un, sinon ils sont refusés (et toujours pour la revue et les tests) jusqu'au {{date}}.",
  "consumption.budget.unknown": "La dépense n'a pas pu être lue à l'instant. Les tours ne sont pas bloqués.",
  "consumption.budget.form.period": "Période",
  "consumption.budget.form.cap": "Montant (USD)",
  "consumption.budget.form.capHint": "Entre 0,01 $ et {{max}}, en dollars.",
  "consumption.budget.form.action": "À l'atteinte du budget",
  "consumption.budget.form.actionHint.refuse": "Les nouveaux tours sont refusés avec un message clair jusqu'à la fin de la période ou à l'augmentation du budget.",
  "consumption.budget.form.actionHint.downgrade": "Les tours passent à un modèle moins cher du même fournisseur quand un modèle validé existe. La revue et les tests ne sont jamais dégradés : ils sont refusés. Au-delà de 125 % du montant, tout est refusé.",
  "consumption.budget.form.save": "Enregistrer",
  "consumption.budget.form.clear": "Supprimer le budget",
  "consumption.budget.form.cancel": "Annuler",
  "consumption.budget.form.saveError": "Impossible d'enregistrer le budget.",
  "consumption.builds.title": "Builds",
  "consumption.builds.note": "Chaque push construit sa branche. Un build est facturé à ses secondes de conteneur ; son coût est déjà inclus dans les totaux ci-dessus.",
  "consumption.builds.app": "App",
  "consumption.builds.branch": "Branche",
  "consumption.builds.version": "Version",
  "consumption.builds.seconds": "Secondes",
  "consumption.builds.cost": "Coût",
  "mission.mode.configTitle": "Configuration · cette mission",
  "mission.mode.trust.label": "Confiance accordée",
  "mission.mode.trust.camille": "Confiance accordée à Camille",
  "mission.mode.trust.level.supervised": "Supervisée",
  "mission.mode.trust.level.guided": "Encadrée",
  "mission.mode.trust.level.autonomous": "Autonome",
  "mission.mode.trust.effect.supervised": "Camille te demande avant chaque décision, avec les options et sa recommandation.",
  "mission.mode.trust.effect.guided": "Camille te demande dès qu'une décision se voit ou t'engage ; elle gère seule relances, séquence, modèles et assignations, et note pourquoi.",
  "mission.mode.trust.effect.autonomous": "Camille te demande seulement pour l'irréversible ; elle merge, recadre une story et ajuste l'escouade seule, en documentant chaque choix.",
  "mission.mode.trust.agentEffect.supervised": "Demande avant chaque choix dans sa story.",
  "mission.mode.trust.agentEffect.guided": "Décide l'invisible, demande avant un choix visible.",
  "mission.mode.trust.agentEffect.autonomous": "Décide tout le réversible dans sa story, signale ses choix visibles.",
  "mission.mode.trust.always": "Toujours toi : budget, release, argent ou irréversible hors enveloppe, légal, signatures de gates.",
  "mission.mode.rigor.missionDefault": "Rigueur par défaut de la mission",
  "mission.mode.rigor.story": "Rigueur de la story",
  "mission.mode.rigor.level.fast": "Ship fast",
  "mission.mode.rigor.level.steady": "Ship steady",
  "mission.mode.rigor.level.solid": "Ship solid",
  "mission.mode.rigor.effect.fast": "Tests sur les chemins critiques ; revue sécurité si surface sensible ; 3 tentatives de revue.",
  "mission.mode.rigor.effect.steady": "Tests complets ; revue sécurité si surface sensible ; 3 tentatives.",
  "mission.mode.rigor.effect.solid": "Tests complets + e2e sur chaque story P0 ; revue sécurité systématique ; escalade à la 2e revue.",
  "mission.mode.squad.scope": "Escouade : périmètre story",
  "mission.mode.source.matchmaking": "confirmé au matchmaking",
  "mission.mode.source.poc": "modifié par le POC",
  "mission.mode.source.proposed": "proposé par Camille",
  "mission.mode.source.inherited": "hérité du membre",
  "mission.mode.source.adjusted": "ajusté pour cette story",
  "mission.mode.matchmaking.title": "Ton escouade",
  "mission.mode.matchmaking.intro": "Camille a pré-rempli la confiance et la rigueur de chaque membre. Confirme ou ajuste en une fois.",
  "mission.mode.matchmaking.confirm": "Confirmer l'escouade",
  "mission.mode.matchmaking.confirming": "Confirmation…",
  "mission.mode.matchmaking.confirmed": "Escouade confirmée",
  "mission.mode.matchmaking.pocOnly": "Seul le POC confirme",
  "mission.mode.matchmaking.member": "Membre",
  "mission.mode.matchmaking.model": "Modèle",
  "mission.mode.matchmaking.effort": "Effort",
  "mission.mode.matchmaking.why": "Pourquoi",
  "mission.mode.matchmaking.rowAria": "{{name}}, {{role}}",
  "mission.mode.matchmaking.conductorRole": "Conduit la mission",
  "mission.mode.matchmaking.effortSnapped": "Effort ajusté à {{level}} : ce modèle ne propose pas {{previous}}.",
  "mission.mode.matchmaking.failed": "Échec de la confirmation de l'escouade",
  "mission.mode.assignment.title": "Confiance et rigueur par assigné",
  "mission.mode.assignment.edit": "Ajuster pour cette story : {{name}}",
  "mission.mode.assignment.save": "Enregistrer",
  "mission.mode.assignment.cancel": "Annuler",
  "mission.mode.assignment.revert": "Revenir au membre",
  "mission.mode.chip.trust": "Confiance : {{trust}}",
  "mission.mode.chip.rigor": "Rigueur : {{rigor}}",
  "mission.mode.badge.text": "{{rigor}} · Camille {{trust}}",
  "mission.mode.badge.aria": "Mode de la mission : {{rigor}}, confiance accordée à Camille {{trust}}",
  "mission.mode.badge.proposed": "proposé",
  "mission.mode.badge.proposedHint": "Proposé par Camille, pas encore confirmé : les défauts s'appliquent.",
  "mission.mode.badge.decisions": "Décisions",
  "mission.mode.gate.summaryTitle": "Mode de la mission (confirmé)",
  "mission.mode.gate.members": "Escouade",
  "mission.mode.gate.assignments": "Ajustements par story proposés par Camille (confirmés avec Approuver)",
  "mission.mode.gate.assignmentLine": "{{sid}} · {{name}} : {{values}}",
  "mission.decisions.title": "Décisions",
  "mission.decisions.intro": "Ce que Camille a tranché seule : le problème, les options, son choix et comment revenir en arrière.",
  "mission.decisions.empty": "Aucune décision enregistrée pour l'instant.",
  "mission.decisions.loadFailed": "Impossible de charger les décisions.",
  "mission.decisions.loadMore": "Plus anciennes",
  "mission.decisions.problem": "Problème",
  "mission.decisions.choice": "Choix",
  "mission.decisions.options": "Options",
  "mission.decisions.pros": "Pour",
  "mission.decisions.cons": "Contre",
  "mission.decisions.rationale": "Pourquoi",
  "mission.decisions.reversibility.reversible": "Réversible",
  "mission.decisions.reversibility.irreversible": "Irréversible",
  "mission.decisions.revertHow": "Comment revenir en arrière",
  "mission.decisions.refs": "Références",
  "mission.decisions.supersedes": "Remplace la décision {{id}}",
  "mission.decisions.revisitNote": "Note du POC",
  "mission.decisions.byAt": "{{by}} · {{at}}",
  "mission.decisions.details": "Détails de la décision #{{seq}}",
  "mission.decisions.trust": "Confiance au moment du choix : {{trust}}",
  "mission.decisions.class.minor": "mineure",
  "mission.decisions.class.visible": "visible",
  "mission.decisions.class.irreversible": "irréversible",
  "mission.decisions.class.choice": "choix",
  "mission.decisions.status.recorded": "notée",
  "mission.decisions.status.used": "appliquée",
  "mission.decisions.status.revisit_requested": "à revoir",
  "mission.decisions.status.revisited": "revue",
  "mission.decisions.revisit": "Revenir sur cette décision",
  "mission.decisions.revisitLabel": "Ce que tu veux revoir (500 caractères max)",
  "mission.decisions.revisitSubmit": "Demander à Camille de revoir",
  "mission.decisions.revisitCancel": "Annuler",
  "mission.decisions.revisitSent": "Demande envoyée à Camille",
  "mission.decisions.notRevisable": "Cette décision ne peut plus être revue.",
  "mission.decisions.revisitFailed": "Échec de la demande",
  "mission.decisions.pocOnly": "Seul le POC peut demander de revenir sur une décision.",
  "mission.decisions.history": "Historique",
  "mission.decisions.alternatives": "Alternatives : {{list}}",
  "workspace.dock.decisions": "Décisions de Camille",
  "mission.kickoff.effort.xhigh": "Extra",
  "mission.kickoff.effort.max": "Max",
  "mission.mode.source.default": "défaut",
  "mission.mode.source.unreadable": "illisible : niveau le plus prudent",
  "mission.mode.pocOnly": "Seul le POC peut modifier",
  "mission.mode.rigor.label": "Rigueur",
  "mission.mode.saved": "Mode enregistré",
  "mission.mode.stale": "Le mode a changé entre-temps : valeurs rechargées.",
  "mission.mode.agentNotInSquad": "Un membre n'est plus dans l'escouade : valeurs rechargées.",
  "mission.mode.saveFailed": "Échec de l’enregistrement du mode",
  "mission.mode.proposal.title": "Mode de la mission",
  "mission.mode.proposal.byCamille": "Proposé par Camille",
  "mission.mode.proposal.none": "Aucune proposition : défauts pré-remplis.",
  "mission.mode.proposal.signals": "Signaux",
  "mission.mode.proposal.confirmHint": "Approuver confirme ce mode ; il reste modifiable ensuite dans Escouade.",
  "mission.mode.proposal.confirmed": "Mode confirmé par le POC",
  "mission.mode.proposal.infoDiff": "Proposition de Camille (pour information, non appliquée) : {{diff}}",
  "mission.mode.notAllowed": "Le mode n’a pas été enregistré sur cette porte",
  "mission.mode.notAllowedDetail": "Le mode n’a pas été enregistré sur cette porte : rien n’a été décidé. Règle-le dans Escouade, ou approuve sans le mode.",
  "mission.mode.approveWithoutMode": "Approuver sans le mode",
  "mission.mode.rigorUnmet": "Exigences de rigueur non remplies : re-planifier ou donner une raison de bypass.",
  "mission.mode.blocker.security_reviewer_missing": "Aucun security-reviewer dans l’escouade.",
  "mission.mode.blocker.e2e_missing": "Stories P0 sans oracle e2e : {{sids}}",
  "mission.mode.blocker.e2e_facts_unreadable": "Faits e2e illisibles : les faits de rigueur du plan sont illisibles, re-planifier.",
  "sidebar.archived.toggle": "Afficher les archivées",
  "sidebar.archived.tag": "Archivée",
  "mission.archive.badge": "Archivée",
  "mission.archive.menu": "Actions de la mission",
  "mission.archive.archive": "Archiver",
  "mission.archive.unarchive": "Désarchiver",
  "mission.archive.confirmArchiveTitle": "Archiver cette mission ?",
  "mission.archive.confirmArchiveBody": "Elle disparaît de la barre latérale (filtre « Afficher les archivées » pour la retrouver). Un nouveau message dans le chat la désarchive.",
  "mission.archive.confirmUnarchiveTitle": "Désarchiver cette mission ?",
  "mission.archive.confirmUnarchiveBody": "Elle revient dans la barre latérale, au statut de sa phase actuelle.",
  "mission.archive.cancel": "Annuler",
  "mission.archive.archived": "Mission archivée",
  "mission.archive.unarchived": "Mission désarchivée",
  "storyDrawer.tabs.budget": "Budget",
  "storyDrawer.budget.total": "Budget total",
  "storyDrawer.budget.split": "Humains {{humans}} · Agents {{agents}}",
  "storyDrawer.budget.incomplete": "Incomplet : {{unrated}} sans tarif, {{unpriced}} non tarifés, {{hidden}} masquées",
  "storyDrawer.budget.humans": "Personnes",
  "storyDrawer.budget.agents": "Agents",
  "storyDrawer.budget.empty": "Aucune dépense pour l'instant.",
  "storyDrawer.budget.atRate": "à {{rate}}/h",
  "storyDrawer.budget.setRate": "Fixez votre tarif horaire",
  "storyDrawer.budget.unrated": "Sans tarif",
  "storyDrawer.budget.redacted": "Tarif privé",
  "storyDrawer.budget.basis.harness": "Facturé",
  "storyDrawer.budget.basis.priced": "Estimé ({{version}})",
  "storyDrawer.budget.basis.unpriced": "Non tarifé",
  "storyDrawer.budget.running": "En cours",
  "storyDrawer.budget.tokens": "{{in}} entrée · {{out}} sortie",
  "storyDrawer.budget.cache": "Cache : {{read}} lus · {{write}} écrits",
  "storyDrawer.budget.cacheSummary": "Tokens de cache",
  "storyDrawer.budget.rateLabel": "Taux horaire (USD/h)",
  "storyDrawer.budget.rateSource.office": "taux de l'office",
  "storyDrawer.budget.rateSource.profile": "taux personnel",
  "storyDrawer.budget.rateSource.none": "aucun taux",
  "storyDrawer.budget.rateHintSetOffice": "Enregistré comme votre taux de l'office.",
  "storyDrawer.budget.rateHintOverride": "Vaut pour cette entrée uniquement ; votre taux de l'office ne change pas.",
  "storyDrawer.budget.rateAdjusted": "taux ajusté pour ce ticket",
  "storyDrawer.budget.effortLevel.low": "Faible",
  "storyDrawer.budget.effortLevel.medium": "Moyen",
  "storyDrawer.budget.effortLevel.high": "Élevé",
  "storyDrawer.budget.effortLevel.xhigh": "Extra",
  "storyDrawer.budget.effortLevel.max": "Max",
  "storyDrawer.budget.effort": "effort {{level}}",
  "storyDrawer.budget.modelUnknown": "modèle inconnu",
  "storyDrawer.budget.effortUnknown": "effort non enregistré",
  "storyDrawer.budget.maxTokensTip": "Plafond de sortie : {{n}} tokens",
  "storyDrawer.budget.readOnly": "Enregistré par la plateforme",
  "storyDrawer.budget.edit": "Modifier",
  "storyDrawer.budget.delete": "Supprimer",
  "storyDrawer.budget.update": "Mettre à jour",
  "storyDrawer.budget.cancel": "Annuler",
  "storyDrawer.budget.truncated": "Seules les entrées les plus récentes sont affichées.",
  "storyDrawer.budget.noCost": "non chiffré",
  "storyDrawer.budget.attempt": "tentative {{n}}",
  "mission.journey.budgetTitle": "Budget de la mission : {{amount}}{{plus}}",
  "settings.rate.title": "Tarif horaire",
  "settings.rate.help": "Visible par vous, le POC de l'office et les admins de l'agence.",
  "settings.rate.override": "Tarif de l'office",
  "settings.rate.source.profile": "du profil",
  "settings.rate.source.office": "surcharge de l'office",
  "settings.rate.save": "Enregistrer",
  "settings.rate.remove": "Retirer",
  "settings.rate.currency": "Devise : USD",
  "settings.rate.none": "Aucun tarif",
  "settings.rate.saved": "Tarif enregistré",
  "settings.rate.removed": "Tarif retiré",
  "settings.rate.failed": "Impossible d'enregistrer le tarif",
  "settings.rate.removeOverride": "Retirer le tarif de l'office",
  "settings.rate.hidden": "Tarif du profil privé tant qu'aucun temps n'est saisi ici",
  "staff.title": "Squad de l'office",
  "staff.status.hired": "Engagé",
  "staff.status.pending_confirmation": "À confirmer",
  "staff.priceUndefined": "prix à définir",
  "staff.perMonth": "{{amount}} / mois",
  "staff.perMonthSuffix": "/ mois",
  "staff.missionChip": "{{title}} — {{roles}}",
  "staff.openStories_one": "{{count}} story ouverte",
  "staff.openStories_other": "{{count}} stories ouvertes",
  "staff.capLabel": "Plafond",
  "staff.noCap": "sans plafond",
  "staff.capReached": "Plafond atteint",
  "staff.totalMonthly": "Total mensuel : {{amount}}",
  "staff.newTotal": "Nouveau total : {{amount}}",
  "staff.proposals": "À décider ({{count}})",
  "staff.proposal.hire": "Engager {{name}}",
  "staff.proposal.confirm": "Confirmer {{name}}",
  "staff.proposal.release": "Libérer {{name}}",
  "staff.raiseCap": "Relève le plafond à {{cap}}",
  "staff.accept": "Accepter",
  "staff.refuse": "Refuser",
  "staff.error.generic": "Décision impossible.",
  "staff.error.staff_cap_reached": "Plafond atteint : relevez-le pour engager.",
  "staff.error.champion_has_active_roles": "Ce champion tient encore des rôles sur une mission active.",
  "staff.showLegacy": "Afficher l'historique ({{count}})",
  "staff.hideLegacy": "Masquer l'historique",
  "staff.legacy.badge": "Historique",
  "staff.legacy.banner": "Historique — cet agent a servi la mission {{mission}} ; son champion le remplace dans la squad de l'office.",
  "staff.legacy.bannerNoMission": "Historique — cet agent a servi une mission passée ; son champion le remplace dans la squad de l'office.",
  "staff.legacy.replacedBy": "Remplaçant :",
  "staff.squadRoles": "Squad de la mission : champion — rôle",
  "staff.offSpecialty": "Rôle hors spécialité",
  "staff.tab.missions": "Missions",
  "staff.noMissions": "Aucune mission en cours.",
  "staff.loading": "Chargement…",
  "staff.untitledMission": "Mission sans titre",
  "staff.untitledMissionOn": "Mission sans titre · {{date}}",
  "staff.chart.title": "Organigramme de l'office",
  "staff.chart.list": "Champions de l'office",
  "staff.chart.toConfirm_one": "{{count}} champion à confirmer",
  "staff.chart.toConfirm_other": "{{count}} champions à confirmer",
  "staff.chart.missions_one": "{{count}} mission",
  "staff.chart.missions_other": "{{count}} missions",
  "staff.chart.missionsLink_one": "Stories de {{name}} — {{count}} mission",
  "staff.chart.missionsLink_other": "Stories de {{name}} — {{count}} missions",
  "staff.chart.hire": "Engager",
  "staff.chart.hireAria": "Engager {{name}}",
  "staff.chart.more": "Plus d'actions pour {{name}}",
  "staff.chart.refuse": "Refuser l'engagement",
  "staff.chart.lead": "Chef d'orchestre",
  "staff.chart.poc": "POC",
  "staff.chart.pocUnnamed": "POC de l'office",
  "staff.chart.open": "Ouvrir la fiche de {{name}}",
  "staff.panel.missions": "Missions ({{count}})",
  "staff.panel.close": "Fermer",
  "staff.panel.stories": "Voir ses stories",
  "staff.panel.profile": "Profil de l'agent",
  "staff.panel.reason": "Pourquoi : {{reason}}",
  "taskList.view.champion": "Par champion",
  "taskList.champion.pick": "Champion",
  "taskList.champion.all_one": "Tous les champions ({{count}})",
  "taskList.champion.all_other": "Tous les champions ({{count}})",
  "taskList.champion.selected": "Champion sélectionné",
  "taskList.champion.clear": "Tous",
  "taskList.champion.empty": "Aucune story assignée.",
  "taskList.champion.emptyOne": "Aucune story assignée à ce champion dans ce projet.",
  "story.assignees.group": "{{role}} ({{count}})",
  "story.assignees.roleMark.implementer": "Im",
  "story.assignees.roleMark.reviewer": "Rv",
  "story.assignees.roleMark.tester": "Te",
  "story.assignees.roleMark.security-reviewer": "Sé",
  "story.assignees.roleMark.architect": "Ar",
  "story.assignees.roleMark.account-manager": "AM",
  "story.assignees.roleMark.other": "··",
  "story.assignees.family.other": "Autre",
  "story.assignees.aria": "{{parts}}",
  "story.assignees.ariaEffort": "effort {{value}}",
  "story.assignees.ariaTrust": "confiance {{value}}",
  "story.assignees.ariaRigor": "rigueur {{value}}",
  "story.assignees.tip.model": "Modèle",
  "story.assignees.tip.effort": "Effort",
  "story.assignees.tip.trust": "Confiance",
  "story.assignees.tip.rigor": "Rigueur",
  "story.assignees.adjusted": "ajusté pour cette story",
  "story.assignees.inherited.member": "hérité (membre)",
  "story.assignees.inherited.mission": "hérité (mission)",
  "story.assignees.inherited.office": "hérité (office)",
  "story.assignees.more": "+{{n}}",
  "story.assignees.summary_one": "{{count}} assigné",
  "story.assignees.summary_other": "{{count}} assignés",
  "story.assignees.missingReviewer": "Pas de reviewer",
  "story.assignees.missingReviewerHint": "Cette story a un implementer mais aucun reviewer assigné.",
  "story.assignees.unassigned": "Non assigné",
  "assigneeEditor.open": "Modifier les assignations : {{names}}",
  "assigneeEditor.openEmpty": "Assigner un champion à cette story",
  "assigneeEditor.title": "Assignations de la story",
  "assigneeEditor.drawerTrigger": "Modifier les assignations",
  "assigneeEditor.list": "Assignations",
  "assigneeEditor.role": "Rôle",
  "assigneeEditor.champion": "Champion",
  "assigneeEditor.championPlaceholder": "Choisir un champion…",
  "assigneeEditor.inherit": "Hérité ({{value}})",
  "assigneeEditor.modelNotForRole": "{{model}} — non disponible pour ce rôle",
  "assigneeEditor.save": "Enregistrer",
  "assigneeEditor.pocOnly": "Modèle, effort, confiance et rigueur : réservés au POC.",
  "assigneeEditor.noMode": "Réglages par assignation indisponibles pour cette story.",
  "assigneeEditor.remove": "Retirer {{name}}",
  "assigneeEditor.add": "Ajouter",
  "assigneeEditor.toHire": "{{name}} — à engager",
  "assigneeEditor.offSquad": "{{name}} — hors squad de la mission",
  "assigneeEditor.onStory": "{{name}} — déjà sur la story",
  "assigneeEditor.hireLink_one": "{{count}} champion à engager → Engager",
  "assigneeEditor.hireLink_other": "{{count}} champions à engager → Engager",
  "assigneeEditor.error.modelBlocked": "Ce modèle n'est pas sélectionnable pour ce rôle.",
  "assigneeEditor.error.notOnStory": "Cette assignation n'existe plus : rafraîchis la story.",
  "assigneeEditor.error.forbidden": "Réservé au POC.",
  "assigneeEditor.error.memberNotFound": "Ce champion n'est pas un agent actif de l'office.",
  "assigneeEditor.error.generic": "Modification impossible.",
  "assigneeEditor.lockedAfterStart": "Verrouillé après le début de l'implémentation — seul le POC peut modifier",
  "story.assignees.edit.unavailable": "Modèle et effort par assignation : pas encore disponibles sur cet environnement (migration en attente).",
  "story.assignees.edit.inherit": "Hérité ({{value}})",
  "story.assignees.edit.inheritEffort": "Hérité",
  "story.assignees.role": "Rôle pour cette story",
  "story.assignees.rolePlaceholder": "Rôle…",
  "story.assignees.pick": "Ajouter un assigné",
  "story.assignees.alreadyOnStory": "Ce champion est déjà sur la story : un seul rôle par champion et par story.",
  "story.assignees.roleNotHeld": "Ce champion ne tient pas ce rôle dans la mission.",
  "story.assignees.roleRequired": "Ce champion tient plusieurs rôles : choisis-en un.",
  "staff.cancel": "Annuler",
  "staff.price.edit": "Modifier le prix de {{name}}",
  "staff.price.label": "Prix mensuel de {{name}} (euros)",
  "staff.price.unit": "€ / mois",
  "staff.price.save": "Enregistrer",
  "staff.cap.edit": "Modifier le plafond",
  "staff.cap.label": "Plafond de champions engagés",
  "staff.raiseCapTo": "Relever le plafond à",
  "staff.settingsSaved": "Squad mise à jour.",
  "staff.error.settings": "Enregistrement impossible.",
  "staff.error.unknown_champion": "Champion inconnu.",
  "staff.error.champion_not_in_catalog": "Ce champion n'est pas dans le catalogue de la Guilde.",
  "staff.error.already_hired": "Ce champion est déjà engagé.",
  "staff.error.camille_is_permanent": "Camille fait partie de l'office en permanence.",
  "staff.pocOnlyEdit": "Réservé au POC : persona, prompt et modèle valent pour toutes les missions.",
  "staff.matchmaking.hireTitle": "Engager dans l'office",
  "staff.matchmaking.rolesTitle": "Rôles dans la mission",
  "staff.matchmaking.hireIntro": "Ces champions ne sont pas encore dans l'office : leur engagement reste ta décision.",
  "staff.matchmaking.hireRow": "Engager {{name}} ({{delta}})",
  "staff.matchmaking.noPrice": "prix à définir",
  "staff.matchmaking.decisionLink": "Voir la décision",
  "staff.matchmaking.offSpecialty": "Hors spécialité",
  "staff.matchmaking.decided": "Décision enregistrée.",
  "team.facepile.label": "Équipe : {{names}}",
  "team.facepile.labelMore": "Équipe : {{names}} et {{count}} autres",
  "team.facepile.dialog": "Équipe de la mission",
  "team.facepile.more": "+{{count}}",
  "team.member.roles": "{{name}} — {{roles}}",
  "team.member.mention": "Mentionner",
  "team.member.mentionAria": "Mentionner {{name}}",
  "team.presence.working": "au travail",
  "team.presence.asking": "attend une réponse",
  "team.presence.idle": "disponible",
  "team.unknownAgent": "Un agent",
  "team.recipient.chip": "→ {{name}}",
  "team.recipient.reset": "Revenir à Camille",
  "team.recipient.listLabel": "Mentionner un membre de l'équipe",
  "team.recipient.hint": "{{name}} répondra à ce message",
  "team.question.region": "Question de {{name}}",
  "team.question.request": "Demande",
  "team.question.story": "Ouvrir la story {{sid}}",
  "team.question.mission": "Mission",
  "team.question.context": "Contexte",
  "team.question.options": "Options",
  "team.question.pros": "Avantages",
  "team.question.cons": "Inconvénients",
  "team.question.recommended": "Recommandée",
  "team.question.because": "Pourquoi : {{because}}",
  "team.question.option": "Option {{n}}",
  "team.question.class.minor": "Mineure",
  "team.question.class.visible": "Visible",
  "team.question.class.irreversible": "Irréversible",
  "team.question.state.waiting": "En attente de Camille",
  "team.question.state.escalated": "Escaladé au POC",
  "team.question.state.answered": "Répondu",
  "team.question.replies": "Réponses",
  "team.question.replyBy.camille": "Camille",
  "team.question.replyBy.poc": "POC",
  "team.question.seeDecision": "Voir la décision",
  "team.escalation.title": "Camille propose de répondre :",
  "team.escalation.confirm": "Confirmer",
  "team.escalation.refuse": "Refuser",
  "team.escalation.waitPoc": "En attente du POC",
  "team.answer.open": "Répondre à {{name}}",
  "team.answer.label": "Votre réponse à {{name}}",
  "team.answer.send": "Envoyer la réponse",
  "team.answer.cancel": "Annuler",
  "team.answer.error.already_answered": "Cette question a déjà reçu une réponse.",
  "team.answer.error.question_not_found": "Cette question n'existe plus.",
  "team.answer.error.generic": "Réponse non envoyée. Réessayez.",
  "team.notice.answerAgent": "Décision sous la question de {{name}}",
  "team.notice.answerAgentGeneric": "Décision sous la question d'un agent",
  "team.notice.goTo": "Aller à la question",
  "team.seat.poc": "POC",
  "team.seat.camille": "Camille",
  "team.seat.pmSeat": "PM (siège)",
  "team.question.topic.product": "Produit",
  "team.question.topic.delivery": "Livraison",
  "team.question.topic.other": "Autre",
  "team.question.decides": "Décide : {{name}}",
  "team.question.deciderPo": "{{name}} (PO)",
  "team.question.deciderPm": "{{name}} (PM)",
  "team.question.reroutedBy": "re-routé par {{name}}",
  "team.question.rerouted": "re-routé",
  "team.question.state.waitingFor": "En attente de {{name}}",
  "team.question.state.waitingPoc": "En attente du POC",
  "team.question.state.decidedBy": "Décidé par {{name}}",
  "team.question.decision": "Décision",
  "team.question.adviceList": "Avis",
  "team.question.adviceBy": "Avis de {{name}}",
  "team.chain.title": "Chaîne de commandement",
  "team.chain.captionPm": "{{lead}} et {{pm}} rapportent au POC ; la squad rapporte à {{pm}}",
  "team.chain.captionLead": "{{lead}} rapporte au POC ; la squad rapporte à {{lead}}",
  "team.chain.captionPmOnly": "{{pm}} rapporte au POC ; la squad rapporte à {{pm}}",
  "team.chain.disputes": "Désaccords ({{count}})",
  "team.dispute.title": "Désaccord · {{subject}}",
  "team.dispute.raisedBy": "Soulevé par {{name}}",
  "team.dispute.option": "Option {{letter}}",
  "team.dispute.otherOptions": "Autres options",
  "team.dispute.costSeat": "estimation du siège",
  "team.dispute.positionMissing": "Position introuvable : le message du siège manque.",
  "team.dispute.positionSilent": "N'a pas donné de position en 30 min",
  "team.dispute.severity.minor": "Mineur",
  "team.dispute.severity.visible": "Visible",
  "team.dispute.severity.major": "Majeur",
  "team.dispute.severityWith": "{{severity}} : {{reasons}}",
  "team.dispute.severityLabel": "Sévérité",
  "team.dispute.why.p0": "P0",
  "team.dispute.why.p0_order": "ordre devant un P0",
  "team.dispute.why.waterline": "ligne de flottaison",
  "team.dispute.why.constraint": "contrainte",
  "team.dispute.why.criticality": "criticité haute",
  "team.dispute.why.irreversible": "irréversible",
  "team.dispute.why.envelope": "hors enveloppe",
  "team.dispute.why.unknown": "fait illisible",
  "team.dispute.arbiterLabel": "Arbitre",
  "team.dispute.arbiterCamille": "Arbitre : {{name}}",
  "team.dispute.arbiterPoc": "Arbitre : POC",
  "team.dispute.reasonInput": "Raison (une ligne)",
  "team.dispute.reasonHint": "Écrivez une raison pour choisir une option.",
  "team.dispute.choose": "Trancher : option {{letter}} — {{label}}",
  "team.dispute.decidedPoc": "Tranché par le POC — option {{letter}}",
  "team.dispute.decidedCamille": "Arbitré par {{name}} — option {{letter}}",
  "team.dispute.error.choice_required": "Choisissez une option.",
  "team.dispute.error.already_answered": "Ce désaccord est déjà tranché.",
  "team.dispute.error.generic": "Décision non envoyée. Réessayez.",
  "agentPrompt.title": "Prompt système",
  "agentPrompt.mission": "Mission",
  "agentPrompt.noMission": "Sans mission",
  "agentPrompt.mode": "Type de tour",
  "agentPrompt.modes.chat": "Chat",
  "agentPrompt.modes.wake": "Réveil",
  "agentPrompt.loading": "Chargement…",
  "agentPrompt.notLive": "Ce rôle n’a pas de runtime hors mission : son prompt est composé à l’activation. Choisissez une mission pour voir celui d’une @-mention.",
  "agentPrompt.readOnly": "Lecture seule : seul le POC modifie les sections de l’office.",
  "agentPrompt.showFull": "voir le prompt complet",
  "agentPrompt.hideFull": "masquer le prompt complet",
  "agentPrompt.copy": "copier",
  "agentPrompt.copied": "Prompt copié",
  "agentPrompt.locked": "Section verrouillée (non modifiable)",
  "agentPrompt.absent": "absente pour ce tour",
  "agentPrompt.origin.platform": "Plateforme",
  "agentPrompt.origin.plugin": "Plugin",
  "agentPrompt.origin.office": "Office",
  "agentPrompt.origin.legacy": "Office (hérité)",
  "agentPrompt.diff.show": "voir les différences avec le défaut",
  "agentPrompt.diff.hide": "masquer les différences",
  "agentPrompt.diff.same": "Identique.",
  "agentPrompt.diff.versus": "Version actuelle → v{{version}}",
  "agentPrompt.editLabel": "Texte de l’office (vide = défaut de la plateforme)",
  "agentPrompt.placeholder.persona": "ex. une cheffe de projet calme, qui tranche vite.",
  "agentPrompt.placeholder.heartbeat": "ex. 1. Lire le board. 2. Débloquer la story la plus ancienne. 3. Finir par set_conductor_status.",
  "agentPrompt.placeholder.office-instructions": "ex. Réponds toujours en français. Priorise les tickets Wave 0.",
  "agentPrompt.save": "Enregistrer",
  "agentPrompt.saving": "Enregistrement…",
  "agentPrompt.cancel": "annuler",
  "agentPrompt.reset": "revenir au défaut",
  "agentPrompt.history": "historique",
  "agentPrompt.noVersions": "Aucune version enregistrée.",
  "agentPrompt.restore": "Restaurer la v{{version}}",
  "agentPrompt.saved": "Section enregistrée (v{{version}})",
  "agentPrompt.restored": "Version restaurée (v{{version}})",
  "agentPrompt.redacted_one": "{{count}} secret masqué",
  "agentPrompt.redacted_other": "{{count}} secrets masqués",
  "agentPrompt.action.edit": "modification",
  "agentPrompt.action.rollback": "restauration",
  "agentPrompt.action.reset": "retour au défaut",
  "agentPrompt.tools": "Outils exposés : {{tools}}",
  "agentPrompt.error.conflict": "Quelqu’un a modifié cette section entre-temps : rechargée, réessayez.",
  "agentPrompt.error.tooLarge": "Texte trop long pour cette section.",
  "agentPrompt.error.locked": "Section verrouillée.",
  "agentPrompt.error.forbidden": "Réservé au POC.",
  "agentPrompt.error.generic": "Échec de l’opération.",
  "agentPrompt.error.load": "Impossible de charger le prompt.",
  "agentPrompt.squadLink": "Persona et instructions : modifier dans le prompt de l’agent",
  "ledger.oracle.eval": "éval",
  "ledger.oracle.e2e": "e2e",
  "ledger.oracle.live": "en direct",
  "ledger.oracle.review": "revue",
  "ledger.oracle.capture": "capture",
  "storyContract.unframed": "Non cadrée",
  "storyContract.empty": "Rien de précisé.",
  "storyContract.outcome": "Résultat :",
  "storyContract.input.title": "Entrée",
  "storyContract.input.context": "Contexte",
  "storyContract.input.consumes": "Utilise",
  "storyContract.input.read": "À lire",
  "storyContract.input.constraints": "Contraintes",
  "storyContract.input.other": "Autre",
  "storyContract.output.title": "Livrables",
  "storyContract.output.unlocated": "emplacement non précisé",
  "storyContract.gates.title": "Validation",
  "storyContract.gates.evidence": "Preuves attendues",
  "storyContract.gates.noEvidence": "Aucune preuve précisée",
  "storyContract.gates.validatedBy": "Validée par",
  "storyContract.gates.oracles": "Comment on vérifie",
  "storyContract.gates.criteria": "Critères d'acceptation",
  "storyContract.gates.given": "Étant donné",
  "storyContract.gates.when": "Quand",
  "storyContract.gates.then": "Alors",
  "storyContract.validator.tester": "testeur",
  "storyContract.validator.reviewer": "relecteur",
  "storyContract.validator.security-reviewer": "relecteur sécurité",
  "storyContract.validator.poc": "POC",
  "storyContract.oracleHint.test": "un test automatisé",
  "storyContract.oracleHint.eval": "un cas d'éval rejoué",
  "storyContract.oracleHint.e2e": "un parcours de bout en bout",
  "storyContract.oracleHint.live": "constaté sur l'environnement réel",
  "storyContract.oracleHint.review": "relu par un humain ou un agent",
  "storyContract.oracleHint.capture": "une capture d'écran",
  "storyContract.oracleHint.checklist": "une liste cochée",
  "storyContract.oracleHint.crossref": "un renvoi vérifié",
  "storyContract.oracleHint.recompute": "un chiffre recalculé",
  "storyContract.oracleHint.prediction": "une prédiction à confirmer plus tard",
  "storyContract.oracleHint.human_verify": "vérifié par une personne",
  "storySet.title": "Revue des stories",
  "storySet.loading": "Chargement du plan…",
  "storySet.summary.stories_one": "{{count}} story",
  "storySet.summary.stories_other": "{{count}} stories",
  "storySet.summary.p0": "{{count}} en P0",
  "storySet.summary.steps_one": "{{count}} étape",
  "storySet.summary.steps_other": "{{count}} étapes",
  "storySet.drift": "Les stories ont changé depuis l'approbation du plan.",
  "storySet.truncated": "Liste tronquée aux 200 premières stories.",
  "storySet.step": "Étape {{n}} — {{title}}",
  "storySet.stepImplicit": "Ordre de livraison non précisé",
  "storySet.changed": "Le plan a changé, relis-le",
  "storySet.hashRequired": "Le plan n'a pas pu être chargé : recharge-le avant d'approuver.",
  "storySet.decomposition.title": "Logique de découpage",
  "storySet.decomposition.missing": "Camille n'a pas encore expliqué le découpage",
  "storySet.decomposition.invalid": "L'explication du découpage n'est pas encore complète :",
  "storySet.decomposition.problem": "La question :",
  "storySet.decomposition.options": "Options envisagées",
  "storySet.decomposition.chosen": "Retenue",
  "storySet.decomposition.pros": "Pour",
  "storySet.decomposition.cons": "Contre",
  "storySet.decomposition.rationale": "Pourquoi ce découpage",
  "storySet.decomposition.outOfScope": "Laissé de côté",
  "storySet.decomposition.outOfScopeNone": "Rien n'a été écarté.",
  "storySet.decomposition.when.later": "plus tard",
  "storySet.decomposition.when.never": "jamais",
  "storySet.decomposition.p0Path": "Chemin P0",
  "storySet.decomposition.reversibility.reversible": "Découpage réversible",
  "storySet.decomposition.reversibility.irreversible": "Découpage difficile à défaire",
  "storySet.row.noOutcome": "résultat non décrit",
  "storySet.row.titleArtifactOnly": "(le titre nomme un écran ou un fichier, pas ce que l'utilisateur obtient)",
  "storySet.row.unassigned": "non assignée",
  "storySet.row.dependsOn": "après",
  "storySet.row.changed": "modifiée depuis la dernière revue",
  "storySet.row.commented": "commentée",
  "storySet.row.showContract": "Voir le contrat de {{code}}",
  "storySet.row.hideContract": "Masquer le contrat de {{code}}",
  "storySet.row.comment": "Commenter {{code}}",
  "storySet.row.commentLabel": "Commentaire sur {{code}}",
  "storySet.row.commentPlaceholder": "Ce qu'il faut changer dans cette story…",
  "storySet.row.commentCount": "{{n}}/{{max}}",
  "storySet.gate.showSummary": "Voir le résumé",
  "storySet.gate.hideSummary": "Réduire le résumé",
  "storySet.gate.sendBackNeedsWhy": "Pour renvoyer, dis pourquoi : un commentaire général ou sur une story.",
  "storySet.decomposition.missingHint": "Elle l'écrit avant de te demander d'approuver les stories.",
  "storySet.errors.generic": "Un point du découpage doit encore être repris par Camille.",
  "storySet.errors.shaping_decomposition_missing": "Camille n'a pas encore expliqué le découpage.",
  "storySet.errors.shaping_decomposition_invalid": "L'explication du découpage est incomplète (options pesées, choix ou raison).",
  "storySet.errors.shaping_decomposition_too_large": "L'explication du découpage est trop longue pour être affichée.",
  "storySet.errors.shaping_sequence_mismatch": "L'ordre de livraison ne couvre pas chaque story exactement une fois.",
  "storySet.errors.shaping_sequence_order": "Une story est prévue avant une story dont elle dépend.",
  "storySet.errors.shaping_p0_path_mismatch": "Le chemin P0 ne reprend pas exactement les stories P0.",
  "storySet.errors.shaping_priorities_undifferentiated": "Toutes les stories ont la même priorité : le chemin essentiel ne ressort pas.",
  "storySet.errors.shaping_p0_path_open": "Une story P0 attend une story qui n'est pas P0.",
  "storySet.errors.shaping_stories_unframed": "Certaines stories n'ont pas encore leur contrat (ce qu'elles livrent et comment on le vérifie).",
  "storySet.legacyNote_one": "Cette story date d'avant les contrats : elle n'a pas encore de résultat ni de critères.",
  "storySet.legacyNote_other": "Ces {{count}} stories datent d'avant les contrats : elles n'ont pas encore de résultat ni de critères.",
  "storySet.banner.title": "Logique du découpage",
  "storySet.banner.show": "Afficher",
  "storySet.banner.hide": "Masquer",
  "storySet.banner.steps_one": "{{count}} étape de livraison",
  "storySet.banner.steps_other": "{{count}} étapes de livraison",
  "storySet.banner.openGate": "Relire sur le gate",
  "storySet.draft": "Brouillon",
  "storySet.draftTitle": "Brouillon : pas encore approuvée au gate de shaping",
  "cadrage.title": "Cadrage à valider",
  "cadrage.empty": "Rien de cadré pour le moment.",
  "cadrage.unconfirmed_one": "{{count}} proposition de Camille à confirmer",
  "cadrage.unconfirmed_other": "{{count}} propositions de Camille à confirmer",
  "cadrage.allValidated": "Tout est validé par toi",
  "cadrage.source.camille_proposed": "Proposé par Camille",
  "cadrage.source.poc_confirmed": "Confirmé par toi",
  "cadrage.source.poc_stated": "Dit par toi",
  "cadrage.confirm": "Confirmer",
  "cadrage.confirmItem": "Confirmer : {{label}}",
  "cadrage.correct": "Corriger",
  "cadrage.correctItem": "Corriger : {{label}}",
  "cadrage.correctionPlaceholder": "Ta version, en une phrase",
  "cadrage.sendCorrection": "Envoyer à Camille",
  "cadrage.cancel": "Annuler",
  "cadrage.correctionSent": "Correction envoyée à Camille",
  "cadrage.correctionMessage": "Correction du cadrage — {{label}} : {{text}}",
  "cadrage.validate": "Valider le cadrage",
  "cadrage.sendBack": "Renvoyer avec commentaires",
  "cadrage.sendBackNeedsWhy": "Dis à Camille ce qui ne va pas avant de renvoyer le cadrage.",
  "cadrage.sendBackMessage": "Je renvoie le cadrage : {{text}}",
  "cadrage.changed": "Le cadrage a changé depuis l'affichage — relis la nouvelle version avant de valider.",
  "build.errors.cadrage_drift": "Le cadrage a changé depuis que tu l'as validé : reconfirme les éléments modifiés ci-dessous, puis relance le build.",
  "cadrage.quoteLabel": "Tes mots",
  "cadrage.correctionBusy": "Camille répond encore — renvoie dans un instant, ton texte est gardé.",
  "constraints.title": "Finition, rythme, budget",
  "constraints.edit": "Régler finition, rythme et budget",
  "constraints.finition": "Finition",
  "constraints.rythme": "Rythme",
  "constraints.budget": "Budget (appétit)",
  "constraints.budgetQuestion": "Combien ce problème vaut-il pour toi ?",
  "constraints.envelope": "enveloppe, pas un devis",
  "constraints.budgetUnset": "À choisir",
  "constraints.unavailable": "Non disponible",
  "constraints.critiqueUrgent": "Critique exige audit et redondance : pas compatible avec une équipe montée en urgence.",
  "constraints.finitionFrozen": "Finition figée à l'approbation du plan.",
  "constraints.spent": "Déjà dépensé : {{amount}}",
  "constraints.deadline": "Échéance (optionnelle)",
  "constraints.deadlineHint": "Sans date, la fin de l'horizon validé fait foi.",
  "constraints.save": "Enregistrer",
  "constraints.saved": "Finition, rythme et budget enregistrés",
  "constraints.errors.stale_constraints": "Les contraintes ont changé entre-temps — relis la nouvelle version.",
  "constraints.errors.finition_frozen": "La finition est figée depuis l'approbation du plan.",
  "constraints.errors.use_plan_settings": "Un plan est soumis : règle-les directement sur le plan.",
  "constraints.errors.critique_urgent_unavailable": "Critique × Urgent n'est pas disponible.",
  "constraints.errors.budget_below_spend": "Le budget ne peut pas descendre sous ce qui est déjà dépensé.",
  "constraints.errors.invalid_budget": "Ce montant n'est pas possible.",
  "constraints.errors.invalid_deadline": "Cette date n'est pas valide.",
  "constraints.errors.invalid_finition": "Ce niveau de finition n'existe pas.",
  "constraints.errors.invalid_rythme": "Ce rythme n'existe pas.",
  "constraints.errors.not_poc": "Seul le POC de l'office règle ces contraintes.",
  "constraints.errors.poc_required": "Seul le POC de l'office règle ces contraintes.",
  "constraints.noBudget": "Pas de budget fixé : le plafond par défaut de la plateforme s'applique (25 $).",
  "constraints.spendLabel": "Dépense par rapport au budget",
  "constraints.spendOfEstimated": "{{spent}} dépensés sur {{budget}}, estimation comprise (comme le plafond les compte)",
  "constraints.spendOf": "{{spent}} dépensés sur {{budget}}",
  "constraints.unpriced_one": "{{count}} exécution sans coût connu : comptée au tarif de modèle le plus élevé, ou 12 $ forfaitaires sans tokens enregistrés.",
  "constraints.unpriced_other": "{{count}} exécutions sans coût connu : comptées au tarif de modèle le plus élevé, ou 12 $ forfaitaires chacune sans tokens enregistrés.",
  "constraints.waterline.rule": "Ligne de flottaison — ce qui est en dessous n'est pas construit cette fois",
  "constraints.waterline.summary": "Estimé au-dessus de la ligne : {{total}} · marge {{margin}}",
  "constraints.waterline.noBudget": "Pas de budget fixé : tout le plan est au-dessus de la ligne ({{total}} estimés).",
  "constraints.waterline.belowCount_one": "{{count}} ligne sous la ligne de flottaison : hors périmètre cette fois.",
  "constraints.waterline.belowCount_other": "{{count}} lignes sous la ligne de flottaison : hors périmètre cette fois.",
  "constraints.waterline.sourceHistory_one": "D'après l'historique de ton office ({{count}} story).",
  "constraints.waterline.sourceHistory_other": "D'après l'historique de ton office ({{count}} stories).",
  "constraints.waterline.sourceMixed_one": "En partie d'après l'historique de ton office ({{count}} story), le reste en estimation prudente.",
  "constraints.waterline.sourceMixed_other": "En partie d'après l'historique de ton office ({{count}} stories), le reste en estimation prudente.",
  "constraints.waterline.sourceDefault": "Estimation prudente, sans historique.",
  "constraints.waterline.estimate": "≈ {{amount}}",
  "constraints.waterline.outOfScope": "hors périmètre",
  "constraints.waterline.belowTag": "sous la ligne de flottaison",
  "constraints.waterline.issue.waterline_p0_below": "Ligne P0 sous la ligne : monte le budget, baisse la finition ou le rythme, ou passe-la en P1.",
  "constraints.waterline.issue.waterline_dependency_below": "Dépend de {{deps}}, qui est sous la ligne : remonte-la ou descends celle-ci.",
  "constraints.waterline.moveUp": "Monter {{code}} dans l'ordre",
  "constraints.waterline.moveDown": "Descendre {{code}} dans l'ordre",
  "mission.mode.rigor.derived": "Suit la finition choisie par le POC.",
  "cadrage.sendBackBusy": "Cadrage renvoyé. Camille répond encore : redis-lui ton commentaire dans le chat pour qu'elle reprenne tes mots.",
  "cadrage.drift_one": "{{count}} élément modifié depuis ta validation — à reconfirmer",
  "cadrage.drift_other": "{{count}} éléments modifiés depuis ta validation — à reconfirmer",
  "plan.title": "Plan d'action",
  "plan.loading": "Chargement du plan…",
  "plan.empty": "Rien n'est encore écrit ici.",
  "plan.emptyTab": "Camille n'a pas encore soumis de plan d'action pour cette mission.",
  "plan.changed": "Le plan a changé, relis-le avant d'approuver.",
  "plan.cadrageStale": "Le cadrage a changé depuis que ce plan a été écrit : Camille doit le reprendre.",
  "plan.cadrageSource.poc_stated": "dit par toi",
  "plan.cadrageSource.camille_proposed": "proposé par Camille",
  "plan.cadrageSource.poc_confirmed": "confirmé par toi",
  "plan.storiesEmpty": "Les stories seront créées à l'approbation du plan.",
  "plan.storiesEmptyLink": "Lire le plan",
  "plan.approve.plain": "Approuver le plan",
  "plan.approve.read": "J'ai lu la spec (rév. {{rev}}) et j'approuve le plan",
  "plan.sendBack": "Renvoyer à Camille",
  "plan.sendBackNeedsWhy": "Pour renvoyer, dis pourquoi : un commentaire général ou sur une ligne.",
  "plan.approvedBadge": "Approuvé · empreinte {{hash}}",
  "plan.status.submitted": "En attente de ta décision",
  "plan.status.approved": "approuvé",
  "plan.status.rejected": "renvoyé",
  "plan.status.superseded": "remplacé",
  "plan.status.draft": "brouillon",
  "plan.versions.title": "Versions :",
  "plan.versions.current": "version {{n}}",
  "plan.versions.item": "v{{n}} · {{status}}",
  "plan.feedback.title": "Ce que tu as renvoyé sur la version {{n}}",
  "plan.mode.title": "Réglages de la mission",
  "plan.section.glance": "En bref",
  "plan.section.problem": "Le problème",
  "plan.section.solution": "La solution proposée",
  "plan.section.alternatives": "Alternatives envisagées",
  "plan.section.spec": "Architecture et spec",
  "plan.section.decomposition": "Découpage",
  "plan.section.risks": "Risques et parades",
  "plan.section.lines": "Le plan ligne par ligne",
  "plan.section.budget": "Budget et délais",
  "plan.section.out_of_scope": "Hors périmètre",
  "plan.section.coverage": "Couverture de la demande",
  "plan.section.budgetConstraints": "Budget, finition, rythme",
  "plan.section.approval": "Ce que ton approbation déclenche",
  "plan.glance.version": "Version",
  "plan.glance.lines": "Lignes",
  "plan.glance.p0": "Chemin P0",
  "plan.glance.criticality": "Criticité",
  "plan.glance.appetite": "Appétit :",
  "plan.glance.trigger_one": "Ton approbation crée {{count}} story, déjà staffée et réglée.",
  "plan.glance.trigger_other": "Ton approbation crée {{count}} stories, déjà staffées et réglées.",
  "plan.solution.why": "Pourquoi cette solution",
  "plan.alternatives.rationale": "Pourquoi ce choix",
  "plan.spec.read": "Lire la spec (rév. {{rev}})",
  "plan.spec.missing": "La spec n'est pas encore écrite.",
  "plan.spec.stale": "La spec a été révisée depuis ce plan (rév. {{from}} → {{to}}).",
  "plan.spec.revisedSinceApproval": "Spec révisée depuis l'approbation (rév. {{from}} → {{to}}).",
  "plan.decomposition.sequence": "Ordre des étapes",
  "plan.risks.title": "Risques",
  "plan.risks.none": "Aucun risque identifié.",
  "plan.coverage.intro": "Chaque demande de ton message et du cadrage, et ce que le plan en fait. Vérifie surtout ce qui est reporté ou écarté avant d'approuver.",
  "plan.coverage.summary": "{{covered}} couverte(s) · {{deferred}} reportée(s) · {{rejected}} écartée(s)",
  "plan.coverage.requirement": "Demande",
  "plan.coverage.source": "Tes mots",
  "plan.coverage.status": "Statut",
  "plan.coverage.lines": "Lignes",
  "plan.coverage.reason": "Raison",
  "plan.coverage.status.covered": "Couverte",
  "plan.coverage.status.deferred": "Reportée",
  "plan.coverage.status.rejected": "Écartée",
  "plan.coverage.belowWaterline": "sous la ligne de flottaison",
  "plan.risks.impact": "Impact",
  "plan.risks.likelihood": "Probabilité",
  "plan.risks.mitigation": "Parade :",
  "plan.level.low": "faible",
  "plan.level.medium": "moyen",
  "plan.level.high": "élevé",
  "plan.budget.complexity": "Complexité",
  "plan.budget.horizon": "Horizon :",
  "plan.budget.estimate": "Coût estimé : entre {{low}} $ et {{high}} $, d'après les stories déjà livrées de l'office.",
  "plan.budget.noHistory": "Pas encore d'historique pour estimer le coût.",
  "plan.approval.text_one": "Les {{count}} ligne devient une story, avec {{assignments}} assignation(s) et les réglages ci-dessus, signés par toi. Le build peut ensuite démarrer. Tant que tu n'as pas approuvé, aucune story n'existe.",
  "plan.approval.text_other": "Les {{count}} lignes deviennent des stories, avec {{assignments}} assignation(s) et les réglages ci-dessus, signés par toi. Le build peut ensuite démarrer. Tant que tu n'as pas approuvé, aucune story n'existe.",
  "plan.approval.done_one": "Plan approuvé : {{count}} story créée, staffée et réglée comme décidé.",
  "plan.approval.done_other": "Plan approuvé : {{count}} stories créées, staffées et réglées comme décidé.",
  "plan.col.line": "Ligne",
  "plan.col.settings": "Réglages",
  "plan.col.team": "Équipe",
  "plan.col.priority": "Priorité",
  "plan.col.criticality": "Criticité",
  "plan.col.complexity": "Complexité",
  "plan.col.rigor": "Rigueur",
  "plan.col.trust": "Confiance",
  "plan.criticality.critical": "Critique",
  "plan.criticality.high": "Haute",
  "plan.criticality.normal": "Normale",
  "plan.criticality.low": "Basse",
  "plan.complexity.xs": "XS",
  "plan.complexity.s": "S",
  "plan.complexity.m": "M",
  "plan.complexity.l": "L",
  "plan.complexity.xl": "XL",
  "plan.line.edit": "Modifier la ligne {{code}}",
  "plan.line.editShort": "Modifier",
  "plan.line.noOutcome": "résultat non décrit",
  "plan.line.noTeam": "Aucune équipe",
  "plan.line.dependsOn": "après",
  "plan.line.whyCriticality": "Criticité :",
  "plan.line.whyStaffing": "Équipe :",
  "plan.line.floorReason": "Sous le réglage par défaut, ta raison :",
  "plan.line.changedSinceReview": "modifiée depuis la dernière revue",
  "plan.line.changedSinceApproval": "modifié depuis l'approbation",
  "plan.line.commented": "commentée",
  "plan.line.showContract": "Voir le contrat de {{code}}",
  "plan.line.hideContract": "Masquer le contrat de {{code}}",
  "plan.line.comment": "Commenter {{code}}",
  "plan.line.commentLabel": "Commentaire sur {{code}}",
  "plan.line.commentPlaceholder": "Ce qu'il faut changer dans cette ligne…",
  "plan.line.pocSet": "Réglé par toi. Camille proposait : {{proposed}}",
  "plan.line.pocSetShort": "réglé par toi",
  "plan.line.proposedDefault": "la valeur par défaut",
  "plan.line.staffingPoc": "équipe réglée par toi",
  "plan.line.unknownChampion": "Champion inconnu",
  "plan.editor.title": "Régler la ligne {{code}}",
  "plan.editor.addRole": "Ajouter un rôle…",
  "plan.editor.removeRole": "Retirer le rôle {{role}}",
  "plan.editor.floorReason": "Ce réglage est sous le niveau habituel pour cette criticité. En une ligne, pourquoi ?",
  "plan.editor.floorReasonPlaceholder": "Ex. : prototype jetable, aucune donnée réelle",
  "plan.errors.generic": "Cette modification n'a pas pu être enregistrée. Recharge le plan et réessaie.",
  "plan.errors.someLines": "certaines lignes",
  "plan.errors.field.rigor": "la rigueur",
  "plan.errors.field.trust": "la confiance",
  "plan.errors.field.effort": "l'effort",
  "plan.errors.plan_changed": "Le plan a changé depuis que tu l'as ouvert. Relis-le avant d'approuver.",
  "plan.errors.plan_hash_required": "Le plan n'a pas pu être chargé : recharge-le avant d'approuver.",
  "plan.errors.plan_hash_not_allowed": "Cette décision ne concerne pas un plan.",
  "plan.errors.plan_missing": "Camille n'a pas encore soumis de plan à approuver.",
  "plan.errors.plan_invalid": "Le plan est incomplet : Camille doit le reprendre.",
  "plan.errors.plan_not_found": "Ce plan n'existe plus. Recharge la page.",
  "plan.errors.plan_frozen": "Ce plan est déjà décidé : il ne peut plus être modifié.",
  "plan.errors.plan_line_not_found": "Cette ligne n'existe pas dans le plan.",
  "plan.errors.plan_too_large": "Ces réglages rendent le plan trop volumineux.",
  "plan.errors.stale_plan_settings": "Quelqu'un a modifié le plan en même temps. Il vient d'être rechargé : reprends ta modification.",
  "plan.errors.invalid_field": "Une valeur de ce formulaire n'est pas acceptée.",
  "plan.errors.forbidden": "Seul le POC peut régler le plan.",
  "plan.errors.poc_required": "Seul le POC de l'office peut décider ce plan.",
  "plan.errors.story_comment_unknown_sid": "Un commentaire vise une ligne qui n'existe pas ({{sids}}).",
  "plan.errors.plan_staffing_invalid": "L'équipe de {{sids}} n'est pas valide : vérifie les rôles et les champions.",
  "plan.errors.plan_staffing_role_duplicated": "Un rôle apparaît deux fois sur {{sids}}.",
  "plan.errors.plan_role_missing": "Il manque un rôle obligatoire sur {{sids}} (réalisation, relecture, ou sécurité à ce niveau de rigueur).",
  "plan.errors.plan_role_not_held": "Un champion de {{sids}} ne tient pas ce rôle sur la mission, ou son engagement n'est pas encore confirmé.",
  "plan.errors.plan_self_review": "Sur {{sids}}, un même champion ne peut pas réaliser et relire.",
  "plan.errors.plan_champion_unconfirmed": "Un champion de {{sids}} n'est pas encore engagé : confirme son engagement d'abord.",
  "plan.errors.plan_conductor_rule": "Sur {{sids}}, Camille ne peut pas tenir ce rôle.",
  "plan.errors.plan_model_not_routable": "Sur {{sids}}, le modèle choisi n'est pas disponible pour ce rôle.",
  "plan.errors.plan_p0_path_open": "Une ligne P0 ({{sids}}) attend une ligne qui n'est pas P0. Remets-les au même niveau ou change l'ordre.",
  "plan.errors.plan_floor_reason_required": "Sur {{sids}}, {{fields}} passe sous le niveau habituel pour cette criticité : écris en une ligne pourquoi.",
  "plan.errors.plan_floor_reason_required_lines": "Sur {{lines}} : sous le niveau habituel pour cette criticité. Écris en une ligne pourquoi ci-dessous, ou relève le niveau.",
  "plan.floorReason.inline.label": "{{sid}} — {{fields}} sous le niveau habituel pour cette criticité. En une ligne, pourquoi ?",
  "plan.floorReason.inline.save": "Enregistrer la raison",
  "plan.floorReason.inline.hint": "Ou relève le niveau avec le crayon de la ligne. Une fois chaque raison enregistrée, approuve le plan.",
  "plan.floorReason.inline.saved": "Raison enregistrée pour {{sid}}.",
  "plan.errors.plan_mission_not_empty": "Des stories existent déjà sur cette mission : le plan ne peut plus les créer.",
  "plan.errors.plan_spec_missing": "La spec doit être écrite avant que le plan soit décidé.",
  "plan.errors.plan_spec_stale": "La spec a été révisée depuis ce plan : Camille doit le mettre à jour.",
  "plan.errors.plan_cadrage_stale": "Le cadrage a changé depuis ce plan : Camille doit le reprendre.",
  "plan.errors.plan_gate_pending": "Une décision est déjà en attente sur ce plan.",
  "plan.errors.plan_gate_launch_refused": "Cette mission se construit à partir de son plan approuvé : lancez-la avec « Lancer le build » dans la vue mission, pas depuis ce flux.",
  "plan.errors.plan_gate_requires_plan_review": "Cette mission passe en build uniquement par son plan : ouvrez la revue du plan pour l'approuver.",
  "plan.errors.plan_not_approved": "Le plan n'est pas encore approuvé : aucune story ne peut être créée.",
  "plan.errors.mode_not_allowed": "Le mode de la mission se règle dans l'en-tête du plan, pas dans cette décision.",
  "plan.errors.story_set_hash_not_allowed": "Cette décision concerne un plan, pas une liste de stories.",
  "plan.errors.critique_urgent_unavailable": "Critique × Urgent n'est pas disponible : Critique exige audit et redondance.",
  "plan.errors.invalid_constraints": "Ces réglages de finition, rythme ou budget ne sont pas valides.",
  "plan.errors.invalid_budget": "Ce montant n'est pas possible.",
  "plan.errors.invalid_finition": "Ce niveau de finition n'existe pas.",
  "plan.errors.invalid_rythme": "Ce rythme n'existe pas.",
  "plan.errors.invalid_order": "Cet ordre ne reprend pas exactement les lignes du plan. Recharge le plan.",
  "plan.errors.plan_cost_basis_missing": "Ce plan n'a pas encore d'estimation de coût : Camille doit le soumettre à nouveau.",
  "plan.errors.waterline_p0_below": "Une ligne P0 ({{sids}}) est sous la ligne de flottaison : monte le budget, baisse la finition ou le rythme, ou passe-la en P1.",
  "plan.errors.waterline_dependency_below": "{{sids}} dépend d'une ligne sous la ligne de flottaison : change l'ordre ou le budget.",
  "plan.errors.rigor_derived_from_finition": "La rigueur de la mission découle de la finition : règle la finition.",
  "plan.errors.stale_constraints": "Les contraintes de la mission ont changé entre-temps : recharge le plan.",
  "plan.errors.budget_below_spend": "Le budget ne peut pas descendre sous ce qui est déjà dépensé.",
  "plan.section.method": "Méthode suivie",
  "plan.section.appetite": "Appétit",
  "plan.section.breadboard": "Breadboard",
  "plan.section.rabbit_holes": "Trous de lapin et hors-jeu",
  "plan.section.mock": "Maquette",
  "mission.process.stepState.poc_skipped": "Sautée par le POC",
  "mission.process.evidence.ask_answered": "Question répondue par le POC",
  "mission.process.evidence.breadboard_section": "Preuve : {{ref}}",
  "mission.process.evidence.plan": "Plan v{{version}} soumis au POC",
  "mission.process.evidence.appetite": "Appétit confirmé par le POC",
  "methodology.evidence.breadboard": "Ouvrir le breadboard",
  "methodology.evidence.appetite": "Appétit confirmé par le POC",
  "methodology.evidence.appetiteText": "Appétit confirmé par le POC : {{text}}",
  "methodology.evidence.askAnswered": "Question répondue par le POC",
  "methodology.skippedByYou": "Sautée par toi — {{reason}}",
  "methodology.skippedByPoc": "Sautée par le POC — {{reason}}",
  "methodology.how": "Comment la prouver : {{how}}",
  "methodology.howFor.appetite": "l'appétit vient de toi — Camille te le demande s'il manque",
  "methodology.howFor.breadboard_section": "Camille l'écrit dans le breadboard",
  "methodology.howFor.signoff": "ta décision sur la validation de la phase",
  "methodology.howFor.file": "Camille enregistre le document de l'étape",
  "methodology.howFor.plan": "rendu automatiquement quand Camille soumet le plan",
  "methodology.howFor.ask": "Camille te pose la question ; ta réponse en est la preuve",
  "methodology.howFor.record": "Camille enregistre une preuve vérifiable (document, question, décision ou lien)",
  "methodology.skip.action": "Sauter cette étape",
  "methodology.skip.undo": "Annuler le saut",
  "methodology.skip.reasonLabel": "Pourquoi sauter cette étape ? (10 à 200 caractères)",
  "methodology.skip.reasonPlaceholder": "ex. : les entretiens clients ont déjà eu lieu hors plateforme",
  "methodology.skip.confirm": "Confirmer le saut",
  "methodology.skip.error.generic": "Le saut n'a pas pu être enregistré. Réessaie.",
  "methodology.skip.error.skip_reason_required": "Donne une raison de 10 à 200 caractères.",
  "methodology.skip.error.step_already_done": "Cette étape est déjà prouvée : rien à sauter.",
  "methodology.skip.error.gate_not_skippable": "Le gate de la phase est ta propre décision : il ne se saute pas.",
  "methodology.skip.error.poc_required": "Seul le POC peut sauter une étape.",
  "methodology.skip.error.phase_not_reached": "Cette phase n'a pas encore commencé.",
  "methodology.skip.error.step_not_in_phase": "Cette étape n'est plus dans la méthode de la phase.",
  "methodology.skip.error.step_not_skipped": "Cette étape n'est pas sautée.",
  "methodology.gateWaiting_one": "Le gate attend : {{count}} étape",
  "methodology.gateWaiting_other": "Le gate attend : {{count}} étapes",
  "methodology.unavailable": "La méthode de la phase n'a pas pu être lue.",
  "methodology.appetite.missing": "Appétit non confirmé par le POC.",
  "methodology.appetite.constraints": "Réglé par le POC",
  "methodology.appetite.cadrage": "Confirmé par le POC au cadrage",
  "breadboard.title": "Breadboard",
  "breadboard.loading": "Chargement du breadboard…",
  "breadboard.loadFailed": "Le breadboard n'a pas pu être chargé.",
  "breadboard.missing": "Pas encore de breadboard.md.",
  "breadboard.none": "Aucun — {{reason}}",
  "breadboard.affordances": "Ce qu’on peut faire dans {{place}}",
  "breadboard.to": "vers",
  "breadboard.section.problem": "Problème",
  "breadboard.section.places": "Lieux",
  "breadboard.section.connections": "Connexions",
  "breadboard.section.rabbit_holes": "Trous de lapin",
  "breadboard.section.no_gos": "Hors-jeu",
  "breadboard.errorsTitle_one": "Breadboard incomplet : {{count}} point à corriger",
  "breadboard.errorsTitle_other": "Breadboard incomplet : {{count}} points à corriger",
  "breadboard.error.generic": "La section {{section}} est à revoir.",
  "breadboard.error.section_missing": "La section {{section}} manque.",
  "breadboard.error.section_too_long": "La section {{section}} est trop longue.",
  "breadboard.error.section_empty": "La section {{section}} est vide.",
  "breadboard.error.problem_too_short": "Le problème est trop court pour parier dessus.",
  "breadboard.error.problem_copies_objective": "Le problème recopie l'objectif : il doit dire ce qui coince.",
  "breadboard.error.place_line_invalid": "Une ligne de lieu est mal formée : {{detail}}",
  "breadboard.error.place_duplicate": "Lieu en double : {{detail}}",
  "breadboard.error.place_without_affordance": "Le lieu {{detail}} n'a aucune action possible.",
  "breadboard.error.affordances_too_many": "Trop d’actions pour le lieu {{detail}}.",
  "breadboard.error.places_too_many": "Trop de lieux.",
  "breadboard.error.places_too_few": "Il faut au moins deux lieux.",
  "breadboard.error.connection_line_invalid": "Une ligne de connexion est mal formée : {{detail}}",
  "breadboard.error.connection_unknown_place": "Une connexion mène à un lieu non déclaré : {{detail}}",
  "breadboard.error.connection_affordance_unknown": "Une connexion passe par une action que le lieu n'a pas : {{detail}}",
  "breadboard.error.connections_too_many": "Trop de connexions.",
  "breadboard.error.none_reason_too_short": "« Aucun » doit donner une raison (10 caractères au moins).",
  "mock.title": "Maquette de shaping",
  "mock.status.requested": "Demandée",
  "mock.status.generating": "En génération",
  "mock.status.ready": "Prête — à toi de décider",
  "mock.status.changes_requested": "Changements demandés",
  "mock.status.validated": "Validée",
  "mock.status.waived": "Dispensée",
  "mock.status.abandoned": "Abandonnée",
  "mock.status.failed": "Échouée",
  "mock.status.declined": "Déclinée",
  "mock.round": "Tour {{round}} / {{max}}",
  "mock.generatingNow": "En génération…",
  "mock.generatingSince": "En génération depuis {{minutes}} min",
  "mock.costTitle": "Coût par tour",
  "mock.roundCost": "Tour {{round}} : {{cost}}",
  "mock.total": "Total {{cost}}",
  "mock.open": "Ouvrir la maquette",
  "mock.validate": "Valider la maquette",
  "mock.changes": "Demander des changements",
  "mock.extraRound": "Un tour de plus",
  "mock.retry": "Réessayer",
  "mock.abandon": "Abandonner la maquette",
  "mock.capNote": "Les {{max}} tours sont faits : valide, abandonne ou accorde un tour de plus.",
  "mock.changesLabel": "Ce qui doit changer (10 à 1000 caractères)",
  "mock.changesPlaceholder": "ex. : le plan doit apparaître avant le programme",
  "mock.changesSend": "Envoyer les changements",
  "mock.cancel": "Annuler",
  "mock.declined": "Maquette de shaping déclinée par le POC.",
  "mock.notOffered": "Maquette de shaping : non proposée.",
  "mock.viewer.title": "Maquette — tour {{round}}",
  "mock.viewer.note": "Maquette jetable, données fictives. Elle tourne isolée du Studio.",
  "mock.viewer.navigatedAway": "La page a quitté la maquette (navigation vers une autre adresse) : elle a été fermée par sécurité. Ferme puis rouvre la maquette.",
  "mock.viewer.stalled": "La maquette a perturbé l'annotation (messages hors séquence) : recharge-la pour continuer.",
  "mock.viewer.reload": "Recharger la maquette",
  "mock.annotate.title": "Annotations de la maquette",
  "mock.annotate.sendWith": "{{count}} annotation(s) partira(ont) avec ce tour — le commentaire global devient facultatif.",
  "mock.annotate.element": "Annoter un élément",
  "mock.annotate.cancel": "Annuler la sélection",
  "mock.annotate.armedHint": "Cliquez l'élément à commenter. Clavier : Tab / Maj+Tab pour parcourir, flèche haut = parent, flèche bas = enfant, Entrée pour choisir, Échap pour annuler.",
  "mock.annotate.waiting": "Chargement de la maquette…",
  "mock.annotate.channelClosed": "La maquette envoie trop de messages : l'annotation est coupée pour cette ouverture. Fermez puis rouvrez la maquette.",
  "mock.annotate.count": "{{count}} / {{max}}",
  "mock.annotate.empty": "Aucune annotation. Pointez un élément de la maquette pour dire ce qui ne va pas.",
  "mock.annotate.listTitle": "Annotations",
  "mock.annotate.showList": "Afficher",
  "mock.annotate.hideList": "Masquer",
  "mock.annotate.number": "Annotation {{n}} :",
  "mock.annotate.zone": "zone {{w}} × {{h}}",
  "mock.annotate.details": "Détails de l'élément",
  "mock.annotate.selector": "Sélecteur",
  "mock.annotate.path": "Chemin",
  "mock.annotate.box": "Boîte",
  "mock.annotate.boxValue": "x {{x}}, y {{y}} — {{w}} × {{h}} px",
  "mock.annotate.styles": "Styles",
  "mock.annotate.comment": "Commentaire de l'annotation {{n}}",
  "mock.annotate.commentPlaceholder": "ex. : ce bouton doit être plus visible",
  "mock.annotate.commentHint": "{{count}} caractères — {{min}} à {{max}}, obligatoire",
  "mock.annotate.commentTooShort": "Au moins {{min}} caractères.",
  "mock.annotate.delete": "Supprimer l'annotation {{n}}",
  "mock.annotate.added": "Annotation {{n}} ajoutée",
  "mock.annotate.removed": "Annotation supprimée — il en reste {{count}}",
  "mock.annotate.estimate": "Ce tour : {{cost}} (≤ {{cap}})",
  "mock.annotate.estimateUnknown": "Ce tour : coût inconnu (modèle sans tarif).",
  "mock.annotate.noVision": "Ce modèle ne lit pas les images : chaque zone est décrite par son rectangle et ses éléments.",
  "mock.annotate.imagesTrimmed": "Les images des zones dépassent le plafond du tour : chaque zone est décrite par son rectangle et ses éléments.",
  "mock.error.mock_input_too_large": "Les annotations de ce tour dépassent le plafond de la génération, même raccourcies. Pas de maquette pour cette étape, ou un nouveau tour avec moins d'annotations.",
  "mock.annotate.caps.annotations": "{{max}} annotations au plus par tour.",
  "mock.annotate.region": "Entourer une zone",
  "mock.annotate.cancelRegion": "Annuler la zone",
  "mock.annotate.armedRegionHint": "Tracez un rectangle sur la maquette. Clavier : flèches pour déplacer (Maj = 1 px), Alt + flèches pour redimensionner, Entrée pour capturer, Échap pour annuler.",
  "mock.annotate.approx": "aperçu approximatif",
  "mock.annotate.thumbAlt": "Aperçu approximatif de la zone {{n}} ({{w}} × {{h}} px)",
  "mock.annotate.zoneDetails": "Détails de la zone",
  "mock.annotate.elements": "Éléments",
  "mock.annotate.noElements": "Aucun élément repéré dans la zone.",
  "mock.annotate.captureFailed": "Capture impossible — la zone et ses éléments sont gardés.",
  "mock.annotate.captureTooLarge": "Capture trop lourde — la zone et ses éléments sont envoyés.",
  "mock.annotate.captureUnsupported": "Ce navigateur ne sait pas capturer la maquette — la zone et ses éléments sont gardés.",
  "mock.annotate.captureRefused": "Capture refusée par le contrôle d'image — la zone et ses éléments sont gardés.",
  "mock.annotate.caps.images": "{{max}} captures au plus par tour — cette zone et ses éléments sont gardés sans image.",
  "mock.error.generic": "La maquette n'a pas pu être traitée. Réessaie.",
  "mock.wake.queued": "Décision enregistrée. Camille termine l'étape en cours, puis reprend ta décision.",
  "mock.wake.held": "Décision enregistrée. Camille est en pause (budget de réveils atteint) : elle la reprend dès que le budget le permet.",
  "mock.wake.unavailable": "Décision enregistrée, mais Camille n'a pas pu être prévenue : écris-lui dans le chat pour la relancer.",
  "mock.error.mock_real_pii_suspected": "La maquette contenait des données qui ressemblent à de vraies données personnelles : elle a été refusée.",
  "mock.error.mock_real_pii_suspected.email": "Refusée : e-mail réel suspecté. Réessaie le même tour.",
  "mock.error.mock_real_pii_suspected.phone": "Refusée : numéro de téléphone réel suspecté. Réessaie le même tour.",
  "mock.error.mock_real_pii_suspected.address": "Refusée : adresse postale réelle suspectée. Réessaie le même tour.",
  "mock.error.mock_real_pii_suspected.card": "Refusée : numéro de carte bancaire suspecté. Réessaie le même tour.",
  "mock.error.mock_real_pii_suspected.iban": "Refusée : IBAN réel suspecté. Réessaie le même tour.",
  "mock.error.mock_real_pii_suspected.nir": "Refusée : numéro de sécurité sociale suspecté. Réessaie le même tour.",
  "mock.error.mock_real_pii_suspected.external_url": "Refusée : lien vers un site externe. Réessaie le même tour.",
  "mock.error.mock_output_invalid": "Le fichier généré n'était pas une maquette autonome valide (ressource externe, réseau ou bannière manquante).",
  "mock.error.mock_truncated": "La maquette était trop longue pour la limite de ce tour : rien n'a été enregistré. Réessaie le même tour.",
  "mock.error.mock_timeout": "Le générateur a mis trop de temps à répondre. Réessaie le même tour.",
  "mock.error.mock_generation_failed": "La génération a échoué. Tu peux redemander une maquette.",
  "mock.error.mock_interrupted": "La génération a été interrompue. Tu peux redemander une maquette.",
  "mock.error.mock_job_unavailable": "Le générateur de maquette n'est pas joignable pour l'instant.",
  "mock.error.mock_job_busy": "Une maquette est déjà en génération pour cette mission.",
  "mock.error.mock_job_crashed": "La génération a échoué. Tu peux redemander une maquette.",
  "mock.error.mock_store_failed": "La maquette n'a pas pu être enregistrée.",
  "mock.error.mock_store_failed.read_only_mirror": "La maquette n'a pas pu être enregistrée : cette mission reflète son dépôt GitHub et son dossier de mission n'est pas encore synchronisé. Relancer ne coûte rien et fonctionnera une fois le dossier synchronisé.",
  "mock.error.mock_role_missing": "Personne dans l'équipe ne peut dessiner la maquette (designer ou frontend).",
  "mock.error.mock_scan_unavailable": "Le contenu de la maquette n'a pas pu être vérifié : elle reste bloquée.",
  "mock.error.stale_mock": "La maquette a changé entre-temps : la vue est rafraîchie, refais ton choix.",
  "mock.error.mock_status": "La maquette n'attend pas de décision en ce moment.",
  "mock.error.ui_mock_round_cap": "Les tours sont épuisés : valide, abandonne ou accorde un tour de plus.",
  "mock.error.poc_required": "Seul le POC décide de la maquette.",
  "mock.error.mock_not_found": "Maquette introuvable.",
  "mock.error.invalid_input": "Le commentaire doit faire 10 à 1000 caractères.",
  "mock.line.queued": "En file d'attente — démarre après la maquette en cours",
  "mock.line.chip": "Maquette",
  "mock.line.serves": "Avant le backend de",
  "mock.line.note": "Ligne ajoutée par le serveur : écrans sur données factices, validés par toi sur une preview.",
  "mock.line.ui": "UI",
  "mock.line.uiTitle": "Cette ligne change un écran",
  "mock.line.mockTitle": "Maquette de cette ligne",
  "mock.line.mock.auto": "Maquette d'abord",
  "mock.line.mock.waived": "Sans maquette",
  "mock.line.mock.unavailable": "Maquette indisponible",
  "mock.line.by.poc": "POC",
  "mock.line.by.office": "office",
  "mock.line.by.server": "serveur",
  "mock.line.byNamed": "{{source}} · {{name}}",
  "plan.htmlMock.chip": "Maquette",
  "plan.htmlMock.serves": "Sert",
  "plan.htmlMock.note": "Maquette HTML générée par le serveur, validée par toi avant leurs stories.",
  "plan.htmlMock.budget": "Maquettes UI : {{count}} × un tour de maquette (≤ 3 tours chacune)",
  "plan.htmlMock.banner": "Maquette facultative pour cet office (réglage de {{by}}, {{date}}) — chaque ligne UI peut en redemander une.",
  "mock.editor.ui": "Cette ligne change un écran",
  "mock.editor.waive": "Pas de maquette pour cette ligne",
  "mock.editor.waiveReason": "Pourquoi pas de maquette ?",
  "mock.editor.waivePlaceholder": "ex. : texte seulement, aucun écran nouveau",
  "mock.story.round": "Maquette UI — tour {{round}} / {{max}}",
  "mock.story.serves": "avant {{sids}}",
  "mock.story.note": "Valider = la maquette est bonne, le backend des écrans peut commencer. Demander des changements = un nouveau tour de maquette, pas un échec.",
  "mock.story.waiting": "En attente de la validation de la maquette {{sid}}",
  "mock.story.waitingHtml": "En attente de la validation de « {{title}} » ({{key}})",
  "mock.line.titleFallback": "Maquette UI",
  "mock.line.servesList": "Sert {{sids}}",
  "mock.line.retry": "Relancer",
  "mock.line.waive": "Pas de maquette pour cette étape",
  "mock.line.waiveLabel": "Pourquoi pas de maquette pour cette étape ?",
  "mock.line.waiveHint": "{{count}} / 200 caractères visibles (10 minimum)",
  "mock.line.waiveSend": "Confirmer : pas de maquette",
  "mock.line.waiveNote": "Les stories UI de cette étape partiront sans maquette. Ta raison est journalisée.",
  "mock.line.waived": "Sans maquette — {{reason}}",
  "mock.line.panelTitle": "Maquettes UI des étapes",
  "mock.line.panelNote": "Chaque étape qui change un écran a sa maquette : ses stories UI attendent ta validation.",
  "mock.story.openMock": "Voir la maquette",
  "mock.history.title": "Historique",
  "mock.history.show": "Voir l'historique",
  "mock.history.hide": "Masquer l'historique",
  "mock.history.loading": "Chargement de l'historique…",
  "mock.history.error": "L'historique n'a pas pu être chargé.",
  "mock.history.empty": "Aucun tour décidé pour l'instant.",
  "mock.history.round": "Tour {{round}}",
  "mock.history.verdict.validate": "Validé",
  "mock.history.verdict.changes": "Changements demandés",
  "mock.history.verdict.abandon": "Abandonné",
  "mock.history.pending": "En attente de décision",
  "mock.history.decidedBy": "par {{name}} le {{date}}",
  "mock.history.someone": "un POC",
  "mock.history.validatedBy": "Validée par {{name}} le {{date}} — tour {{round}}",
  "mock.history.waivedBy": "Sans maquette, décidé par {{name}} le {{date}} : {{reason}}",
  "mock.history.comment": "Commentaire global",
  "mock.history.annotations_one": "{{count}} annotation",
  "mock.history.annotations_other": "{{count}} annotations",
  "mock.history.noAnnotations": "Aucune annotation.",
  "mock.history.element": "Élément",
  "mock.history.region": "Zone {{w}} × {{h}}",
  "mock.history.notes": "notes pour le build",
  "mock.history.approx": "aperçu approximatif",
  "mock.history.imageAlt": "Capture de la zone {{n}} (aperçu approximatif)",
  "mock.history.capture.failed": "Capture impossible — la zone et ses éléments sont gardés",
  "mock.history.capture.unsupported": "Capture non prise en charge par ce navigateur — la zone et ses éléments sont gardés",
  "mock.history.capture.too_large": "Capture trop lourde — la zone et ses éléments sont envoyés",
  "mock.history.model": "Modèle {{model}}",
  "mock.editor.waiveHint": "{{count}} / 200 caractères visibles (10 minimum)",
  "mock.error.mock_line_abandon": "Une maquette d'étape ne s'abandonne pas : choisis « Pas de maquette pour cette étape ».",
  "mock.error.mock_scope": "Cette maquette ne se décide pas ici.",
  "mock.error.annotations_not_allowed": "Les annotations accompagnent « Valider » ou « Demander des changements » seulement.",
  "mock.error.annotations_cap": "12 annotations au plus par tour.",
  "mock.error.images_cap": "6 captures au plus par tour.",
  "mock.error.images_total_cap": "Les captures dépassent 1,5 Mo pour ce tour : retire une zone.",
  "mock.error.annotation_n_duplicate": "Deux annotations portent le même numéro.",
  "mock.error.annotation_comment": "Chaque annotation demande un commentaire de 3 à 500 caractères.",
  "mock.error.annotation_invalid": "Une annotation est illisible : supprime-la et recommence.",
  "mock.error.annotation_target_too_large": "Une annotation est trop volumineuse : supprime-la et recommence.",
  "mock.error.annotation_image_invalid": "Une capture a été refusée : supprime la zone et recommence.",
  "mock.error.annotation_real_data": "Une annotation contient ce qui ressemble à une vraie donnée personnelle : l'envoi est refusé.",
  "mock.error.comment_real_data": "Ton commentaire contient ce qui ressemble à une vraie donnée personnelle : retire-la.",
  "mock.error.annotation_store_failed": "Les captures n'ont pas pu être enregistrées. Réessaie.",
  "mock.error.payload_too_large": "Le tour est trop lourd à envoyer : retire une capture.",
  "mock.error.mock_not_viewable": "Cette maquette ne s'ouvre pas dans le viewer.",
  "mock.error.waive_reason": "La raison doit faire 10 à 200 caractères visibles.",
  "connectionCard.waitingPoc": "En attente du POC",
  "connectionCard.action.connect": "Connecter {{name}}",
  "connectionCard.action.reconnect": "Reconnecter {{name}}",
  "connectionCard.action.connecting": "Ouverture…",
  "connectionCard.action.authorize": "Autoriser pour cette mission",
  "connectionCard.action.authorizing": "Autorisation…",
  "connectionCard.scope.office": "Connecté pour l'office",
  "connectionCard.scope.mission": "Autorisé pour cette mission",
  "connectionCard.scope.missionPending": "Pas encore autorisé pour cette mission",
  "connectionCard.unavailable.not_published": "{{name}} n'est pas encore proposé sur cette plateforme — l'équipe Nova doit l'activer.",
  "connectionCard.unavailable.not_configured": "Les sources de données ne sont pas activées sur cette plateforme.",
  "connectionCard.unavailable.directory_error": "Impossible de lire l'état de la connexion pour l'instant. Réessayez plus tard.",
  "connectionCard.repo.linked": "Dépôt lié : {{list}}",
  "connectionCard.repo.managed": "Aucun dépôt GitHub lié — la mission utilise son dépôt géré ({{name}}).",
  "connectionCard.repo.none": "Aucun dépôt n'est lié à cette mission, à son projet ni à l'office.",
  "connectionCard.repo.link": "Lier un dépôt à l'office",
  "connectionCard.repo.candidates": "Plusieurs dépôts sont liés à l'office ({{list}}) — Camille vous demandera lequel cette mission utilise.",
  "connectionCard.repo.linkHint": "Choisissez-le sur la page GitHub de l'office (nouvel onglet) — cette mission l'utilise ensuite. Cette carte se met à jour à votre retour.",
  "connectionCard.repo.onboarding": "{{name}} est lié à l'office — son onboarding n'est pas encore terminé (PR de bootstrap), le build ne peut pas encore l'utiliser. Cette carte se met à jour quand il est prêt.",
  "connectionCard.repo.failed": "{{name}} est lié à l'office, mais son onboarding a échoué — le build ne peut pas l'utiliser. La page GitHub de l'office indique la marche à suivre.",
  "connectionCard.repo.followOnboarding": "Suivre l'onboarding",
  "connectionCard.toast.connected": "{{name}} est connecté.",
  "connectionCard.toast.notConnected": "La connexion n'a pas abouti — réessayez depuis la carte.",
  "connectionCard.toast.pocOnly": "Seul le POC de l'office peut faire cette action.",
  "connectionCard.toast.error": "Action impossible pour l'instant. Réessayez.",
  "champion.step.propose_connection": "propose une connexion",
  "champion.step.list_mission_repos": "vérifie le dépôt lié",
  "champion.tooling.sandbox.label": "Sandbox",
  "champion.tooling.sandbox.hint": "Code dans une sandbox isolée",
  "champion.tooling.codemode.label": "Code Mode",
  "champion.tooling.codemode.hint": "Exécute du code léger (Code Mode)",
  "champion.tooling.conversation.label": "Conversation",
  "champion.tooling.conversation.hint": "Agent de conversation — pas de sandbox",
  "workspace.champion.modelRoute.default": "Demande simple : modèle par défaut",
  "workspace.champion.modelRoute.complex": "Demande jugée complexe : modèle plus fort",
  "workspace.champion.modelRoute.escalated": "Passée à un modèle plus fort en cours de conversation",
  "workspace.champion.modelRoute.kept": "Modèle conservé pour la conversation en cours",
  "workspace.champion.modelRoute.budget": "Limité par le budget du bureau",
  "workspace.champion.modelRoute.gate": "Étape de validation : modèle fixe",
  "workspace.champion.modelRoute.pinned": "Modèle fixé (mission ou bureau)",
  "workspace.champion.modelRoute.uncertain": "Modèle par défaut conservé",
  "workspace.champion.modelRoute.router_unavailable": "Routage indisponible : modèle par défaut",
  "workspace.tickets.state.wait": "Attend ta réponse",
  "workspace.tickets.state.run": "En cours",
  "workspace.tickets.state.review": "En revue",
  "workspace.tickets.state.blocked": "Bloqué",
  "workspace.tickets.state.todo": "À faire",
  "workspace.tickets.state.done": "Terminé",
  "workspace.tickets.state.idle": "En cours · inactif",
  "prototype.title": "Prototype",
  "prototype.status.running": "En cours",
  "prototype.status.ready": "Prêt",
  "prototype.status.error": "Erreur",
  "prototype.status.summarized": "Tour interrompu",
  "prototype.status.budget_exceeded": "Budget atteint",
  "prototype.status.approved": "Validé",
  "prototype.status.promoted": "En ligne",
  "prototype.status.handed_off": "Version robuste lancée",
  "prototype.status.skipped": "Passé",
  "prototype.version": "v{{n}}",
  "prototype.buildingFirst": "Le prototype se construit — un premier aperçu arrive dans quelques minutes.",
  "prototype.updating": "Votre modification est en cours…",
  "prototype.hostDown": "Le prototype est injoignable pour le moment. Réessayez dans un instant.",
  "prototype.turnFailed": "Le dernier tour n'a pas abouti. Décrivez le changement à Camille pour réessayer.",
  "prototype.startFailed": "Le prototype n'a pas pu démarrer. Réessayez, ou demandez à Camille de le relancer.",
  "prototype.retryStart": "Réessayer",
  "prototype.retryRows": "Relancer l'import des données",
  "prototype.error.prototype_not_retryable": "Il n'y a rien à relancer : le prototype a déjà démarré.",
  "prototype.error.prototype_not_eligible": "Cette mission ne peut plus être prototypée.",
  "prototype.error.handoff_rows_not_retryable": "Il n'y a pas d'import de données à relancer.",
  "prototype.summarized": "Le dernier tour a atteint sa limite : la dernière version qui fonctionne reste en ligne.",
  "prototype.budgetExceeded": "Le budget prototype du jour ({{cap}}) est atteint : les modifications reprennent demain.",
  "prototype.turnFacts": "Dernier tour",
  "prototype.cost": "Coût du dernier tour : {{cost}}",
  "prototype.duration": "Durée : {{duration}}",
  "prototype.firstReady": "Premier aperçu en {{duration}}",
  "prototype.open": "Ouvrir l'aperçu privé",
  "prototype.privateNote": "Lien privé, valable 12 h, réservé à vous. Les données saisies sont conservées d'une version à l'autre.",
  "prototype.linkStaffOnly": "L'aperçu de ce prototype n'est pas encore ouvert aux clients sur cet environnement.",
  "prototype.robustBanner": "Passer en version robuste — raison : {{reason}}",
  "prototype.trigger.sensitive_data": "données personnelles ou sensibles",
  "prototype.trigger.size": "plus grand que ce qu'un prototype tient",
  "prototype.trigger.out_of_model": "besoin hors du modèle prototype",
  "prototype.trigger.client_request": "spec ou revue demandée",
  "prototype.trigger.red_streak": "deux tours en échec de suite",
  "prototype.trigger.model_flag": "signalé par l'agent prototype",
  "prototype.dismiss": "Lever ce déclencheur",
  "prototype.dismissLabel": "Pourquoi lever ce déclencheur ?",
  "prototype.dismissPlaceholder": "Ex. : ce sont des données de test, aucune vraie adresse",
  "prototype.dismissSend": "Lever",
  "prototype.reasonHint": "Entre {{min}} et {{max}} caractères.",
  "prototype.cancel": "Annuler",
  "prototype.versions_one": "{{count}} version",
  "prototype.versions_other": "{{count}} versions",
  "prototype.current": "(actuelle)",
  "prototype.restoredFrom": "restaurée depuis v{{n}}",
  "prototype.versionBroken": "(non publiée)",
  "prototype.restore": "Restaurer v{{n}}",
  "prototype.approve": "Valider ce prototype",
  "prototype.skip": "Passer cette étape",
  "prototype.skipLabel": "Pourquoi passer le prototype ?",
  "prototype.skipPlaceholder": "Ex. : nous avons déjà des maquettes validées",
  "prototype.skipSend": "Passer le prototype",
  "prototype.skipped": "Prototype passé à la demande du client.",
  "prototype.skippedNoUi": "Pas de prototype : cette mission n'a pas d'interface.",
  "prototype.consent": "J'accepte la mise en ligne de la version v{{n}} telle quelle, avec les données saisies.",
  "prototype.promoteAction": "Mettre en ligne",
  "prototype.promoteUnavailable": "La mise en ligne directe d'un prototype n'est pas encore disponible. Pour publier l'application, passez en version robuste.",
  "prototype.handoffAction": "Passer en version robuste",
  "prototype.promote.deploying": "Mise en ligne de v{{version}} en cours…",
  "prototype.promote.propagating": "Propagation en cours…",
  "prototype.promote.live": "En ligne :",
  "prototype.promote.failed": "La mise en ligne a échoué.",
  "prototype.promote.count_mismatch": "Mise en ligne arrêtée : le nombre de lignes copiées ne correspond pas.",
  "prototype.handoff.packaged": "Version robuste lancée : le dépôt se prépare, les données suivent.",
  "prototype.handoff.imported": "Version robuste lancée : dépôt créé, données importées et vérifiées.",
  "prototype.handoff.kept_live": "Version robuste lancée : les données de l'app en ligne sont conservées.",
  "prototype.handoff.count_mismatch": "Données de la version robuste : le nombre de lignes ne correspond pas — à vérifier.",
  "prototype.handoff.failed": "L'import des données de la version robuste a échoué.",
  "prototype.error.generic": "L'action n'a pas abouti. Réessayez.",
  "prototype.error.poc_required": "Seul le client référent peut faire cette action.",
  "prototype.error.turn_running": "Attendez la fin du tour en cours.",
  "prototype.error.version_not_green": "Cette version ne fonctionne pas : choisissez une version publiée.",
  "prototype.error.phase_closed": "Cette étape est terminée.",
  "prototype.error.prototype_trigger_active": "Un déclencheur « Garanties » est actif : passez en version robuste ou levez-le.",
  "prototype.error.prototype_budget_exceeded": "Le budget prototype du jour est atteint.",
  "prototype.error.not_configured": "La mise en ligne n'est pas encore disponible sur cet environnement.",
  "prototype.error.count_mismatch": "Le nombre de lignes copiées ne correspond pas.",
  "prototype.error.promote_in_progress": "Une mise en ligne est déjà en cours.",
  "prototype.error.reason_invalid": "La raison doit faire entre 10 et 200 caractères.",
  "prototype.error.not_active": "Ce déclencheur n'est plus actif.",
  "prototype.error.prototype_host_error": "Le prototype est injoignable pour le moment.",
  "settings.github.missionLimitUnlimited": "illimité",
  "settings.github.officeLimitLabel": "Missions actives du bureau (tous les dépôts)",
  "settings.github.missionLimitInert": "Une limite par dépôt supérieure à celle du bureau n'a pas d'effet.",
  "settings.github.missionCounts": "{{active}} actives · {{queued}} en attente",
  "settings.github.officeBusy": "Ce bureau exécute déjà {{count}} missions actives (limite {{limit}}).",
  "build.errors.office_busy": "Ce bureau exécute déjà son nombre maximal de missions actives.",
  "build.amendment.title": "Amendement #{{seq}} proposé par Camille : {{codes}}",
  "build.amendment.beforeRelease": "Une fois approuvé, il rejoint le build : la mise en ligne attend sa livraison.",
  "build.amendment.envelope": "Estimé {{estimate}} · budget {{budget}} · dépensé {{spent}} · stories en cours {{open}} · reste {{remaining}}",
  "build.amendment.over": "Ne tient pas dans l'enveloppe.",
  "build.amendment.approve": "Approuver",
  "build.amendment.approveOver": "Approuver au-delà de l'enveloppe",
  "build.amendment.confirmOver": "Le budget n'est pas augmenté : le build s'arrêtera au plafond actuel si la dépense le dépasse. Approuver quand même ?",
  "build.amendment.confirmOverYes": "Oui, approuver",
  "build.amendment.reject": "Renvoyer",
  "build.amendment.rejectComment": "Pourquoi (facultatif)",
  "build.amendment.rejectConfirm": "Renvoyer à Camille",
  "build.amendment.cancel": "Annuler",
  "build.amendment.pocOnly": "Le POC décide de cet amendement.",
  "build.amendment.last.approved": "Amendement #{{seq}} approuvé : {{codes}} rejoint le build.",
  "build.amendment.last.rejected": "Amendement #{{seq}} renvoyé ({{codes}}).",
  "build.amendment.errors.amendment_changed": "L'amendement a changé : relisez-le avant de décider.",
  "build.amendment.errors.amendment_stale": "L'amendement ne correspond plus au build : Camille doit le reproposer.",
  "build.amendment.errors.amendment_over_envelope": "Il ne tient plus dans l'enveloppe : utilisez « Approuver au-delà de l'enveloppe ».",
  "build.amendment.errors.release_open": "La mise en ligne est déjà demandée : le périmètre ne peut plus grandir dans ce build.",
  "build.amendment.errors.poc_required": "Seul le POC décide.",
  "build.amendment.errors.unknown": "La décision n'a pas pu être enregistrée.",
  "build.amendment.sensitive": "Touche des chemins sensibles : {{paths}}",
  "build.amendment.belowOversight": "Supervision plus légère que celle de la mission :",
  "build.amendment.belowField": "{{field}} {{line}} (mission : {{mission}})",
  "build.amendment.approveBelowOversight": "Approuver avec une supervision réduite",
  "build.amendment.confirmBelowOversight": "Ces stories tourneront avec moins de supervision que le reste de la mission (confiance / rigueur ci-dessus). Approuver quand même ?",
  "build.amendment.confirmBelowOversightYes": "Oui, avec une supervision réduite",
  "build.amendment.last.approved_unscheduled": "Amendement #{{seq}} approuvé après l'ouverture de la mise en ligne : {{codes}} n'est PAS dans ce build (stories annulées).",
  "build.amendment.errors.amendment_below_oversight": "Supervision réduite : confirmez-la avec « Approuver avec une supervision réduite ».",
  "build.amendment.errors.amendment_below_floor": "Une ligne touche des chemins sensibles sous le plancher de criticité : Camille doit la reproposer.",
  "build.amendment.field.outcome": "Résultat",
  "build.amendment.field.priority": "Priorité",
  "build.amendment.field.complexity": "Complexité",
  "build.amendment.field.criticality": "Criticité",
  "build.amendment.field.trust": "Confiance",
  "build.amendment.field.rigor": "Rigueur",
  "build.amendment.field.finition": "Finition",
  "build.amendment.field.floor_rigor": "Rigueur plancher",
  "build.amendment.field.floor_reason": "Raison du plancher",
  "build.amendment.field.estimate_usd": "Estimé ($)",
  "build.amendment.field.champion": "Rôle",
  "build.amendment.field.depends_on": "Dépend de",
  "build.amendment.field.staffing": "Équipe",
  "build.amendment.field.staffing_source": "Équipe choisie par",
  "build.amendment.field.required_roles": "Rôles requis",
  "build.amendment.field.input.context": "Contexte",
  "build.amendment.field.input.consumes": "Consomme",
  "build.amendment.field.input.read": "À lire",
  "build.amendment.field.input.constraints": "Contraintes",
  "build.amendment.field.outputs": "Livrable → emplacement",
  "build.amendment.field.criteria": "Critère",
  "build.amendment.field.gates.evidence": "Preuve",
  "build.amendment.field.gates.validated_by": "Validé par",
  "build.amendment.field.why.criticality": "Pourquoi cette criticité",
  "build.amendment.field.why.staffing": "Pourquoi cette équipe",
  "champion.step.propose_plan_amendment": "propose un amendement du plan",
  "champion.step.list_plan_amendments": "consulte les amendements du plan",
  "workspace.tickets.title": "Tickets",
  "workspace.tickets.count_one": "{{count}} ticket",
  "workspace.tickets.count_other": "{{count}} tickets",
  "workspace.tickets.legend": "Légende",
  "workspace.tickets.listLabel": "Tickets de la mission",
  "workspace.tickets.empty": "Aucun ticket pour l'instant.",
  "workspace.tickets.unassigned": "non assigné",
  "workspace.tickets.since.now": "à l'instant",
  "workspace.tickets.composer.placeholder": "Écrire sur {{sid}}…",
  "workspace.tickets.composer.empty": "Aucun message sur ce ticket pour l'instant.",
  "workspace.tickets.composer.inputLabel": "Message sur {{sid}}",
  "mock.edit.title": "Modifier la maquette",
  "mock.edit.select": "Sélectionner un élément",
  "mock.edit.cancelSelect": "Annuler la sélection",
  "mock.edit.armedHint": "Cliquez l'élément à modifier. Clavier : Tab / Maj+Tab pour parcourir, flèche haut = parent, flèche bas = enfant, Entrée pour choisir, Échap pour annuler.",
  "mock.edit.noSelection": "Sélectionnez un élément de la maquette pour le modifier.",
  "mock.edit.selected": "Élément sélectionné : {{tag}}",
  "mock.edit.scriptElement": "Élément créé par le script de la maquette : il ne peut pas être modifié.",
  "mock.edit.commentThis": "Commenter cet élément",
  "mock.edit.generating": "Une génération est en cours — commentez plutôt.",
  "mock.edit.tooLarge": "Maquette trop grande pour l'édition : commentez plutôt.",
  "mock.edit.text": "Texte",
  "mock.edit.textHint": "Entrée applique, Maj+Entrée ajoute une ligne.",
  "mock.edit.editInPlace": "Modifier le texte sur la maquette",
  "mock.edit.inPlaceHint": "Tapez dans la maquette : Entrée valide, Maj+Entrée ajoute une ligne, Échap annule.",
  "mock.edit.inPlaceCancelled": "Modification du texte sur la maquette annulée (ou non disponible dans ce navigateur : utilisez le champ Texte).",
  "mock.edit.color": "Couleur du texte",
  "mock.edit.background": "Fond",
  "mock.edit.fontSize": "Taille de police",
  "mock.edit.unit": "Unité",
  "mock.edit.weight": "Graisse",
  "mock.edit.weights.normal": "Normale",
  "mock.edit.weights.bold": "Grasse",
  "mock.edit.font": "Police",
  "mock.edit.unchanged": "Inchangée",
  "mock.edit.fonts.system": "Système",
  "mock.edit.fonts.sans": "Sans empattement",
  "mock.edit.fonts.serif": "Avec empattement",
  "mock.edit.fonts.mono": "Chasse fixe",
  "mock.edit.fonts.rounded": "Arrondie",
  "mock.edit.align": "Alignement",
  "mock.edit.alignTo.left": "Gauche",
  "mock.edit.alignTo.center": "Centre",
  "mock.edit.alignTo.right": "Droite",
  "mock.edit.alignTo.justify": "Justifié",
  "mock.edit.margin": "Marges",
  "mock.edit.padding": "Espacements intérieurs",
  "mock.edit.linked": "Même valeur partout",
  "mock.edit.side.all": "Tous les côtés",
  "mock.edit.side.top": "Haut",
  "mock.edit.side.right": "Droite",
  "mock.edit.side.bottom": "Bas",
  "mock.edit.side.left": "Gauche",
  "mock.edit.gap": "Espacement",
  "mock.edit.radius": "Arrondi",
  "mock.edit.moveUp": "Monter",
  "mock.edit.moveDown": "Descendre",
  "mock.edit.remove": "Supprimer",
  "mock.edit.journalTitle": "Modifications en cours",
  "mock.edit.journal_one": "{{count}} modification (max {{max}})",
  "mock.edit.journal_other": "{{count}} modifications (max {{max}})",
  "mock.edit.removeOp": "Retirer : {{label}}",
  "mock.edit.dropRefused": "Retirer cette modification",
  "mock.edit.refusedRow": "Modification {{n}} refusée : retirez-la puis enregistrez de nouveau.",
  "mock.edit.bannerProtected": "Le bandeau « Maquette — données fictives » et ses conteneurs ne se modifient pas.",
  "mock.edit.undo": "Annuler",
  "mock.edit.undoAll": "Tout annuler",
  "mock.edit.save": "Enregistrer (0 $)",
  "mock.edit.saveValidated": "Enregistrer comme version validée (0 $)",
  "mock.edit.saving": "Enregistrement…",
  "mock.edit.saved": "Version {{revision}} enregistrée",
  "mock.edit.applied": "Modification appliquée",
  "mock.edit.undone": "Modification annulée",
  "mock.edit.undoneAll": "Toutes les modifications annulées",
  "mock.edit.op.setText": "Texte de <{{tag}}> : « {{text}} »",
  "mock.edit.op.setStyle": "{{prop}} de <{{tag}}> : {{value}}",
  "mock.edit.op.setAttr": "Attribut {{name}} de <{{tag}}>",
  "mock.edit.op.remove": "Suppression de <{{tag}}>",
  "mock.edit.op.moveUp": "<{{tag}}> monté",
  "mock.edit.op.moveDown": "<{{tag}}> descendu",
  "mock.edit.invalid.grammar": "Valeur non reconnue pour ce champ.",
  "mock.edit.invalid.range": "Valeur hors des limites permises.",
  "mock.edit.invalid.chars": "Caractère non permis dans cette valeur.",
  "mock.edit.invalid.length": "Valeur trop longue.",
  "mock.edit.invalid.prop": "Propriété non modifiable.",
  "mock.edit.invalid.element": "Cet attribut ne s'applique pas à cet élément.",
  "mock.edit.invalid.control": "Caractère de contrôle non permis.",
  "mock.edit.invalid.type": "Valeur invalide.",
  "mock.edit.invalid.invalid": "Valeur invalide.",
  "mock.edit.invalid.cap": "Trop de modifications : enregistrez d'abord.",
  "mock.edit.invalid.not_ready": "La maquette n'est pas encore prête.",
  "mock.edit.invalid.real_data": "Donnée réelle détectée ({{kind}}) : utilisez des données fictives.",
  "mock.edit.kind.email": "e-mail",
  "mock.edit.kind.phone": "téléphone",
  "mock.edit.kind.address": "adresse postale",
  "mock.edit.kind.card": "carte bancaire",
  "mock.edit.kind.iban": "IBAN",
  "mock.edit.kind.nir": "numéro de sécurité sociale",
  "mock.edit.kind.external_url": "lien vers un site externe",
  "mock.error.invalid_edit": "Modification refusée : elle sort de ce que l'éditeur permet.",
  "mock.error.edit_real_data": "Modification refusée : une donnée réelle a été détectée.",
  "mock.error.edit_base_stale": "La maquette a changé depuis l'ouverture : rechargez-la puis refaites vos modifications.",
  "mock.error.edit_cap": "Nombre maximal d'enregistrements atteint pour ce tour.",
  "mock.error.edit_rate": "Trop d'enregistrements en une heure : réessayez plus tard.",
  "mock.error.edit_target_unknown": "Un élément modifié n'existe plus dans la version enregistrée.",
  "mock.error.edit_target_mismatch": "Un élément modifié ne correspond plus à la version enregistrée.",
  "mock.error.edit_target_forbidden": "Cet élément ne peut pas être modifié ainsi.",
  "mock.error.edit_text_not_leaf": "Ce texte contient d'autres éléments : il ne peut pas être remplacé.",
  "mock.error.edit_move_edge": "Cet élément ne peut pas aller plus loin.",
  "mock.error.edit_value_invalid": "Une valeur sort de ce que l'éditeur permet.",
  "mock.error.edit_output_invalid": "La version modifiée ne passe pas les vérifications de la maquette (bandeau, liens…).",
  "mock.error.edit_too_large": "La version modifiée serait trop grande.",
  "mock.error.edit_not_stampable": "Maquette trop grande pour l'édition : commentez plutôt.",
  "mock.error.edit_apply_failed": "La modification n'a pas pu être appliquée. Réessayez.",
  "mock.error.edit_output_unstable": "Cette modification changerait la structure de la page : elle n'est pas enregistrée.",
  "mock.error.edit_target_banner": "Le bandeau « Maquette — données fictives » doit rester visible et en place : ce style ou ce déplacement est refusé.",
  "mock.error.edit_ops_too_large": "Trop de modifications en un seul enregistrement : enregistrez en plusieurs fois.",
  "mock.panel.tabs": "Outils de la maquette",
  "mock.panel.comment": "Commenter",
  "mock.panel.edit": "Modifier",
  "mock.comment.element": "Commenter un élément",
  "mock.comment.modeHint": "Chaque commentaire part tout de suite à Camille, sans décision sur la maquette.",
  "mock.comment.empty": "Aucun commentaire en cours. Pointez un élément ou entourez une zone de la maquette.",
  "mock.comment.send": "Envoyer le commentaire",
  "mock.comment.sending": "Envoi…",
  "mock.comment.sent": "Commentaire envoyé ({{ref}})",
  "mock.comment.sentTitle": "Envoyés",
  "mock.comment.duringGeneration": "Envoyé pendant la génération : pas pris en compte par ce tour.",
  "mock.comment.wake.queued": "Commentaire enregistré. Camille termine l'étape en cours, puis y répond.",
  "mock.comment.wake.held": "Commentaire enregistré. Camille y répondra à sa prochaine reprise.",
  "mock.comment.wake.unavailable": "Commentaire enregistré, mais Camille n'a pas pu être prévenue : relancez-la dans le chat.",
  "mock.comment.card.title": "Commentaire sur la maquette « {{mock}} » — tour {{round}}, {{ref}}",
  "mock.comment.card.shaping": "de cadrage",
  "mock.comment.card.unknown": "de l'étape",
  "mock.comment.card.by": "par {{name}} le {{date}}",
  "mock.comment.card.imageAlt": "Capture du commentaire {{ref}} (aperçu approximatif)",
  "mock.outcome.title": "Maquette validée : que faire de ce commentaire ?",
  "mock.outcome.reopenAction": "Rouvrir un tour",
  "mock.outcome.reopenWithCost": "Rouvrir un tour (≈ {{cost}})",
  "mock.outcome.reopenCost": "Un nouveau tour coûterait environ {{cost}}.",
  "mock.outcome.costUnknown": "coût inconnu",
  "mock.outcome.noteAction": "Note pour l'implémentation",
  "mock.outcome.later": "Plus tard",
  "mock.outcome.reopenNote": "La validation du tour {{round}} reste dans l'historique ; les stories UI déjà parties ne sont pas rappelées.",
  "mock.outcome.shapingStale": "Un plan soumis devra être revalidé.",
  "mock.outcome.none": "sans suite",
  "mock.outcome.reopen": "tour rouvert",
  "mock.outcome.note": "note pour l'implémentation",
  "mock.outcome.round": "pris en compte au tour suivant",
  "mock.history.comments_one": "{{count}} commentaire hors décision",
  "mock.history.comments_other": "{{count}} commentaires hors décision",
  "mock.history.commentBy": "par {{name}} le {{date}}",
  "mock.history.commentOutcomeBy": "issue décidée par {{name}} le {{date}}",
  "mock.history.commentImageAlt": "Capture du commentaire {{ref}} (aperçu approximatif)",
  "mock.history.edits_one": "{{count}} version modifiée par le POC",
  "mock.history.edits_other": "{{count}} versions modifiées par le POC",
  "mock.history.editBy_one": "Version modifiée par {{name}} le {{date}} — {{count}} modification",
  "mock.history.editBy_other": "Version modifiée par {{name}} le {{date}} — {{count}} modifications",
  "mock.history.editMore_one": "… et {{count}} autre modification",
  "mock.history.editMore_other": "… et {{count}} autres modifications",
  "mock.history.versionView": "Voir cette version",
  "mock.history.versionGenerated": "Voir la version générée",
  "mock.history.reopenedBy": "Tour rouvert par {{name}} le {{date}} — la validation reste acquise.",
  "mock.error.mock_closed": "Cette maquette est close : elle ne se commente plus.",
  "mock.error.round_not_found": "Ce tour de la maquette n'est pas consultable.",
  "mock.error.comment_rate": "Trop de commentaires en une heure sur cette mission : réessayez plus tard.",
  "mock.error.comments_cap": "Nombre maximal de commentaires atteint pour ce tour.",
  "mock.error.comment_busy": "Un autre commentaire vient d'être enregistré : réessayez.",
  "mock.error.comment_not_found": "Commentaire introuvable.",
  "mock.error.comment_outcome_set": "Ce commentaire a déjà une suite.",
  "mock.error.comment_round_stale": "Ce commentaire est d'un tour précédent : il ne peut pas rouvrir le tour validé. Gardez-le en note ou commentez à nouveau.",
  "mock.error.ui_mock_already_open": "Une autre maquette de cadrage est déjà ouverte : terminez-la avant de rouvrir celle-ci.",
  "mock.error.mock_stamp_invalid": "La maquette générée n'a pas pu être préparée pour l'édition : rien n'a été enregistré. Réessayez le même tour.",
  "mock.error.edit_store_failed": "La version modifiée n'a pas pu être enregistrée. Réessayez.",
  "mock.error.invalid_revision": "Cette version de la maquette n'existe pas.",
  "workspace.pane.close": "Fermer le panneau",
  "workspace.pane.dialogDescription": "Section de la mission, affichée par-dessus le chat. Fermez-la pour revenir au chat.",
  "mission.journey.stage.flow": "Parcours",
  "mission.journey.stage.now": "en cours : {{step}}",
  "mission.journey.stage.events_one": "{{count}} étape",
  "mission.journey.stage.events_other": "{{count}} étapes",
  "mission.journey.event.advance": "→ {{stage}}",
  "mission.journey.event.list": "Étapes — {{stage}}",
  "mission.journey.event.decisionPrefix": "Décision de Camille :",
  "mission.journey.event.decisionUntitled": "Décision",
  "mission.journey.fold": "Replier la frise",
  "mission.journey.unfold": "Déplier la frise",
  "mission.journey.noEvents": "Aucune décision pour le moment.",
  "workspace.tab.plan": "Plan",
  "workspace.dock.process": "Process de la mission"
}
